var _defs, _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M60,29.5c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.2L13.1,44H40V20.7l12.9-5.4l7,13.4 C59.9,29,60,29.3,60,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M60,29.5c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.2L13.1,44H40V20.7l12.9-5.4l7,13.4 C59.9,29,60,29.3,60,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M60,29.5c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.2L13.1,44H40V20.7l12.9-5.4l7,13.4 C59.9,29,60,29.3,60,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M60,29.5c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.2L13.1,44H40V20.7l12.9-5.4l7,13.4 C59.9,29,60,29.3,60,29.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 7.76897321,
    cy: 7.76897321,
    r: 7.76897321
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 15.5379464,
    height: 15.5379464,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 7.76897321,
    cy: 7.76897321,
    r: 7.76897321
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 15.5379464,
    height: 15.5379464,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M150,73.8c0,41.5-33.5,75-75,75c-10.2,0-20-2-28.8-5.5L32.8,110L55,70l45-18.2l32.2-13.5l17.5,33.5 C149.8,72.5,150,73.2,150,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M150,73.8c0,41.5-33.5,75-75,75c-10.2,0-20-2-28.8-5.5L32.8,110L55,70l45-18.2l32.2-13.5l17.5,33.5 C149.8,72.5,150,73.2,150,73.8z"
  }))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "adaptive-ip-hover",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("title", null, "cicons-86 copy 14a"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.93,
    y: 3.31,
    width: 23.88,
    height: 23.88,
    rx: 11.94,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-2",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.45,
    y: 13.45,
    width: 4.22,
    height: 4.22,
    rx: 2.11,
    fill: "#babcbe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.78,17.77a2.1,2.1,0,0,0-.84-1.68c0-.28,0-.55,0-.84a15.11,15.11,0,1,0-16.86,15,2.11,2.11,0,0,0,4.14-.1,15.14,15.14,0,0,0,12-10.37A2.11,2.11,0,0,0,31.78,17.77ZM18.18,29.15a2.09,2.09,0,0,0-4,.1,14.11,14.11,0,0,1-12.4-14h0A14.11,14.11,0,0,1,15.87,1.14h0A14.11,14.11,0,0,1,30,15.25h0c0,.15,0,.29,0,.44a2.85,2.85,0,0,0-.29,0,2.11,2.11,0,0,0-.46,4.17A14.11,14.11,0,0,1,18.18,29.15Z",
    fill: "#babcbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.67,12.7a5.07,5.07,0,0,0-4.88,3.77l-4.21-1.36a5.05,5.05,0,1,0-5.67,5.45l.43,4.26a5.09,5.09,0,1,0,1.5,0l-.43-4.26a5.05,5.05,0,0,0,4.09-3.88L24.62,18a5.06,5.06,0,1,0,5.05-5.3ZM19.75,29.8a3.57,3.57,0,1,1-3.57-3.57A3.57,3.57,0,0,1,19.75,29.8ZM15.56,19.13a3.57,3.57,0,1,1,3.57-3.57A3.57,3.57,0,0,1,15.56,19.13Zm14.11,2.21a3.57,3.57,0,1,1,3.57-3.57A3.57,3.57,0,0,1,29.67,21.34Z",
    fill: "#43c9f7"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "adaptive-ip",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("title", null, "cicons-86 copy 13a"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.87,1.14A14.11,14.11,0,0,1,30,15.25h0A14.11,14.11,0,0,1,15.87,29.36h0A14.11,14.11,0,0,1,1.76,15.25h0A14.11,14.11,0,0,1,15.87,1.14h0m0-1A15.11,15.11,0,1,0,31,15.25,15.13,15.13,0,0,0,15.87.14Z",
    fill: "#babcbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-2",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.93,
    y: 3.31,
    width: 23.88,
    height: 23.88,
    rx: 11.94,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-3",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.56,12A3.57,3.57,0,1,1,12,15.56,3.56,3.56,0,0,1,15.56,12m0-1.5a5.07,5.07,0,1,0,5.07,5.06,5.07,5.07,0,0,0-5.07-5.06Z",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 19.56,
    y1: 15.56,
    x2: 25.65,
    y2: 17.54,
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-4",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.67,14.2a3.57,3.57,0,1,1-3.57,3.57,3.57,3.57,0,0,1,3.57-3.57m0-1.5a5.07,5.07,0,1,0,5.07,5.07,5.08,5.08,0,0,0-5.07-5.07Z",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-5",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.18,26.23a3.57,3.57,0,1,1-3.56,3.57,3.57,3.57,0,0,1,3.56-3.57m0-1.5a5.07,5.07,0,1,0,5.07,5.07,5.07,5.07,0,0,0-5.07-5.07Z",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-6",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.45,
    y: 13.45,
    width: 4.22,
    height: 4.22,
    rx: 2.11,
    fill: "#babcbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-7",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.56,
    y: 15.66,
    width: 4.22,
    height: 4.22,
    rx: 2.11,
    fill: "#babcbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-8",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.07,
    y: 27.69,
    width: 4.22,
    height: 4.22,
    rx: 2.11,
    fill: "#babcbe"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 15.56,
    y1: 19.59,
    x2: 16.16,
    y2: 25.56,
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1.5
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "alarm",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M60,30c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.3C7.6,53.2,0,42.5,0,30C0,13.4,13.4,0,30,0 c16.3,0,29.6,13.1,30,29.3C60,29.5,60,29.8,60,30z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    clipPath: "url(#SVGID_2_)",
    fill: "#272425",
    points: "53.1,15.4 60,31 56.9,55 25.9,60 15,44 24.4,25.7 "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    d: "M60,29.5c0,16.6-13.4,30-30,30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 25,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M21,20v25h5V20H21z M25,24h-3v-3h3V24z M25,28h-3v-3h3V28z M25,32h-3v-3h3V32z M25,43h-3v-3h3V43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    cx: 37.1,
    cy: 23.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,13v9.7c0,1.1-0.9,2.3-2,2.3h-5l-5,4v-4h-6c-1.1,0-2-1.2-2-2.4v-9.5c0-1.1,0.9-2.1,2-2.1h16 C51.1,11,52,11.9,52,13z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "analytics-hover",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-608.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(608.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.6,
    x: 6.12315832,
    y: 18.0147059,
    width: 3.60294118,
    height: 7.20588235
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    x: 12.1280603,
    y: 19.2156863,
    width: 3.60294118,
    height: 6.00490196
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    x: 18.1329622,
    y: 15.6127451,
    width: 3.60294118,
    height: 9.7412854
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    x: 24.1378642,
    y: 19.2156863,
    width: 3.60294118,
    height: 6.00490196
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.4,
    x: 6.12315832,
    y: 25.2205882,
    width: 21.6176471,
    height: 1.20098039
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#009EEF",
    points: "29.2453669 12.0098039 23.4406284 18.7819989 17.6358898 14.3316993 11.8311512 17.6210512 6.12315832 16.2666122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.532472,34.8284314 C7.98908831,34.8284314 0.118256358,27.0559848 0.118256358,17.4142157 C0.118256358,7.77244655 7.89070291,0 17.532472,0 C27.1742412,0 34.9466877,7.77244655 34.9466877,17.4142157 C34.9466877,27.0559848 27.1742412,34.8284314 17.532472,34.8284314 Z M17.532472,1.96770799 C9.0713277,1.96770799 2.08596435,8.85468594 2.08596435,17.4142157 C2.08596435,25.9737454 8.9729423,32.8607234 17.532472,32.8607234 C26.0920018,32.8607234 32.9789797,25.9737454 32.9789797,17.4142157 C32.9789797,8.85468594 26.0920018,1.96770799 17.532472,1.96770799 Z",
    id: "Shape",
    fill: "#43C9F7",
    fillRule: "nonzero"
  })))))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "analytics",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-561.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(561.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.6,
    x: 6.12315832,
    y: 18.0147059,
    width: 3.60294118,
    height: 7.20588235
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    x: 12.1280603,
    y: 19.2156863,
    width: 3.60294118,
    height: 6.00490196
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    x: 18.1329622,
    y: 15.6127451,
    width: 3.60294118,
    height: 9.7412854
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    x: 24.1378642,
    y: 19.2156863,
    width: 3.60294118,
    height: 6.00490196
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.4,
    x: 6.12315832,
    y: 25.2205882,
    width: 21.6176471,
    height: 1.20098039
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#FFFFFF",
    points: "29.2453669 12.0098039 23.4406284 18.7819989 17.6358898 14.3316993 11.8311512 17.6210512 6.12315832 16.2666122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.532472,34.8284314 C7.98908831,34.8284314 0.118256358,27.0559848 0.118256358,17.4142157 C0.118256358,7.77244655 7.89070291,0 17.532472,0 C27.1742412,0 34.9466877,7.77244655 34.9466877,17.4142157 C34.9466877,27.0559848 27.1742412,34.8284314 17.532472,34.8284314 Z M17.532472,1.96770799 C9.0713277,1.96770799 2.08596435,8.85468594 2.08596435,17.4142157 C2.08596435,25.9737454 8.9729423,32.8607234 17.532472,32.8607234 C26.0920018,32.8607234 32.9789797,25.9737454 32.9789797,17.4142157 C32.9789797,8.85468594 26.0920018,1.96770799 17.532472,1.96770799 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7
  })))))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "application-hover",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-2",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-3",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-4",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2,27a1,1,0,0,1-1-1V19H13V18H1V10H19v3h1V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V26a2,2,0,0,0,2,2H13V27ZM1,2A1,1,0,0,1,2,1H18a1,1,0,0,1,1,1V9H1Z",
    fill: "#babcbe"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16 19 16 18 16 16 19 16 20 16 31 16 31 14 20 14 19 14 14 14 14 18 14 19 14 27 14 28 14 31 16 31 16 28 16 27 16 19",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31 17 20 17 19 17 17 17 17 18 17 19 17 27 17 28 17 31 17 32 17 34 34 34 34 17 32 17 31 17",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,16V13H13V32h3v3H35V16ZM16,31H14V14H31v2H16V31Zm18,3H17V17H34Z",
    fill: "#43c9f7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-23",
    x: 19,
    y: 22,
    width: 13,
    height: 10,
    fill: "#5a6671"
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "application",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-2",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-3",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-4",
    "data-name": "Rectangle-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#5a6671"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2,27a1,1,0,0,1-1-1V19H13V18H1V10H19v3h1V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V26a2,2,0,0,0,2,2H13V27ZM1,2A1,1,0,0,1,2,1H18a1,1,0,0,1,1,1V9H1Z",
    fill: "#babcbe"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "16 19 16 18 16 16 19 16 20 16 31 16 31 14 20 14 19 14 14 14 14 18 14 19 14 27 14 28 14 31 16 31 16 28 16 27 16 19",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31 17 20 17 19 17 17 17 17 18 17 19 17 27 17 28 17 31 17 32 17 34 34 34 34 17 32 17 31 17",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,16V13H13V32h3v3H35V16ZM16,31H14V14H31v2H16V31Zm18,3H17V17H34Z",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-23",
    x: 19,
    y: 22,
    width: 13,
    height: 10,
    fill: "#5a6671"
  })))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "audio-mute",
    viewBox: "0 0 21.726 21.414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audio-mute",
    transform: "translate(-0.622 -2.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M13,3,9.09,6.258,13,10.168Z",
    fill: "#0271bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M15,6.4v5.773l2.46,2.46A6.727,6.727,0,0,0,15,6.4Z",
    fill: "#0271bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M22.348,12A9.2,9.2,0,0,0,15,3V4.894A7.353,7.353,0,0,1,20.511,12a7.269,7.269,0,0,1-1.4,4.276L20.43,17.6A9.124,9.124,0,0,0,22.348,12Z",
    fill: "#0271bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M2.036,2.032h0L.622,3.446,5.176,8H2v8H7l6,5V15.824l2.951,2.95a7.374,7.374,0,0,1-.951.332V21a9.1,9.1,0,0,0,2.346-.83l3.276,3.276,1.414-1.414Z",
    fill: "#0271bc"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "big-data-cluster",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-20.000000, -912.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 912.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#4F7A97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,45 L5,45 C2.239,45 0,42.761 0,40 L0,5 C0,2.239 2.239,0 5,0 L40,0 C42.761,0 45,2.239 45,5 L45,40 C45,42.761 42.761,45 40,45 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40,45 C29.1663628,45 22.1330295,45 18.9,45 L11,33 L18,21 L34,13 L45,24.4210526 L45,40.0292398 C45,42.7740936 42.761,45 40,45 Z",
    id: "Shape",
    fillOpacity: 0.25,
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A9B5BE",
    cx: 15.2,
    cy: 29.2,
    r: 10.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 14.1,
    cy: 14.1,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 23,
    cy: 23,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 32.1,
    cy: 14.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.7,
    cx: 31.1,
    cy: 31.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.5,
    cx: 36.6,
    cy: 23.6,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 22.8,
    cy: 13.8,
    r: 7.8
  })))))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "dataset",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MCP-application-icons",
    transform: "translate(-21.000000, -3328.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(21.000000, 3328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.96,45 L5.04,45 C2.25,45 0,42.75 0,39.96 L0,5.04 C0.18,2.25 2.43,0 5.04,0 L39.96,0 C42.75,0 45,2.25 45,5.04 L45,40.05 C45,42.75 42.75,45 39.96,45 Z",
    id: "Shape",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#272425",
    opacity: 0.15,
    points: "36 37 36 9 45 15.48 45 40.05 44.91 41.4 44.82 41.76 44.37 42.57 44.01 43.29 43.11 44.01 41.94 44.55 40.41 45 17.46 45 9 37.8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    fill: "#B3E0E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.75757576 C0,0.790909091 0.790909091,0 1.75757576,0 L27.2424242,0 C28.2090909,0 29,0.790909091 29,1.75757576 L29,28.2090909 C29,29.1757576 28.2090909,29.9666667 27.2424242,29.9666667 L1.75757576,29.9666667 C0.790909091,29.9666667 0,29.1757576 0,28.2090909 L0,1.75757576 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    opacity: 0.3,
    x: 10,
    y: 20,
    width: 7,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.3,
    points: "10 26 17 26 17 31 10 31"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.75,
    x: 19,
    y: 32,
    width: 7,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.75,
    x: 28,
    y: 20,
    width: 7,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 19,
    y: 26,
    width: 7,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    opacity: 0.1,
    x: 19,
    y: 20,
    width: 7,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.5,
    points: "19 15 26 15 26 19 19 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.75,
    points: "10 15 17 15 17 19 10 19"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 10,
    y: 9.9,
    width: 7,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 28,
    y: 10,
    width: 7,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#7B7F7F",
    opacity: 0.25,
    x: 19,
    y: 10,
    width: 7,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    points: "28 32 35 32 35 36 28 36"
  }))))))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "domains",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "49.5,22.9 60,39 60,60 27.8,60 14.4,41 31.5,33.1 "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    cx: 30.5,
    cy: 28.5,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 37.5,
    cy: 31.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 23.5,
    cy: 22.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 20.5,
    cy: 35.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "19.2,37 21.8,23 12,23 12,21 24.2,21 21.8,34.4 36.9,30.8 49,22 49.8,23.4 37.7,32.7 37.6,32.7 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 38.8,
    y1: 11.8,
    x2: 37.6,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "3.1341,3.1341",
    x1: 35,
    y1: 14.5,
    x2: 26,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "24.7,21.6 23.5,22.5 24.8,23.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2.8419,2.8419",
    points: " 27.2,24.8 37.1,30.8 42.9,38.7  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 43.7,
    y1: 39.8,
    x2: 44.6,
    y2: 41
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: 3,
    x1: 36.3,
    y1: 33.1,
    x2: 23.5,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 34.5,
    transform: "matrix(0.7866 0.6175 -0.6175 0.7866 27.6634 -2.8879)",
    fill: "#FFFFFF",
    width: 2,
    height: 8.1
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "export",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    fillRule: "nonzero",
    fill: "#637582"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4444444,50 L5.55555556,50 C2.48777778,50 0,47.5122222 0,44.4444444 L0,5.55555556 C0,2.48777778 2.48777778,0 5.55555556,0 L44.4444444,0 C47.5122222,0 50,2.48777778 50,5.55555556 L50,44.4444444 C50,47.5122222 47.5122222,50 44.4444444,50 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    transform: "translate(11.000000, 12.000000)",
    fillOpacity: 0.25,
    fillRule: "nonzero",
    fill: "#414141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4444444,38 C21.4070698,38 13.592255,38 10,38 L6.53699317e-13,26 L28,26 L28.959512,1.05268894 L29,0 L39,15 L39,32.4444444 C39,35.5122222 36.5122222,38 33.4444444,38 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#E8E8E8",
    fillRule: "nonzero",
    points: "20.3 27 17.6 25 15.9 26.2 11 26.2 11 25.3 15.6 25.3 17.6 24 19.8 25.6 22.4 17 25.5 24.2 28.4 22.5 30.3 25.1 35.6 25.1 35.6 26 29.9 26 28.1 23.6 25.1 25.5 22.5 19.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,10.5 C12.1715729,10.5 11.5,11.1715729 11.5,12 L11.5,37 C11.5,37.8284271 12.1715729,38.5 13,38.5 L38,38.5 C38.8284271,38.5 39.5,37.8284271 39.5,37 L39.5,12 C39.5,11.1715729 38.8284271,10.5 38,10.5 L13,10.5 Z",
    id: "Rectangle-9",
    stroke: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5A6771",
    x: 39,
    y: 15,
    width: 1,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.000000, 16.000000)",
    fillRule: "nonzero",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(10.652130, 4.201625) rotate(-45.000000) translate(-10.652130, -4.201625) ",
    x: 9.79893301,
    y: -0.152851078,
    width: 1.70639435,
    height: 8.70895219
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(10.652554, 9.148368) rotate(45.000000) translate(-10.652554, -9.148368) ",
    x: 9.79935644,
    y: 4.79389152,
    width: 1.70639435,
    height: 8.70895219
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.832857143,
    y: 5.86785714,
    width: 11.5398036,
    height: 1.70641071
  })), /*#__PURE__*/React.createElement("text", {
    id: "LOG",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 11,
    fontWeight: "bold",
    fill: "#E8E8E8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 36
  }, "LOG")))))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "gr-connected",
    viewBox: "0 0 30 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u2705-MCP-93270---GR-status",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr-connected",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1176471,2 C11.5562261,2 11.9117647,2.36809057 11.9117647,2.82215329 L11.9117647,16.8061587 L8.93382353,16.8061587 L8.93382353,19.2726186 C8.9360115,21.2014461 10.4457695,22.7645048 12.3088235,22.7667701 L14.6911765,22.7667701 C16.5542305,22.7645048 18.0639885,21.2014461 18.0661765,19.2726186 L18.0661765,16.8061587 L15.0882353,16.8061587 L15.0882353,2.82215329 C15.0882353,2.36809057 15.4437739,2 15.8823529,2 L26.2058824,2 C26.6444614,2 27,2.36809057 27,2.82215329 L27,16.8061587 L24.0220588,16.8061587 L24.0220588,19.2726186 C24.0220588,21.8796667 21.9732353,24 19.4558824,24 L7.54411765,24 C5.02355781,23.9968289 2.98100409,21.8821646 2.97794118,19.2726186 L2.97794118,16.8061587 L0,16.8061587 L0,2.82215329 C0,2.36809057 0.355538581,2 0.794117647,2 L11.1176471,2 Z M22.8308824,16.8061587 L19.2573529,16.8061587 L19.2573529,19.2726186 C19.2567944,20.6048293 18.7111545,21.8744425 17.7556765,22.7667701 L19.4558824,22.7667701 C21.3189363,22.7645048 22.8286944,21.2014461 22.8308824,19.2726186 L22.8308824,16.8061587 L22.8308824,16.8061587 Z M7.74264706,16.8061587 L4.16911765,16.8061587 L4.16911765,19.2726186 C4.17130562,21.2014461 5.68106366,22.7645048 7.54411765,22.7667701 L9.24432353,22.7667701 C8.28884546,21.8744425 7.74320563,20.6048293 7.74264706,19.2726186 L7.74264706,16.8061587 L7.74264706,16.8061587 Z M25.8088235,12.2843156 L16.2794118,12.2843156 L16.2794118,15.5729287 L25.8088235,15.5729287 L25.8088235,12.2843156 Z M10.7205882,12.2843156 L1.19117647,12.2843156 L1.19117647,15.5729287 L10.7205882,15.5729287 L10.7205882,12.2843156 Z M2.77941176,13.1064689 C3.21799083,13.1064689 3.57352941,13.4745594 3.57352941,13.9286221 C3.57352941,14.3826849 3.21799083,14.7507754 2.77941176,14.7507754 C2.3408327,14.7507754 1.98529412,14.3826849 1.98529412,13.9286221 C1.98529412,13.4745594 2.3408327,13.1064689 2.77941176,13.1064689 Z M17.8676471,13.1064689 C18.3062261,13.1064689 18.6617647,13.4745594 18.6617647,13.9286221 C18.6617647,14.3826849 18.3062261,14.7507754 17.8676471,14.7507754 C17.429068,14.7507754 17.0735294,14.3826849 17.0735294,13.9286221 C17.0735294,13.4745594 17.429068,13.1064689 17.8676471,13.1064689 Z M25.8088235,7.76247244 L16.2794118,7.76247244 L16.2794118,11.0510856 L25.8088235,11.0510856 L25.8088235,7.76247244 Z M10.7205882,7.76247244 L1.19117647,7.76247244 L1.19117647,11.0510856 L10.7205882,11.0510856 L10.7205882,7.76247244 Z M2.77941176,8.58462573 C3.21799083,8.58462573 3.57352941,8.9527163 3.57352941,9.40677903 C3.57352941,9.86084175 3.21799083,10.2289323 2.77941176,10.2289323 C2.3408327,10.2289323 1.98529412,9.86084175 1.98529412,9.40677903 C1.98529412,8.9527163 2.3408327,8.58462573 2.77941176,8.58462573 Z M17.8676471,8.58462573 C18.3062261,8.58462573 18.6617647,8.9527163 18.6617647,9.40677903 C18.6617647,9.86084175 18.3062261,10.2289323 17.8676471,10.2289323 C17.429068,10.2289323 17.0735294,9.86084175 17.0735294,9.40677903 C17.0735294,8.9527163 17.429068,8.58462573 17.8676471,8.58462573 Z M25.8088235,3.23322994 L16.2794118,3.23322994 L16.2794118,6.52184312 L25.8088235,6.52184312 L25.8088235,3.23322994 Z M10.7205882,3.23322994 L1.19117647,3.23322994 L1.19117647,6.52184312 L10.7205882,6.52184312 L10.7205882,3.23322994 Z M2.77941176,4.06278262 C3.21799083,4.06278262 3.57352941,4.43087318 3.57352941,4.88493591 C3.57352941,5.33899864 3.21799083,5.7070892 2.77941176,5.7070892 C2.3408327,5.7070892 1.98529412,5.33899864 1.98529412,4.88493591 C1.98529412,4.43087318 2.3408327,4.06278262 2.77941176,4.06278262 Z M17.8676471,4.06278262 C18.3062261,4.06278262 18.6617647,4.43087318 18.6617647,4.88493591 C18.6617647,5.33899864 18.3062261,5.7070892 17.8676471,5.7070892 C17.429068,5.7070892 17.0735294,5.33899864 17.0735294,4.88493591 C17.0735294,4.43087318 17.429068,4.06278262 17.8676471,4.06278262 Z",
    id: "Shape",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6666667,10 L28.3333333,10 C29.2538079,10 30,9.25380792 30,8.33333333 L30,1.66666667 C30,0.746192084 29.2538079,0 28.3333333,0 L21.6666667,0 C20.7461921,0 20,0.746192084 20,1.66666667 L20,8.33333333 C20,9.25380792 20.7461921,10 21.6666667,10 Z",
    id: "Path",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,9 L28.2,9 C28.6418278,9 29,8.6418278 29,8.2 L29,1.8 C29,1.3581722 28.6418278,1 28.2,1 L21.8,1 C21.3581722,1 21,1.3581722 21,1.8 L21,8.2 C21,8.6418278 21.3581722,9 21.8,9 Z",
    id: "Path",
    fill: "#00AA3E"
  }))))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "gr-notconnected",
    viewBox: "0 0 30 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u2705-MCP-93270---GR-status",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gr-notconnected",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1176471,2 C11.5562261,2 11.9117647,2.36809057 11.9117647,2.82215329 L11.9117647,16.8061587 L8.93382353,16.8061587 L8.93382353,19.2726186 C8.9360115,21.2014461 10.4457695,22.7645048 12.3088235,22.7667701 L14.6911765,22.7667701 C16.5542305,22.7645048 18.0639885,21.2014461 18.0661765,19.2726186 L18.0661765,16.8061587 L15.0882353,16.8061587 L15.0882353,2.82215329 C15.0882353,2.36809057 15.4437739,2 15.8823529,2 L26.2058824,2 C26.6444614,2 27,2.36809057 27,2.82215329 L27,16.8061587 L24.0220588,16.8061587 L24.0220588,19.2726186 C24.0220588,21.8796667 21.9732353,24 19.4558824,24 L7.54411765,24 C5.02355781,23.9968289 2.98100409,21.8821646 2.97794118,19.2726186 L2.97794118,16.8061587 L0,16.8061587 L0,2.82215329 C0,2.36809057 0.355538581,2 0.794117647,2 L11.1176471,2 Z M22.8308824,16.8061587 L19.2573529,16.8061587 L19.2573529,19.2726186 C19.2567944,20.6048293 18.7111545,21.8744425 17.7556765,22.7667701 L19.4558824,22.7667701 C21.3189363,22.7645048 22.8286944,21.2014461 22.8308824,19.2726186 L22.8308824,16.8061587 L22.8308824,16.8061587 Z M7.74264706,16.8061587 L4.16911765,16.8061587 L4.16911765,19.2726186 C4.17130562,21.2014461 5.68106366,22.7645048 7.54411765,22.7667701 L9.24432353,22.7667701 C8.28884546,21.8744425 7.74320563,20.6048293 7.74264706,19.2726186 L7.74264706,16.8061587 L7.74264706,16.8061587 Z M25.8088235,12.2843156 L16.2794118,12.2843156 L16.2794118,15.5729287 L25.8088235,15.5729287 L25.8088235,12.2843156 Z M10.7205882,12.2843156 L1.19117647,12.2843156 L1.19117647,15.5729287 L10.7205882,15.5729287 L10.7205882,12.2843156 Z M2.77941176,13.1064689 C3.21799083,13.1064689 3.57352941,13.4745594 3.57352941,13.9286221 C3.57352941,14.3826849 3.21799083,14.7507754 2.77941176,14.7507754 C2.3408327,14.7507754 1.98529412,14.3826849 1.98529412,13.9286221 C1.98529412,13.4745594 2.3408327,13.1064689 2.77941176,13.1064689 Z M17.8676471,13.1064689 C18.3062261,13.1064689 18.6617647,13.4745594 18.6617647,13.9286221 C18.6617647,14.3826849 18.3062261,14.7507754 17.8676471,14.7507754 C17.429068,14.7507754 17.0735294,14.3826849 17.0735294,13.9286221 C17.0735294,13.4745594 17.429068,13.1064689 17.8676471,13.1064689 Z M25.8088235,7.76247244 L16.2794118,7.76247244 L16.2794118,11.0510856 L25.8088235,11.0510856 L25.8088235,7.76247244 Z M10.7205882,7.76247244 L1.19117647,7.76247244 L1.19117647,11.0510856 L10.7205882,11.0510856 L10.7205882,7.76247244 Z M2.77941176,8.58462573 C3.21799083,8.58462573 3.57352941,8.9527163 3.57352941,9.40677903 C3.57352941,9.86084175 3.21799083,10.2289323 2.77941176,10.2289323 C2.3408327,10.2289323 1.98529412,9.86084175 1.98529412,9.40677903 C1.98529412,8.9527163 2.3408327,8.58462573 2.77941176,8.58462573 Z M17.8676471,8.58462573 C18.3062261,8.58462573 18.6617647,8.9527163 18.6617647,9.40677903 C18.6617647,9.86084175 18.3062261,10.2289323 17.8676471,10.2289323 C17.429068,10.2289323 17.0735294,9.86084175 17.0735294,9.40677903 C17.0735294,8.9527163 17.429068,8.58462573 17.8676471,8.58462573 Z M25.8088235,3.23322994 L16.2794118,3.23322994 L16.2794118,6.52184312 L25.8088235,6.52184312 L25.8088235,3.23322994 Z M10.7205882,3.23322994 L1.19117647,3.23322994 L1.19117647,6.52184312 L10.7205882,6.52184312 L10.7205882,3.23322994 Z M2.77941176,4.06278262 C3.21799083,4.06278262 3.57352941,4.43087318 3.57352941,4.88493591 C3.57352941,5.33899864 3.21799083,5.7070892 2.77941176,5.7070892 C2.3408327,5.7070892 1.98529412,5.33899864 1.98529412,4.88493591 C1.98529412,4.43087318 2.3408327,4.06278262 2.77941176,4.06278262 Z M17.8676471,4.06278262 C18.3062261,4.06278262 18.6617647,4.43087318 18.6617647,4.88493591 C18.6617647,5.33899864 18.3062261,5.7070892 17.8676471,5.7070892 C17.429068,5.7070892 17.0735294,5.33899864 17.0735294,4.88493591 C17.0735294,4.43087318 17.429068,4.06278262 17.8676471,4.06278262 Z",
    id: "Shape",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6666667,10 L28.3333333,10 C29.2538079,10 30,9.25380792 30,8.33333333 L30,1.66666667 C30,0.746192084 29.2538079,0 28.3333333,0 L21.6666667,0 C20.7461921,0 20,0.746192084 20,1.66666667 L20,8.33333333 C20,9.25380792 20.7461921,10 21.6666667,10 Z",
    id: "Path",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,9 L28.2,9 C28.6418278,9 29,8.6418278 29,8.2 L29,1.8 C29,1.3581722 28.6418278,1 28.2,1 L21.8,1 C21.3581722,1 21,1.3581722 21,1.8 L21,8.2 C21,8.6418278 21.3581722,9 21.8,9 Z",
    id: "Path",
    fill: "#E52C2C"
  }))))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "hadoop-file-system",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-21.000000, -974.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(21.000000, 974.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I_project",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4081633,45 L4.59183673,45 C2.17863105,45 1.39888101e-14,42.75 1.39888101e-14,40.4081633 L1.39888101e-14,4.59183673 C1.39888101e-14,2.175 2.25375626,0 4.59183673,0 L40.4081633,0 C42.8213689,0 45,2.25 45,4.59183673 L45,40.4081633 C45,42.75 42.8213689,45 40.4081633,45 Z",
    id: "Shape",
    fill: "#4F7A97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0204082,36.7346939 L11.0204082,6.42857143 L29.3877551,6.42857143 L34.8979592,13.7755102 L34.8979592,36.7346939 L11.0204082,36.7346939 Z M11.9387755,35.8163265 L33.9795918,35.8163265 L33.9795918,14.6938776 L28.4693878,14.6938776 L28.4693878,7.34693878 L11.9387755,7.34693878 L11.9387755,35.8163265 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#272425",
    opacity: 0.15,
    points: "34.8979592 13.7755102 45 26.6326531 45 40.4081633 45 41.3265306 44.0816327 42.244898 44.0816327 43.1632653 43.1632653 44.0816327 42.244898 45 40.4081633 45 19.2857143 45 11.0204082 36.7346939 34.8979592 36.7346939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(16.000000, 17.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#4B6B81",
    strokeLinejoin: "round",
    points: "0 2.83446712 0 11.3378685 6.88932981 15.5895692 14.4675926 11.3378685 14.4675926 2.83446712 6.88932981 6.37755102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88932981,6.37755102 L6.88932981,15.5895692",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 2.83446712 6.88932981 0 14.4675926 2.83446712"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.46590909,4.67989042 L3.46590909,13.5830966",
    id: "Path-11"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,21.5 L26.5,18.5",
    id: "Path-5",
    stroke: "#FFFFFF"
  }))))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "hadoop-sql",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-21.000000, -1033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(21.000000, 1033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I_project",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4081633,45 L4.59183673,45 C2.17863105,45 1.39888101e-14,42.75 1.39888101e-14,40.4081633 L1.39888101e-14,4.59183673 C1.39888101e-14,2.175 2.25375626,0 4.59183673,0 L40.4081633,0 C42.8213689,0 45,2.25 45,4.59183673 L45,40.4081633 C45,42.75 42.8213689,45 40.4081633,45 Z",
    id: "Shape",
    fill: "#4F7A97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0204082,36.7346939 L11.0204082,6.42857143 L29.3877551,6.42857143 L34.8979592,13.7755102 L34.8979592,36.7346939 L11.0204082,36.7346939 Z M11.9387755,35.8163265 L33.9795918,35.8163265 L33.9795918,14.6938776 L28.4693878,14.6938776 L28.4693878,7.34693878 L11.9387755,7.34693878 L11.9387755,35.8163265 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#272425",
    opacity: 0.15,
    points: "34.8979592 13.7755102 45 26.6326531 45 40.4081633 45 41.3265306 44.0816327 42.244898 44.0816327 43.1632653 43.1632653 44.0816327 42.244898 45 40.4081633 45 19.2857143 45 11.0204082 36.7346939 34.8979592 36.7346939"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(16.000000, 17.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#4B6B81",
    strokeLinejoin: "round",
    points: "0 2.83446712 0 11.3378685 6.88932981 15.5895692 14.4675926 11.3378685 14.4675926 2.83446712 6.88932981 6.37755102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88932981,6.37755102 L6.88932981,15.5895692",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0 2.83446712 6.88932981 0 14.4675926 2.83446712"
  })))))))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "help",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("title", null, "bArtboard 1"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,1.5A13.5,13.5,0,1,1,1.5,15,13.444,13.444,0,0,1,15,1.5M15,0A15,15,0,1,0,30,15,14.98,14.98,0,0,0,15,0Z",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4,18.2a7.267,7.267,0,0,1,.4-2.5,4.887,4.887,0,0,1,1.4-1.8,4.708,4.708,0,0,0,1.3-1.5,2.663,2.663,0,0,0,.3-1.2c0-1.3-.6-1.9-1.7-1.9a1.9,1.9,0,0,0-1.3.5,2.389,2.389,0,0,0-.5,1.4H10a3.772,3.772,0,0,1,1.4-3.3,5.331,5.331,0,0,1,3.7-1.2,5.572,5.572,0,0,1,3.7,1.1A3.894,3.894,0,0,1,20.1,11a3.922,3.922,0,0,1-.4,1.8,8.961,8.961,0,0,1-1.5,1.9l-.9.9a3.521,3.521,0,0,0-1,1.9v.7ZM13,21.6a1.656,1.656,0,0,1,.5-1.2,2.1,2.1,0,0,1,2.6,0,1.633,1.633,0,0,1,0,2.4,2.1,2.1,0,0,1-2.6,0,1.656,1.656,0,0,1-.5-1.2Z",
    fill: "#e2e2e2"
  })))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/accounts",
    viewBox: "-25 -5 50 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M19.4,45h-38.8c-3.1,0-5.6-2.5-5.6-5.6V0.6c0-3.1,2.5-5.6,5.6-5.6h38.8C22.5-5,25-2.5,25,0.6v38.9 C24.9,42.5,22.4,45,19.4,45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "3.6,4.8 24.9,22.2 24.9,40.1 24.7,41 24.5,41.4 24.1,42.3 23.6,43.1 22.8,43.9 21.5,44.5 19.7,45 -6.1,45 -17.7,33.6 0.2,33.3 1,28.4 3.9,23.7 2.7,21.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M-0.8,3.9L-0.8,3.9c-3.8,0-6.8,3.1-6.8,6.8c0,0.6,0.1,1.1,0.2,1.6c-0.2,0.1-0.3,0.2-0.5,0.4 c-0.3,0.3-0.5,0.7-0.5,1.2l0.2,1.4c0,0.9,0.6,1.7,1.5,1.7h0.1c0.3,1.9,0.8,4,2.4,4.8c0,0-0.6,2.1-0.6,2.2c-0.9,0.1-0.3,0-0.4,0 c-5.2,0.2-9.2,3.8-9.2,3.8c-1.6,1.5-2.3,3.7-2.5,5.7c-1.7,0,33.8,0,32.2,0c-0.2-1.9-0.9-4.2-2.5-5.7c0,0-4-3.7-9.2-3.8 c-0.1,0,0.5,0-0.4,0c0-0.1-0.6-2.2-0.6-2.2C4.2,21,4.7,18.9,5,17h0.1c0.9,0,1.5-0.7,1.5-1.7l0.2-1.4c0-0.5-0.2-0.9-0.5-1.2 c-0.1-0.1-0.3-0.3-0.5-0.3c0-0.6,0.1-1.1,0.1-1.7C5.9,7,2.9,3.9-0.8,3.9L-0.8,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M15.3,34H-17v-0.5l-0.4-0.1c0.3-2.6,1.2-4.6,2.7-6c0.2-0.2,4.1-3.8,9.5-4l0,0c0.1-0.2,0.2-0.7,0.4-1.4 c-1.4-1-1.9-2.8-2.2-4.6c-1-0.2-1.6-1-1.6-2.1l-0.2-1.4c0-0.6,0.2-1.2,0.6-1.6c0.1,0,0.2-0.1,0.3-0.2C-8,11.6-8,11.2-8,10.7 c0-4,3.2-7.2,7.2-7.3l0,0h0.1c4,0,7.2,3.3,7.2,7.3c0,0.5,0,0.9-0.1,1.4c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.4,0.6,0.9,0.6,1.5L7,15.3 c0,1.1-0.7,1.9-1.6,2c-0.3,1.9-0.9,3.6-2.3,4.6c0.2,0.8,0.4,1.2,0.4,1.5l0,0c5.4,0.2,9.4,3.8,9.5,4c1.5,1.3,2.4,3.4,2.7,6 l-0.4,0.1V34z M-16.4,33h31.1c-0.3-2.1-1.1-3.8-2.3-4.9c0,0-3.7-3.4-8.6-3.7H3.6H3.5l-1-0.1l0.1-0.4c-0.1-0.2-0.3-1.2-0.6-2.1 l-0.1-0.3l0.4-0.2c1.5-0.8,1.9-2.7,2.2-4.5l0.1-0.4h0.3c0.8,0,1.1-0.6,1.1-1.2l0.2-1.5c0-0.2-0.1-0.5-0.4-0.8 c-0.1-0.1-0.2-0.2-0.4-0.2L5,12.5l0.1-0.4c0.1-0.5,0.2-1,0.2-1.5c0-3.5-2.8-6.3-6.2-6.3h-0.1l0,0h0c-3.4,0-6.2,2.9-6.2,6.3 c0,0.5,0.1,1,0.2,1.5l0.1,0.4l-0.4,0.3c-0.1,0-0.2,0.1-0.3,0.2c-0.3,0.2-0.4,0.5-0.4,0.9l0.2,1.4c0,0.7,0.3,1.2,1,1.2h0.4 l0.1,0.4c0.3,1.8,0.7,3.7,2.2,4.5l0.4,0.2L-3.7,22c-0.3,0.7-0.6,1.7-0.6,2l0.1,0.4l-1,0.1h-0.1h-0.3c-4.8,0.3-8.5,3.7-8.5,3.7 C-15.3,29.3-16,30.9-16.4,33z"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/alarm",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M60,30c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.3C7.6,53.2,0,42.5,0,30C0,13.4,13.4,0,30,0 c16.3,0,29.6,13.1,30,29.3C60,29.5,60,29.8,60,30z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    clipPath: "url(#SVGID_2_)",
    fill: "#272425",
    points: "53.1,15.4 60,31 56.9,55 25.9,60 15,44 24.4,25.7 "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    d: "M60,29.5c0,16.6-13.4,30-30,30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 25,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M21,20v25h5V20H21z M25,24h-3v-3h3V24z M25,28h-3v-3h3V28z M25,32h-3v-3h3V32z M25,43h-3v-3h3V43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 3,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    cx: 37.1,
    cy: 23.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,13v9.7c0,1.1-0.9,2.3-2,2.3h-5l-5,4v-4h-6c-1.1,0-2-1.2-2-2.4v-9.5c0-1.1,0.9-2.1,2-2.1h16 C51.1,11,52,11.9,52,13z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/capacity-map",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M135,150H15c-8.4,0-15-6.6-15-15V15C0,6.6,6.6,0,15,0h120c8.4,0,15,6.6,15,15v120 C150,143.4,143.4,150,135,150z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M150,92v43.2c0,8.4-6.6,15-15,15H53.1L21.3,97.4L54,114.2l3,3 l36-21h3l36,21V61.7L150,92z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "21.3,44 21.3,97.4 54,114.2 54,60.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "96,45.2 96,96.2 132,117.2 132,61.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    points: "93,45.2 93,96.2 57,117.2 57,60.2  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M129,56.6c-4.2,7.2-12,12-21,12c-13.5,0-24.6-11.1-24.6-24.6c0-13.2,10.5-24.3,24-24.6v22.8L129,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFA",
    d: "M132.6,44c0,3.6-0.6,6.9-2.1,9.9l-4.4-3.7c0.9-2.1,0.5-3.5,0.5-6.2c0-10.2-8.4-18.6-18.6-18.6 c-0.3,0-0.3,0-0.6,0v-6c0.3,0,0.3,0,0.6,0C121.5,19.4,132.6,30.5,132.6,44z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/equipment-alarm",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M60,30c0,16.6-13.4,30-30,30c-4.1,0-8-0.8-11.5-2.3C7.6,53.2,0,42.5,0,30C0,13.4,13.4,0,30,0 c16.3,0,29.6,13.1,30,29.3C60,29.5,60,29.8,60,30z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    clipPath: "url(#SVGID_2_)",
    fill: "#272425",
    enableBackground: "new    ",
    points: "53.1,15.4 65,38.6 56.9,55 24.4,61.8 13.1,43.9 24.4,25.7  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    d: "M60,29.5c0,16.6-13.4,30-30,30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 20.6,
    opacity: 0.3,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    width: 27.3,
    height: 22.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M19.4,18.3v27.3h5.5V18.3H19.4z M23.9,22.7h-3.5V19h3.5V22.7z M23.9,27.5h-3.6v-3.7h3.6V27.5z  M23.9,32.3h-3.6v-3.7h3.6V32.3z M23.9,44.2h-3.6v-3.7h3.6V44.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 22.8,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 4.1,
    height: 18.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 22.8,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 4.1,
    height: 18.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 22.8,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 4.1,
    height: 18.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.7,
    y: 22.8,
    opacity: 0.2,
    fill: "#F1F1F1",
    enableBackground: "new    ",
    width: 4.1,
    height: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49,28H37c-2.2,0-4-1.8-4-4v-7c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v7C53,26.2,51.2,28,49,28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#009999",
    points: "42.8,26.6 40.3,22.3 39.7,24.2 33.3,24.2 33.3,22.2 38.2,22.2 39.8,17.4 42.7,22.4 44.1,19.6 45.5,21.8 50.2,21.7 50.2,23.7 44.4,23.8 44.3,23.6  "
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/equipment-browser",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "47,16 60,31 60,60 18.6,60 11.5,48 47,48 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 35,
    height: 32.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M20,14v35h7V14H20z M26,20h-5v-5h5V20z M26,26h-5v-5h5V26z M26,32h-5v-5h5V32z M26,47h-5v-5h5V47z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 5,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 5,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 23,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 5,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23,
    opacity: 0.2,
    fill: "#F1F1F1",
    width: 5,
    height: 23
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    fill: "#F1F1F1",
    cx: 43,
    cy: 19,
    r: 2
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/event",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M150,75c0,41.4-33.6,75-75,75c-10.2,0-19.8-2.1-28.8-5.7C19.2,132.9,0,106.2,0,75C0,33.6,33.6,0,75,0 c40.8,0,74.1,32.7,75,73.2C150,73.8,150,74.4,150,75z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M148.2,91.5c-7.5,32.7-36,57.3-70.5,58.5h-5.4l-40.8-42l36-59 l41.1-1.3L148.2,91.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65A8A6",
    cx: 59.5,
    cy: 93.5,
    r: 30.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B4D8D7",
    cx: 54.8,
    cy: 49,
    r: 18.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9AD6D4",
    cx: 83,
    cy: 75,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B2E0E0",
    cx: 109,
    cy: 47.7,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 107.8,
    cy: 99.5,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 122,
    cy: 78.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 83,
    cy: 47.7,
    r: 23.5
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/fiber-map",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "10,18 10,38 23,46 23,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38,18 38,39 50,46 50,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "37,18 37,39 24,46 24,24  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 38,
    cy: 17.6,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M30.4,20.5c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S31.5,20.5,30.4,20.5z M30.4,17.5 c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S30.9,17.5,30.4,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M37.4,27.8l-1-0.1c0,0,0.5-4.8-1.6-7.1c-0.7-0.8-1.9-1.2-2.9-1.2v-1c1,0,2.7,0.5,3.6,1.5 C37.9,22.5,37.4,27.6,37.4,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M45.8,20.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S46.9,20.5,45.8,20.5z M45.8,17.5c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S46.3,17.5,45.8,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M38.7,27.8c0-0.2-0.6-5.3,1.7-7.9c0.9-1,2.5-1.5,3.5-1.5v1c-1,0-2.1,0.4-2.8,1.2c-2,2.3-1.5,7-1.5,7.1 L38.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M42.6,16.1c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S43.7,16.1,42.6,16.1z M42.6,13.1c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S43.2,13.1,42.6,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M37.9,27.8c0-1.2-0.3-12.1,3.6-13.1l0.2,1c-2.3,0.6-3,7.8-2.8,12.1L37.9,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M33.5,16.1c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S34.6,16.1,33.5,16.1z M33.5,13.1c-0.6,0-1,0.4-1,1 s0.4,1,1,1s1-0.4,1-1S34.1,13.1,33.5,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M38.2,27.8l-1,0c0.2-4.4-0.5-11.5-2.8-12.1l0.2-1C38.5,15.6,38.3,26.5,38.2,27.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "50,24 60,36 60,60 24.1,60 10,38 24,46 38,38 50,46 "
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/link-browser",
    viewBox: "0 0 70 60"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "17.7,59.9 0.4,29.9 17.7,0 52.3,0 69.6,29.9 52.3,59.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "53.2,17.2 21.8,16.5 13.9,40.2 29.5,59.9 51.6,60 64.8,38.2 "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    d: "M30.6,45.4l-6.5-1.8l-12.2-2.2l5.8-15h10.1l12.4,0.4L30.6,45.4z M16,39.1l8.8,1.6l4.2,1.2 l6.3-12.2l-7.6-0.3l-8,0L16,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    d: "M30.2,45.1l0-3L42.5,42l-6.8-13.5l21-0.3L51.5,45h-6.6L30.2,45.1z M45.8,42h3.5l3.3-10.7 l-12.1,0.1L45.8,42z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#F1F1F1",
    d: "M25.5,42.6l-2.9-0.7l2.9-12.6h-8.9l4.1-14.5L44.6,18l-16,10.8L25.5,42.6z M20.5,26.4h6.3 l9.5-6.4l-13.5-1.8L20.5,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#272425",
    d: "M56.6,31.5l-21.3-0.3l7.3-16.5l12,1.2L56.6,31.5z M39.9,28.2l13.3,0.2l-1.3-9.9l-7.4-0.7 L39.9,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57,29.9l-22.7-0.3L42.1,12l12.7,1.2L57,29.9z M40.4,25.7l12,0.2l-1.2-8.9l-6.7-0.6L40.4,25.7z"
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/logging",
    viewBox: "482 370 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M535.3,430h-46.6c-3.7,0-6.7-3-6.7-6.7v-46.6c0.2-3.7,3.2-6.7,6.7-6.7h46.6c3.7,0,6.7,3,6.7,6.7v46.7 C542,427,539,430,535.3,430z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "528.1,415.3 528.2,383 542,400 542,424.1 541.8,425.2 541.6,425.7 541.1,426.8 540.5,427.7 539.4,428.7 537.8,429.4 535.8,430 513.1,430 495.9,415.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M859.3,824.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M526.2,382.2h-28.4c-1.7,0-3,1.3-3,3v9.7h1v-9.7c0-1.1,0.9-2,2-2h28.4c1.1,0,2,0.9,2,2v28.1c0,1.1-0.9,2-2,2 h-28.4c-1.1,0-2-0.9-2-2v-15.9h-1v15.9c0,1.6,1.3,3,3,3h28.4c1.7,0,3-1.4,3-3v-28.1C529.2,383.6,527.9,382.2,526.2,382.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M503.2,410.9h3.7v1.4h-5.5v-8.5h1.8V410.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M514.6,408.2c0,0.7-0.1,1.2-0.3,1.8c-0.2,0.5-0.4,1-0.7,1.3s-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.5,0.3 s-1-0.1-1.5-0.3s-0.8-0.5-1.2-0.8s-0.6-0.8-0.8-1.3s-0.3-1.1-0.3-1.8v-0.4c0-0.6,0.1-1.2,0.3-1.8s0.4-1,0.7-1.3s0.7-0.6,1.1-0.8 s0.9-0.3,1.5-0.3s1,0.1,1.5,0.3c0.4,0.2,0.8,0.5,1.1,0.8s0.6,0.8,0.7,1.3s0.3,1.1,0.3,1.8V408.2z M512.8,407.8c0-0.9-0.2-1.6-0.5-2 c-0.3-0.5-0.8-0.7-1.4-0.7s-1.1,0.2-1.4,0.7s-0.5,1.1-0.5,2v0.4c0,0.4,0,0.8,0.1,1.2s0.2,0.6,0.4,0.9s0.4,0.4,0.6,0.5 s0.5,0.2,0.8,0.2c0.6,0,1-0.2,1.4-0.7c0.3-0.5,0.5-1.2,0.5-2V407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M522.6,411.2c-0.1,0.1-0.2,0.3-0.4,0.4s-0.4,0.3-0.7,0.4s-0.6,0.2-0.9,0.3s-0.8,0.1-1.2,0.1 c-0.6,0-1.1-0.1-1.5-0.3s-0.8-0.4-1.2-0.8s-0.6-0.8-0.8-1.3s-0.3-1.1-0.3-1.8v-0.5c0-0.7,0.1-1.2,0.3-1.8s0.4-0.9,0.7-1.3 s0.7-0.6,1.1-0.8s0.9-0.3,1.5-0.3c0.6,0,1,0.1,1.4,0.2s0.7,0.3,1,0.6s0.5,0.5,0.6,0.9s0.3,0.7,0.3,1.1h-1.7c0-0.2-0.1-0.4-0.2-0.6 s-0.2-0.3-0.3-0.4s-0.3-0.2-0.5-0.3s-0.4-0.1-0.7-0.1c-0.6,0-1.1,0.2-1.4,0.7s-0.5,1.1-0.5,2v0.5c0,0.9,0.2,1.6,0.5,2 s0.8,0.7,1.5,0.7c0.2,0,0.4,0,0.6,0s0.3-0.1,0.4-0.1s0.2-0.1,0.3-0.1s0.1-0.1,0.2-0.1v-1.5h-1.6v-1.3h3.4V411.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "506,399.5 502.8,397.1 500.7,398.5 495.4,398.5 495.4,397.5 500.4,397.5 502.8,395.9 505.4,397.8 508.5,387.5 512.2,396.2 515.7,394.1 518,397.2 524.4,397.2 524.4,398.3 517.5,398.3 515.4,395.4 511.8,397.7 508.6,390.4 "
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/metrics",
    viewBox: "-10 -10 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.3,50H-3.3C-7,50-10,47-10,43.3V-3.3C-9.8-7-6.8-10-3.3-10h46.6C47-10,50-7,50-3.3v46.7 C50,47,47,50,43.3,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "33.5,32.5 37.2,21.8 36.2,8.6 50,22.6 50,44.1 49.8,45.2 49.6,45.7 49.1,46.8 48.5,47.7 47.4,48.7 45.8,49.4 43.8,50 23.5,50 5.9,33.9 21,38.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M46.8,52.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M20,3c9.4,0,17,7.6,17,17s-7.6,17-17,17S3,29.4,3,20S10.6,3,20,3 M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20 S31,0,20,0L20,0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20,3c9.4,0,17,7.6,17,17s-7.6,17-17,17S3,29.4,3,20S10.6,3,20,3 M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20 S31,0,20,0L20,0z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.2,
    y1: 17.8,
    x2: 29.2,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 20,
    y1: 9.7,
    x2: 20,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 30.7,
    y1: 20,
    x2: 33.8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 6.3,
    y1: 20,
    x2: 9.5,
    y2: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20,18.2c1,0,1.8,0.8,1.8,1.8S21,21.8,20,21.8S18.2,21,18.2,20S19,18.2,20,18.2 M20,16.2 c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S22.1,16.2,20,16.2L20,16.2z"
  })))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/monitoring",
    viewBox: "-10 -10 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.3,50H-3.3C-7,50-10,47-10,43.3V-3.3C-9.8-7-6.8-10-3.3-10h46.6C47-10,50-7,50-3.3v46.7 C50,47,47,50,43.3,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "36.2,28.8 36.2,5.2 50,22.6 50,44.1 49.8,45.2 49.6,45.7 49.1,46.8 48.5,47.7 47.4,48.7 45.8,49.4 43.8,50 23.5,50 3.9,28.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M34.2,6c0.8,0,1.5,0.7,1.5,1.6v19.2c0,0.9-0.7,1.6-1.5,1.6H5.8c-0.8,0-1.5-0.7-1.5-1.6V7.6 C4.3,6.7,4.9,6,5.8,6H34.2 M34.2,4.4H5.8c-1.7,0-3,1.4-3,3.2v19.2c0,1.8,1.3,3.2,3,3.2h28.4c1.7,0,3-1.4,3-3.2V7.6 C37.2,5.8,35.9,4.4,34.2,4.4L34.2,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M31,34.5c0,0.8-0.7,1.5-1.5,1.5H10c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h4.5v-1.6H25V33h4.5 C30.3,33,31,33.6,31,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M46.8,52.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 16.5,
    fill: "#637582",
    width: 4.9,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 2,
    transform: "matrix(0.9912 0.1322 -0.1322 0.9912 0.7234 -2.0746)",
    fill: "#637582",
    width: 3,
    height: 4.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E8E8",
    points: "14.9,23.4 12.4,20 11.2,18.8 9.4,20.5 2.8,20.5 2.8,18.5 8.6,18.5 11.2,16 13.7,18.6 17.1,-0.1 21.5,16.2 24.7,13.2 27.6,18.5 33.1,18.5 33.1,20.5 26.4,20.5 24.2,16.4 20.4,19.9 17.5,9 "
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/ne-browser",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    opacity: 0.5,
    fill: "#F1F1F1",
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24,
    opacity: 0.4,
    fill: "#FFFFFF",
    width: 5,
    height: 21
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 42,
    cy: 18.8,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "47,12.6 60,28.1 60,60 18.6,60 11.5,48 47,48 "
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/onep-export",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "appbar_icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4,50 L5.6,50 C2.4,50 0,47.6 0,44.4 L0,5.6 C0,2.4 2.6,0 5.6,0 L44.6,0 C47.6,0 50,2.6 50,5.6 L50,44.6 C50,47.6 47.6,50 44.4,50",
    id: "Page-1",
    fill: "#637582"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fillOpacity: 0.15,
    fill: "#272425",
    points: "38.2 16 49.4 27.6 49.4 45.4 49.2 46.4 49 46.8 48.6 47.6 48.2 48.4 47.2 49.4 46 50 44.2 50.4 25 50 14 38 38.2 40.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    strokeOpacity: 0.658344656,
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    fill: "#637582",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.285714, 5.714286)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3.35955598,
    height: 3.35955598
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 4.03073768,
    y: 0,
    width: 3.35955598,
    height: 3.35955598
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 8.06147536,
    y: 0,
    width: 3.35955598,
    height: 3.35955598
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "5.71021171 4.03073768 8.06147536 6.04610652 3.35894807 6.04610652"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 L12,39.4 L38.6,39.4 L38.6,14.4 L31.6,6 L12,6 Z M13.2,7.4 L31,7.4 L31,15 L37.6,15 L37.6,38.4 L13.2,38.4 L13.2,7.4 Z",
    id: "Page-1",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.000000, 19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "10.8613443 -0.00025 9.057125 1.80417847 18.2541808 10.99975 20.057125 9.19787196"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "8.92575 16.5088058 10.7286942 18.31175 19.92575 9.11469424 18.1228058 7.31175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "0 11 17 11 17 8 0 8"
  }))))))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/onep-import",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "appbar_icon-copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4,50 L5.6,50 C2.4,50 0,47.6 0,44.4 L0,5.6 C0,2.4 2.6,0 5.6,0 L44.6,0 C47.6,0 50,2.6 50,5.6 L50,44.6 C50,47.6 47.6,50 44.4,50",
    id: "Page-1",
    fill: "#637582"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fillOpacity: 0.15,
    fill: "#272425",
    points: "38.2 16 49.4 27.6 49.4 45.4 49.2 46.4 49 46.8 48.6 47.6 48.2 48.4 47.2 49.4 46 50 44.2 50.4 25 50 14 38 38.2 40.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    strokeOpacity: 0.658344656,
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    fill: "#637582",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.285714, 5.714286)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 3.35955598,
    height: 3.35955598
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 4.03073768,
    y: 0,
    width: 3.35955598,
    height: 3.35955598
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 8.06147536,
    y: 0,
    width: 3.35955598,
    height: 3.35955598
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "5.71021171 4.03073768 8.06147536 6.04610652 3.35894807 6.04610652"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 L12,39.4 L38.6,39.4 L38.6,14.4 L31.6,6 L12,6 Z M13.2,7.4 L31,7.4 L31,15 L37.6,15 L37.6,38.4 L13.2,38.4 L13.2,7.4 Z",
    id: "Page-1",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "10.8613443 -0.00025 9.057125 1.80417847 18.2541808 10.99975 20.057125 9.19787196"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "8.92575 16.5088058 10.7286942 18.31175 19.92575 9.11469424 18.1228058 7.31175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "0 11 17 11 17 8 0 8"
  }))))))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/pm-browser",
    viewBox: "0 0 150 150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009999",
    d: "M150,75c0,41.5-33.5,75-75,75c-10.2,0-20-2-28.8-5.8C19,133,0,106.2,0,75C0,33.5,33.5,0,75,0 c40.8,0,74,32.8,75,73.2C150,73.8,150,74.5,150,75z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fill: "#272425",
    enableBackground: "new    ",
    d: "M148.2,91.1c-7.5,32.7-36,57.3-70.5,58.5h-5.4L34.1,110 l18.8-58.8l55.8-3.9L148.2,91.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    d: "M150,73.8c0,41.5-33.5,75-75,75"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F2",
    cx: 53.5,
    cy: 59.8,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F2",
    cx: 43,
    cy: 104.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F2",
    cx: 101.2,
    cy: 88,
    r: 10.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F1F1F2",
    points: "35.2,110 49,58.8 56.2,60.8 46,99.2 100.2,84.2 102.2,91.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.2,
    y: 57.5,
    transform: "matrix(-0.8418 -0.5398 0.5398 -0.8418 67.6393 142.4169)",
    fill: "#F1F1F2",
    width: 5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F2",
    d: "M83.5,84.2l-7.2-4.8l4-6.2l7.2,4.8L83.5,84.2z M69.2,75L62,70.2l4-6.2l7.2,4.8L69.2,75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 83.3,
    transform: "matrix(-0.8417 -0.54 0.54 -0.8417 127.9744 211.5808)",
    fill: "#F1F1F2",
    width: 5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.2,39.2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122.5,70h-30c-5.5,0-10-4.5-10-10V42.5c0-5.5,4.5-10,10-10h30c5.5,0,10,4.5,10,10V60 C132.5,65.5,128,70,122.5,70z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#009999",
    points: "107,66.5 100.8,55.8 99.2,60.5 83.2,60.5 83.2,55.5 95.5,55.5 99.5,43.5 106.8,56 110.2,49 113.8,54.5 125.5,54.2 125.5,59.2 111,59.5 110.8,59 "
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/serviceBrowser",
    viewBox: "0 0 70 60"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "17.7,59.9 0.4,29.9 17.7,0 52.3,0 69.6,29.9 52.3,59.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "43.6,14 15.8,33.9 29.9,60.1 52.1,60.3 62.1,42.3 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#F1F1F1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: "39.2,18.4 20.1,30.7 46.4,45.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 40.1,
    y1: 18.7,
    x2: 40.5,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "4.4356,4.4356",
    x1: 41.4,
    y1: 25,
    x2: 44.8,
    y2: 40.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 45.2,
    y1: 42.3,
    x2: 45.7,
    y2: 44.3
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 26,
    fill: "#FFFFFF",
    width: 7.8,
    height: 7.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.25,
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWJJREFUeNq0lX9LwzAQhhObzlYr bMM/VBDE7/+txKk4dDK31dpZ34z34DwzBTGBh/5Kn1zSu9S735vfc3/4y0teHX8SD/sG8XukkQOD bh+Gwcp9QiqiUhGUPIp68K7QA3wTi7QAI1CDY3AEDjmAo+gNrMEKbEAHtlpu17KgpAFjMAUTcMLB HCVL8AyewAK8crCtLEtQEcv0a0rPwQU443XNfhvK7hmEM9HGcxfMMpSc/pTSa3AJTo14ziVyjLTl THoZIJgsKPnChJFG6VVC3PB8zej1cux8dinidcU1HVMoVOzX8hhFD+xbmcxxIZEVQWWFUCmxM89G Sup1lFlaMCUqyd9xLYVW9WvNsy8fLSUWacs8XfDrN2r6Oivm7LPkOyLftSKxPwRVygWj6FhlMtgM 3JA7FspKlfdQJDYfXZE9U0gq7ZHSW0pnvPdio85W0tk3oazbZtaNPuuv6V9+pp8CDABTiJuZ9ZTX iwAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 29 7)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 39.8,
    cy: 17,
    r: 4.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.25,
    width: 22,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAYAAAAP6L+eAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAc9JREFUeNqsldlOwzAQReMsdC9L RQsPLOL//woEpYillFLaNAljdIymxt0kIh3FiZPrseeObaLdLuM9V/v+EOoza4SrTYOYDe9i2rFq O6ESXPvPACYg6sQSIRUy7jHfWKGlR+nNYkVYi1qxmtAQmkIdcdufC3PhU5jRtu8KLe4LJ4hawa5w BF0GMghNhLHwJrwzyEKL6wTFRNVA7FQ4gx6R2+tLeBVGwpC7fZ7qyFMvYi18LlwLl0JfaPOdnf6z 0GGGBdG6iH/WO1EOSFjLQ6K8Em7gQhgIJwjW+G/BQFNm4hL5mxCdNLe+PcQGRNziuxlBuMgf+SdT zon0UrioD1jPNtF1aDdVghe8bzHLTHnd+MKRVxDOxwnESlj3xaHqTL0yLUnAkqjmKjEZP+vCKELF ERIuEPvAp9ZGL4gWROj6JyppuT9AEqi6lHXOvITkFIId8Em4F+6EB54nzGzFbv4u5tpuX5gTnRa9 RXjoFUjpV55RXrYuOMZmfazXZTY5ZTzCasHKMwFHJBRAE7EuRdOkb6mWZLxtrwiJux2uTgEc0Feq ittpd4vWJDJVnjXKPfkmy5ktx5I+RYwSrvY9QTade9GaA7WK/uEyu374LcAA+yWqXdEfl7QAAAAA SUVORK5CYII=",
    transform: "matrix(1 0 0 1 34 33)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 45.1,
    cy: 43.4,
    r: 4.7
  })))))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/swagger",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.018,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#8d6ccf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.594 13.948 7.513 20.028 13.594 26.109 14.442 25.261 9.209 20.028 14.442 14.796 13.594 13.948",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.442 13.948 25.594 14.796 30.826 20.028 25.594 25.261 26.442 26.109 32.523 20.028 26.442 13.948",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.189,
    y: 19.4,
    width: 13.6,
    height: 1.199,
    transform: "translate(-7.061 28.236) rotate(-61.949)",
    fill: "#fff"
  }))))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/topology",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "10,18 10,38 23,46 23,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38,18 38,39 50,46 50,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "37,18 37,39 24,46 24,24  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 35.1,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 26,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30.4,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30.1,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 35,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 27.6,
    transform: "matrix(0.5978 0.8016 -0.8016 0.5978 29.6551 -2.8385)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 31.6,
    transform: "matrix(0.948 0.3183 -0.3183 0.948 12.1999 -4.2819)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 33.8,
    transform: "matrix(0.26 0.9656 -0.9656 0.26 52.4599 6.7993)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 30.8,
    transform: "matrix(0.6808 0.7325 -0.7325 0.6808 34.006 -9.4806)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 33.8,
    transform: "matrix(0.7258 0.6879 -0.6879 0.7258 32.6047 -13.2272)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 6.8,
    height: 1
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 35.4,
    y1: 36.6,
    x2: 40.5,
    y2: 31.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 34.8,
    transform: "matrix(0.6343 0.7731 -0.7731 0.6343 43.0651 -20.5179)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 8.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 27.7,
    transform: "matrix(0.2201 0.9755 -0.9755 0.2201 58.4711 -16.6737)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 7.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 23.6,
    transform: "matrix(0.5529 0.8333 -0.8333 0.5529 37.972 -19.4299)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 25.8,
    transform: "matrix(0.7206 0.6933 -0.6933 0.7206 29.5731 -14.5623)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 27.8,
    transform: "matrix(0.8991 0.4377 -0.4377 0.8991 14.6553 -7.0654)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 17.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "50,24 60,36 60,60 24.1,60 10,38 24,46 38,38 50,46 "
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/transition-arrow",
    viewBox: "0 0 25 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "21.4,16.8 25,20.1 3.6,40 0,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25,19.9 21.4,23.2 0,3.3 3.6,0  "
  })))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "icons/launch/user-security-settings",
    viewBox: "-25 -5 50 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M19.5,45h-38.9c-3.1,0-5.6-2.5-5.6-5.6V0.6c0-3.1,2.5-5.6,5.6-5.6h38.9C22.5-5,25-2.5,25,0.6v38.9 C25,42.5,22.5,45,19.5,45z"
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "2.8,21.6 11.3,8.3 25,22.2 25,40.1 24.8,41 24.6,41.4 24.2,42.3 23.7,43.1 22.9,43.9 21.6,44.5 19.8,45 2.8,45 -11.7,27.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M-0.8,5.2l12.1,3.1v16.6c0,0-1,6-12.1,11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M-0.8,5.2l-12.1,3.1v16.6c0,0,1,6,12.1,11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 19.2,
    fill: "#5A6974",
    width: 12.4,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A6974",
    d: "M-0.4,24.3h-1.1c-2.3,0-4.2-1.9-4.2-4.2v-3.7c0-2.3,1.9-4.2,4.2-4.2h1.1c2.3,0,4.2,1.9,4.2,4.2v3.7 C3.8,22.5,1.9,24.3-0.4,24.3z M-1.4,14.3c-1.2,0-2.1,0.9-2.1,2.1v3.7c0,1.2,0.9,2.1,2.1,2.1h1.1c1.2,0,2.1-0.9,2.1-2.1v-3.7 c0-1.2-0.9-2.1-2.1-2.1H-1.4z"
  })))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "library",
    viewBox: "0 84 260 260"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M238.3,344H21.7C9.5,344,0,334.5,0,322.3V105.7C0,93.5,9.5,84,21.7,84h216.7c12.1,0,21.7,9.5,21.7,21.7 v216.7C260,334.5,250.5,344,238.3,344z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "217.5,170.2 260,240 260,344 104.4,344 42.5,279.2 112.5,279.2 112.5,289.2 147.5,289.2 147.5,279.2 217.5,279.2 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-75.9,123.1C-75.8,123.1-75.8,123.1-75.9,123.1L-75.9,123.1L-75.9,123.1z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M214.5,170c1.6,0,3,1.4,3,3v103c0,1.7-1.4,3-3,3h-64c-1.6,0-3,1.4-3,3v4c0,1.6-1.4,3-3,3h-29 c-1.7,0-3-1.4-3-3v-4c0-1.6-1.3-3-3-3h-64c-1.7,0-3-1.3-3-3V173c0-1.6,1.3-3,3-3H214.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M212,167.9c0,0-17-13.1-38-12.9c-15.8,0.2-35.9,4-42,16.7V275c0,0,25.7-28.2,80-10.4 C212,230.2,212,167.9,212,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49,167.9c0,0,17-13.1,38-12.9c15.8,0.2,35.9,4,42,16.7V275c0,0-25.7-28.2-80-10.4 C49,230.2,49,167.9,49,167.9z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "logging",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-18.000000, -1093.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(18.000000, 1093.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#4F7A97",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,45 L5,45 C2.239,45 0,42.761 0,40 L0,5 C0,2.239 2.239,0 5,0 L40,0 C42.761,0 45,2.239 45,5 L45,40 C45,42.761 42.761,45 40,45 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40,45 C29.1663628,45 22.1330295,45 18.9,45 L11,34.0643275 L35.1,34.2631579 L35.9635608,11.9418796 L36,11 L45,24.4210526 L45,40.0292398 C45,42.7740936 42.761,45 40,45 Z",
    id: "Shape",
    fillOpacity: 0.25,
    fill: "#414141",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    transform: "translate(11.000000, 11.000000)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#E8E8E8",
    fillRule: "nonzero",
    points: "18.3170732 24 15.902439 22.2 14.3821138 23.28 10 23.28 10 22.47 14.1138211 22.47 15.902439 21.3 17.8699187 22.74 20.195122 15 22.9674797 21.48 25.5609756 19.95 27.2601626 22.29 32 22.29 32 23.1 26.902439 23.1 25.2926829 20.94 22.6097561 22.65 20.2845528 17.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 L10.5,33 C10.5,33.8284271 11.1715729,34.5 12,34.5 L34,34.5 C34.8284271,34.5 35.5,33.8284271 35.5,33 L35.5,11 C35.5,10.1715729 34.8284271,9.5 34,9.5 L12,9.5 Z",
    id: "Rectangle-9",
    stroke: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0800781,31.90625 L19.2636719,31.90625 L19.2636719,33 L14.6542969,33 L14.6542969,25.890625 L16.0800781,25.890625 L16.0800781,31.90625 Z M25.8408203,30.0849609 C25.8408203,30.9606164 25.565758,31.6824516 25.015625,32.2504883 C24.465492,32.818525 23.7493534,33.1025391 22.8671875,33.1025391 C21.9882769,33.1025391 21.2753934,32.8177112 20.7285156,32.2480469 C20.1816379,31.6783826 19.9082031,30.9573611 19.9082031,30.0849609 L19.9082031,28.8056641 C19.9082031,27.9365191 20.1808241,27.2163115 20.7260742,26.6450195 C21.2713243,26.0737276 21.9817665,25.7880859 22.8574219,25.7880859 C23.7395877,25.7880859 24.457354,26.0737276 25.0107422,26.6450195 C25.5641304,27.2163115 25.8408203,27.9365191 25.8408203,28.8056641 L25.8408203,30.0849609 Z M24.4199219,28.7958984 C24.4199219,28.2425103 24.2815769,27.7884132 24.0048828,27.4335938 C23.7281887,27.0787743 23.3457056,26.9013672 22.8574219,26.9013672 C22.3756486,26.9013672 22.0004896,27.0787743 21.7319336,27.4335938 C21.4633776,27.7884132 21.3291016,28.2425103 21.3291016,28.7958984 L21.3291016,30.0849609 C21.3291016,30.6481148 21.4641914,31.1070946 21.734375,31.4619141 C22.0045586,31.8167335 22.382159,31.9941406 22.8671875,31.9941406 C23.3554712,31.9941406 23.7363268,31.8167335 24.0097656,31.4619141 C24.2832045,31.1070946 24.4199219,30.6481148 24.4199219,30.0849609 L24.4199219,28.7958984 Z M32.4179688,32.0283203 C32.1966135,32.3180353 31.8662131,32.5694976 31.4267578,32.7827148 C30.9873025,32.9959321 30.4209019,33.1025391 29.7275391,33.1025391 C28.8681598,33.1025391 28.1650418,32.8323595 27.6181641,32.2919922 C27.0712863,31.7516249 26.7978516,31.0501345 26.7978516,30.1875 L26.7978516,28.703125 C26.7978516,27.8437457 27.0631484,27.1430691 27.59375,26.6010742 C28.1243516,26.0590793 28.8063109,25.7880859 29.6396484,25.7880859 C30.5087934,25.7880859 31.1744769,25.9939758 31.6367188,26.4057617 C32.0989606,26.8175476 32.3219402,27.3668585 32.3056641,28.0537109 L32.2958984,28.0830078 L30.953125,28.0830078 C30.953125,27.7054018 30.8440766,27.4116221 30.6259766,27.2016602 C30.4078765,26.9916982 30.0904969,26.8867188 29.6738281,26.8867188 C29.237628,26.8867188 28.886069,27.0551741 28.6191406,27.3920898 C28.3522122,27.7290056 28.21875,28.1627578 28.21875,28.6933594 L28.21875,30.1875 C28.21875,30.7246121 28.3554674,31.1624332 28.6289062,31.5009766 C28.9023451,31.8395199 29.2685524,32.0087891 29.7275391,32.0087891 C30.0660824,32.0087891 30.3338206,31.9746097 30.5307617,31.90625 C30.7277028,31.8378903 30.8798823,31.7516281 30.9873047,31.6474609 L30.9873047,30.2705078 L29.6201172,30.2705078 L29.6201172,29.2841797 L32.4179688,29.2841797 L32.4179688,32.0283203 Z",
    id: "LOG",
    fill: "#E8E8E8"
  }))))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "maintenance",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5H55c2.8,0,5,2.2,5,5v50C60,57.8,57.7,60,55,60z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 12.6,
    opacity: 0.4,
    fill: "#F1F1F1",
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 23.2,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 5.2,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 23.2,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 5.2,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 23.2,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 5.2,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 23.2,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 5.2,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3,
    y: 23.2,
    opacity: 0.3,
    fill: "#FFFFFF",
    width: 5.2,
    height: 21.4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    fill: "#FFFFFF",
    cx: 41.5,
    cy: 17.9,
    r: 2.2
  })), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "47,12.6 60,28.1 60,60 17.6,60 11.5,47.9 47,47.6 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M49.9,45.6c0.6-1.3,1.7-2.1,3-2.2c0.1-0.9,0.2-1.8,0.1-2.7c-0.3-0.1-0.6-0.1-0.9-0.3c-1.9-0.8-2.7-3-1.9-4.9 c0.1-0.3,0.3-0.6,0.5-0.8c-0.5-0.7-1.1-1.3-1.7-1.9c-1,0.8-2.5,1-3.8,0.5c-1.3-0.6-2.1-1.8-2.2-3.2l0,0c-0.8-0.1-1.7-0.1-2.5,0 c0,0.3-0.1,0.7-0.3,1c-0.8,1.9-3,2.8-4.9,1.9c-0.3-0.1-0.6-0.3-0.9-0.5c-0.8,0.6-1.5,1.3-2.1,2.1c0.6,1,0.8,2.3,0.2,3.5 c-0.5,1.1-1.5,1.9-2.6,2.1C30,41,29.9,41.8,30,42.6c0.3,0,0.7,0.1,1,0.3c1.9,0.8,2.7,3,1.9,4.9c-0.1,0.3-0.3,0.6-0.6,0.9 c0.5,0.6,1,1.2,1.6,1.8c1-0.8,2.5-1.1,3.8-0.5c1.3,0.6,2.1,1.8,2.2,3.2c0.9,0.1,1.8,0.1,2.6,0c0-0.3,0.1-0.6,0.3-1 c0.8-1.9,3-2.8,4.9-1.9c0.3,0.1,0.5,0.3,0.8,0.5c0.6-0.5,1.1-1,1.6-1.5C49.5,48.2,49.3,46.9,49.9,45.6z M38.6,48.3 c-3.6-1.6-5.3-5.9-3.7-9.6c1.6-3.7,5.9-5.3,9.5-3.7c3.6,1.6,5.3,5.9,3.7,9.6C46.5,48.2,42.2,49.9,38.6,48.3z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Active_alarms",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.288,27.364l-.359-.2c-.861-.478-2.265-1.848-2.265-2.315V15.14a5.644,5.644,0,0,0-4.556-5.576A1.952,1.952,0,0,0,21.211,8H18.754a1.96,1.96,0,0,0-1.9,1.586A5.646,5.646,0,0,0,12.3,15.161l0,9.684a4.52,4.52,0,0,1-2.17,2.208l-.425.181V28.91h6.605a3.745,3.745,0,0,0,7.375,0h6.608Zm-4.166.147H11.979A4.519,4.519,0,0,0,13.7,24.873V15.161a4.22,4.22,0,0,1,3.86-4.255l.653-.044V10a.588.588,0,0,1,.542-.6H21.21a.56.56,0,0,1,.541.578v.863l.653.044a4.218,4.218,0,0,1,3.861,4.256v9.71c0,.928.952,1.95,1.79,2.661Z",
    fill: "#fff"
  })))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Active_sessions",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.694,29.364a7.4,7.4,0,0,1,.818,2.036H7.473a6.454,6.454,0,0,1,1.773-3.57,12.28,12.28,0,0,1,6.909-2.951H16.2a.552.552,0,0,0,.092,0l.366-.022a.6.6,0,0,0,.562-.542c.036-.177.261-.983.465-1.688a.6.6,0,0,0-.3-.7c-1.059-.544-1.415-1.956-1.713-3.479a.6.6,0,0,0-.589-.485c-.442,0-.6-.4-.6-.747a.525.525,0,0,0-.006-.079l-.148-1.1a.745.745,0,0,1,.223-.49.815.815,0,0,1,.233-.16.6.6,0,0,0,.327-.686A4.922,4.922,0,0,1,19.8,8.6h.14a4.922,4.922,0,0,1,4.684,6.1.6.6,0,0,0,.328.686.845.845,0,0,1,.234.161.761.761,0,0,1,.227.444l-.159,1.226c0,.019,0,.044,0,.07a6.941,6.941,0,0,1,1.23-.245l.127-.971A1.926,1.926,0,0,0,26.03,14.7a1.494,1.494,0,0,0-.157-.14A6.122,6.122,0,0,0,19.941,7.4h-.155a6.113,6.113,0,0,0-6.014,6.111,6.239,6.239,0,0,0,.088,1.043,1.882,1.882,0,0,0-.155.14,1.925,1.925,0,0,0-.575,1.372.525.525,0,0,0,.006.079l.149,1.11a1.849,1.849,0,0,0,1.293,1.836,5.818,5.818,0,0,0,1.832,3.635c-.123.429-.208.733-.266.953A13.287,13.287,0,0,0,8.431,26.95a7.832,7.832,0,0,0-2.254,4.977.6.6,0,0,0,.6.673H33.227a.6.6,0,0,0,.6-.673,8.509,8.509,0,0,0-1.256-3.436A7.058,7.058,0,0,1,31.694,29.364Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4,24a5.8,5.8,0,1,0,5.8-5.8A5.807,5.807,0,0,0,21.4,24Zm10.4,0a4.6,4.6,0,1,1-4.6-4.6A4.605,4.605,0,0,1,31.8,24Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6,24.6h2.333a.6.6,0,0,0,0-1.2H27.8v-2a.6.6,0,1,0-1.2,0Z",
    fill: "#fff"
  }))))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Alarm_history",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.776,27.165a6.462,6.462,0,0,1-2.229-2.19c-.166.012-.331.025-.5.025a6.726,6.726,0,0,1-.926-.072,4.493,4.493,0,0,0,1.78,2.583H10.826a4.519,4.519,0,0,0,1.719-2.638V15.161a4.221,4.221,0,0,1,3.86-4.256l.653-.044V10a.588.588,0,0,1,.542-.6h2.457a.56.56,0,0,1,.541.578v.863l.653.044a4.052,4.052,0,0,1,2.667,1.273,6.57,6.57,0,0,1,1.542-.327,5.523,5.523,0,0,0-3.505-2.266A1.952,1.952,0,0,0,20.058,8H17.6a1.958,1.958,0,0,0-1.9,1.586,5.645,5.645,0,0,0-4.555,5.575v9.684a4.521,4.521,0,0,1-2.169,2.208l-.425.181V28.91h6.6a3.745,3.745,0,0,0,7.375,0h6.608l-.006-1.546Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.047,13a5.4,5.4,0,1,0,5.4,5.4A5.406,5.406,0,0,0,26.047,13Zm0,9.6a4.2,4.2,0,1,1,4.2-4.2A4.2,4.2,0,0,1,26.047,22.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.647,17.8h-1V16a.6.6,0,1,0-1.2,0v3h2.2a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }))))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_API",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.018,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.594 13.948 7.513 20.028 13.594 26.109 14.442 25.261 9.209 20.028 14.442 14.796 13.594 13.948",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.442 13.948 25.594 14.796 30.826 20.028 25.594 25.261 26.442 26.109 32.523 20.028 26.442 13.948",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.189,
    y: 19.4,
    width: 13.6,
    height: 1.199,
    transform: "translate(-7.061 28.236) rotate(-61.949)",
    fill: "#fff"
  }))))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Audit_logs",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.063,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.737,7.2h-14.4a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8h19.2a.8.8,0,0,0,.8-.8V13.6Zm4.4,24.4h-18.4V8.4h13.2v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.537,21h-2.8a.6.6,0,1,0,0,1.2h2.8a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,21h-3a.6.6,0,0,0,0,1.2h3a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.937,21h-2.2a.6.6,0,1,0,0,1.2h2.2a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.537,24.2h-2.8a.6.6,0,0,0,0,1.2h2.8a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,24.2h-3a.6.6,0,0,0,0,1.2h3a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.937,24.2h-2.2a.6.6,0,0,0,0,1.2h2.2a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.537,27.4h-2.8a.6.6,0,0,0,0,1.2h2.8a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,27.4h-3a.6.6,0,1,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.937,27.4h-2.2a.6.6,0,0,0,0,1.2h2.2a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.137,18.4a.6.6,0,0,0,.6.6h2.8a.6.6,0,0,0,0-1.2h-2.8A.6.6,0,0,0,23.137,18.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,17.8h-3a.6.6,0,0,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.937,17.8h-2.2a.6.6,0,0,0,0,1.2h2.2a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,14.6h-3a.6.6,0,0,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }))))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Cable_systems",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11.9,
    width: 4,
    height: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 24.7,
    width: 4,
    height: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6,23.5V14.7a4.6,4.6,0,0,0-9.2,0V25.1a3.4,3.4,0,1,1-6.8,0v-8h2.6V10.7H8.8v6.4h2.6v8a4.6,4.6,0,0,0,9.2,0V14.7a3.4,3.4,0,0,1,6.8,0v8.8H24.8v6.4h6.4V23.5ZM10,15.9v-4h4v4ZM30,28.7H26v-4h4Z",
    fill: "#fff"
  }))))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Configuration",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.015,10.993a1.614,1.614,0,0,0-.432.432A1.614,1.614,0,0,1,28.015,10.993Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.436,11.7c0,.007,0,.016-.007.023h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.805,10.993a1.6,1.6,0,0,0-1.79,0,1.6,1.6,0,0,1,1.79,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.237,11.425a1.614,1.614,0,0,0-.432-.432A1.614,1.614,0,0,1,30.237,11.425Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.111,27.08a1.584,1.584,0,0,0-.35-.531,1.584,1.584,0,0,1,.35.531Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.392,11.72c0-.007,0-.016-.008-.023l.008.023Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.63,29.28a1.6,1.6,0,0,1-1.308-.683,1.6,1.6,0,0,0,2.79-.317h0A1.6,1.6,0,0,1,23.63,29.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13,12.92H26.179a2.8,2.8,0,0,0,5.463,0H32.87a.6.6,0,1,0,0-1.2H31.642a2.8,2.8,0,0,0-5.464,0H7.13a.6.6,0,0,0,0,1.2ZM27.436,11.7a1.594,1.594,0,0,1,.579-.7,1.6,1.6,0,0,1,2.222.432,1.62,1.62,0,0,1,.147.272c0,.007,0,.016.008.023h0a1.6,1.6,0,0,1,.118.6,1.628,1.628,0,0,1-.032.322,1.6,1.6,0,0,1-2.9.572,1.589,1.589,0,0,1-.154-1.494h0C27.432,11.713,27.433,11.7,27.436,11.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.87,19.4H14.482a2.8,2.8,0,0,0-5.464,0H7.13a.6.6,0,0,0,0,1.2H9.018a2.8,2.8,0,0,0,5.464,0H32.87a.6.6,0,1,0,0-1.2Zm-20.5,2.074a1.6,1.6,0,0,1-2.191-1.152,1.6,1.6,0,0,1,.945-1.8,1.6,1.6,0,0,1,2.19,1.152,1.587,1.587,0,0,1,0,.644A1.6,1.6,0,0,1,12.373,21.474Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.87,27.08H26.362a2.8,2.8,0,0,0-5.464,0H7.13a.6.6,0,1,0,0,1.2H20.9a2.8,2.8,0,0,0,5.464,0H32.87a.6.6,0,0,0,0-1.2Zm-9.24,2.2a1.6,1.6,0,1,1,1.481-2.2h0a1.572,1.572,0,0,1,0,1.2h0A1.6,1.6,0,0,1,23.63,29.28Z",
    fill: "#fff"
  }))))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Custom_alerts",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.2,8.65H8.8a.8.8,0,0,0-.8.8v15.2a.8.8,0,0,0,.8.8H12v6.4l7.2-6.4h12a.8.8,0,0,0,.8-.8V9.45A.8.8,0,0,0,31.2,8.65Zm-.4,15.6H18.744l-.341.3-5.2,4.625V24.25h-4V9.85H30.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21.05,
    r: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,19.05a.483.483,0,0,0,.45-.483l.75-5.316a1.321,1.321,0,0,0-1.2-1.4A1.438,1.438,0,0,0,18.8,13.4l.75,5.171A.452.452,0,0,0,20,19.05Z",
    fill: "#fff"
  }))))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Design_policy",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8,7.2H10.4a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8H29.6a.8.8,0,0,0,.8-.8V13.6Zm4.4,24.4H10.8V8.4H24v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.146,18.029a1.567,1.567,0,0,1,.011-.161c0-.025.007-.051.011-.088a2.078,2.078,0,0,0,.022-.258v-.106l-.091-.051a5.257,5.257,0,0,0-1.258-.521l-.135-.037-.069.121a1.822,1.822,0,0,1-1.524.958,1.752,1.752,0,0,1-1.563-.955l-.07-.131-.142.044a6.434,6.434,0,0,0-1.254.517l-.12.066.033.131a1.126,1.126,0,0,1,.029.241c0,.073,0,.135,0,.262a1.722,1.722,0,0,1-1.753,1.753,1.761,1.761,0,0,1-.262-.018,1.48,1.48,0,0,0-.245-.022h-.116l-.059.135c-.149.321-.218.482-.3.678a5.738,5.738,0,0,0-.245.7l-.032.124.109.073a1.78,1.78,0,0,1,.762,1.447,1.882,1.882,0,0,1-.689,1.414l-.084.069.022.11a3.1,3.1,0,0,0,.488,1.2l.059.1.124-.029a1.085,1.085,0,0,1,.24-.033c.073,0,.135,0,.263,0a1.75,1.75,0,0,1,1.753,1.754,1.875,1.875,0,0,1-.018.251,2.332,2.332,0,0,0-.022.3v.105c.069.037.106.055.109.059a7.048,7.048,0,0,0,.762.346c.186.077.27.109.372.157l.153.069.08-.149a1.726,1.726,0,0,1,3.088,0l.069.127.138-.036a5.215,5.215,0,0,0,1.258-.562l.131-.073-.047-.142a1.049,1.049,0,0,1-.033-.273v-.171a1.722,1.722,0,0,1,1.753-1.754,1.834,1.834,0,0,1,.208.018,2.4,2.4,0,0,0,.255.022h.113l.051-.1a7.823,7.823,0,0,0,.471-1.075L26,24.51l-.1-.077a1.927,1.927,0,0,1-.81-1.538,1.762,1.762,0,0,1,.875-1.528l.121-.069-.037-.135a7.035,7.035,0,0,0-.518-1.334l-.072-.131-.15.051a.723.723,0,0,1-.186.029c-.062,0-.116,0-.219,0A1.749,1.749,0,0,1,23.146,18.029Zm-3.1,7.918A3.147,3.147,0,1,1,23.2,22.8,3.147,3.147,0,0,1,20.05,25.947Z",
    fill: "#fff"
  }))))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Enrollment",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,8H9.6A1.6,1.6,0,0,0,8,9.6V30.4A1.6,1.6,0,0,0,9.6,32H30.4A1.6,1.6,0,0,0,32,30.4V9.6A1.6,1.6,0,0,0,30.4,8Zm.4,22.4a.4.4,0,0,1-.4.4H9.6a.4.4,0,0,1-.4-.4V9.6a.4.4,0,0,1,.4-.4H30.4a.4.4,0,0,1,.4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19.2H20.8V16a.8.8,0,0,0-1.6,0v3.2H16a.8.8,0,0,0,0,1.6h3.2V24a.8.8,0,0,0,1.6,0V20.8H24a.8.8,0,0,0,0-1.6Z",
    fill: "#fff"
  }))))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Equipment",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8,6.4H15.2A1\\xC7.6,1.6,0,0,0,13.6,8V32a1.6,1.6,0,0,0,1.6,1.6h9.6A1.6,1.6,0,0,0,26.4,32V8A1.6,1.6,0,0,0,24.8,6.4ZM22,7.6V9.2H18V7.6ZM18,32.4V30.8h4v1.6Zm7.2-.4a.4.4,0,0,1-.4.4H23.2v-2a.8.8,0,0,0-.8-.8H17.6a.8.8,0,0,0-.8.8v2H15.2a.4.4,0,0,1-.4-.4V8a.4.4,0,0,1,.4-.4h1.6v2a.8.8,0,0,0,.8.8h4.8a.8.8,0,0,0,.8-.8v-2h1.6a.4.4,0,0,1,.4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,15.8A1.8,1.8,0,1,0,18.2,14,1.8,1.8,0,0,0,20,15.8Zm0-2.4a.6.6,0,1,1-.6.6A.6.6,0,0,1,20,13.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,18.4h-.8a.8.8,0,0,0-.8.8v7.2a.8.8,0,0,0,.8.8h.8A2.4,2.4,0,0,0,22,24.8v-4A2.4,2.4,0,0,0,19.6,18.4Zm1.2,6.4A1.2,1.2,0,0,1,19.6,26h-.4V19.6h.4a1.2,1.2,0,0,1,1.2,1.2Z",
    fill: "#fff"
  }))))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Export_logs",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.362,21h-3a.6.6,0,1,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.162,21h-2.2a.6.6,0,1,0,0,1.2h2.2a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.761,24.2h-2.8a.6.6,0,1,0,0,1.2h2.8a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.362,24.2h-3a.6.6,0,0,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.162,24.2h-2.2a.6.6,0,1,0,0,1.2h2.2a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.761,27.4h-2.8a.6.6,0,0,0,0,1.2h2.8a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.362,27.4h-3a.6.6,0,1,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.162,27.4h-2.2a.6.6,0,0,0,0,1.2h2.2a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.962,19h2.8a.6.6,0,0,0,0-1.2h-2.8a.6.6,0,1,0,0,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.362,17.8h-3a.6.6,0,1,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.162,17.8h-2.2a.6.6,0,1,0,0,1.2h2.2a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.362,14.6h-3a.6.6,0,0,0,0,1.2h3a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.361,31.6H8.962V8.4h13.2v6h5.2v1.2h1.2v-2l-5.6-6.4H8.562a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8h19.2a.8.8,0,0,0,.8-.8V27.6h-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.786,26.081l4.452-4.453-4.452-4.452-.849.848,3,3H21.965a.6.6,0,0,0,0,1.2h7.977l-3,3Z",
    fill: "#fff"
  }))))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Foreign_systems",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.828,18.471a6.659,6.659,0,0,1-1.059.785,1.2,1.2,0,1,1-1.514.766.977.977,0,0,1,.044-.113,5,5,0,0,1-1.276.245l-.015.073c0,.055-.012.108-.012.16a2.38,2.38,0,0,0,1.256,2.1l-1.275,5.1a2.421,2.421,0,0,0-.593.087l-4.929-8.761a2.428,2.428,0,0,0,.332-.384c.008-.012.013-.026.021-.039l.059-.11a4.424,4.424,0,0,1-.888-1.027A1.2,1.2,0,1,1,18.956,16a1.24,1.24,0,0,1,.338.1,6.531,6.531,0,0,1-.382-1.3c-.036,0-.076-.011-.116-.011a2.4,2.4,0,0,0-.934.189,2.084,2.084,0,0,0-.279.151l0-.006-3.92-3.92a2.4,2.4,0,0,0,.257-.614h5.608a6.634,6.634,0,0,1,.783-1.2H13.916a2.379,2.379,0,0,0-.328-.741,2.454,2.454,0,0,0-.213-.272A2.4,2.4,0,1,0,10.663,12.2a2.318,2.318,0,0,0,.335.1v9.77a2.45,2.45,0,0,0-.335.1,2.4,2.4,0,1,0,2.88,3.611l10.08,3.92a2.626,2.626,0,0,0-.027.28,2.4,2.4,0,1,0,3.544-2.1l1.275-5.1a2.39,2.39,0,0,0,1.413-4.32ZM10.4,9.991a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,10.4,9.991Zm1.2,15.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,11.6,25.591Zm1.218-3.266a2.359,2.359,0,0,0-.283-.145,2.45,2.45,0,0,0-.335-.1v-9.77a2.318,2.318,0,0,0,.335-.1,2.508,2.508,0,0,0,.283-.144l3.92,3.92a2.36,2.36,0,0,0,0,2.43Zm11.238,6.266-10.08-3.92a2.188,2.188,0,0,0,.024-.28,2.376,2.376,0,0,0-.337-1.215l3.92-3.92a2.446,2.446,0,0,0,.284.145,2.3,2.3,0,0,0,1.546.1l4.929,8.763A2.4,2.4,0,0,0,24.052,28.591Zm3.144,1.4a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,27.2,29.991Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4,8.391a5.2,5.2,0,1,0,5.2,5.2A5.2,5.2,0,0,0,25.4,8.391Zm4.072,6.861H27.985a7.865,7.865,0,0,0,.16-1.261h1.629A4.39,4.39,0,0,1,29.468,15.252Zm-8.138.016a4.35,4.35,0,0,1-.314-1.28h1.63a7.753,7.753,0,0,0,.16,1.261H21.411a.373.373,0,0,0-.081.022Zm0-3.345h1.482a7.852,7.852,0,0,0-.16,1.268H21.016a4.371,4.371,0,0,1,.311-1.268Zm4.469-.8V9.7a2.7,2.7,0,0,1,1.1,1.421Zm1.36.8a6.963,6.963,0,0,1,.177,1.268H25.8V11.923ZM25,9.7v1.421H23.9A2.7,2.7,0,0,1,25,9.7Zm0,2.221v1.268H23.456a6.963,6.963,0,0,1,.177-1.268Zm-1.543,2.068H25v1.261H23.631A7.05,7.05,0,0,1,23.456,13.991ZM25,16.052v1.429a2.711,2.711,0,0,1-1.1-1.429Zm.8,1.429V16.052h1.1A2.717,2.717,0,0,1,25.8,17.481Zm0-2.229V13.991h1.54a7.048,7.048,0,0,1-.174,1.261Zm2.351-2.061a7.965,7.965,0,0,0-.16-1.268h1.482a4.371,4.371,0,0,1,.306,1.268Zm.889-2.068H27.762A4.419,4.419,0,0,0,26.746,9.4,4.417,4.417,0,0,1,29.036,11.123ZM24.047,9.4a4.388,4.388,0,0,0-1.016,1.718H21.756A4.418,4.418,0,0,1,24.047,9.4Zm-2.3,6.647h1.28a4.4,4.4,0,0,0,1.019,1.726A4.411,4.411,0,0,1,21.751,16.052Zm4.995,1.726a4.41,4.41,0,0,0,1.018-1.726h1.28A4.431,4.431,0,0,1,26.746,17.778Z",
    fill: "#fff"
  })))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Geographical_redundancy",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 12.103,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 16.503,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 20.903,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8,9.3H22.4a.8.8,0,0,0-.8.8V23.7h3v2.4a3.4,3.4,0,0,1-3.4,3.4H18.8a3.4,3.4,0,0,1-3.4-3.4V23.7h3V10.1a.8.8,0,0,0-.8-.8H7.2a.8.8,0,0,0-.8.8V23.7h3v2.4A4.605,4.605,0,0,0,14,30.7H26a4.605,4.605,0,0,0,4.6-4.6V23.7h3V10.1A.8.8,0,0,0,32.8,9.3ZM7.6,10.5h9.6v3.2H7.6Zm0,4.406h9.6v3.2H7.6Zm0,7.6V19.3h9.6v3.2Zm6.4,7a3.4,3.4,0,0,1-3.4-3.4V23.7h3.6v2.4a4.584,4.584,0,0,0,1.512,3.4Zm15.4-3.4A3.4,3.4,0,0,1,26,29.5H24.287A4.582,4.582,0,0,0,25.8,26.1V23.7h3.6Zm3-3.6H22.8V19.3h9.6Zm-9.6-4.4V14.9h9.6v3.2Zm0-7.606h9.6v3.2H22.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 12.103,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 16.503,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 20.903,
    r: 0.8,
    fill: "#fff"
  }))))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_L3_vpn_infrastructure",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.424,20.4A2.376,2.376,0,0,0,28.6,18.043l-2.859-6.195a2.391,2.391,0,1,0-3.356-3.37,11.359,11.359,0,0,0-8.421-.126,2.391,2.391,0,0,0-3.606,3.137,11.629,11.629,0,0,0-.276,11.854A2.392,2.392,0,0,0,14.166,25.8l10.086,3.922a2.354,2.354,0,0,0-.028.279,2.4,2.4,0,1,0,3.542-2.1l1.276-5.1A2.4,2.4,0,0,0,31.424,20.4Zm-3.6,9.6a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,27.824,30Zm-1.812-2.312-1.591-2.829a11.743,11.743,0,0,0,3.425-2.222L26.605,27.6A2.366,2.366,0,0,0,26.012,27.688ZM24.224,8.8a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,24.224,8.8Zm-1.783,2.793-2.233,3.349a2.3,2.3,0,0,0-2,.2L16.02,12.948l6.141-1.74A2.412,2.412,0,0,0,22.441,11.593ZM20.624,17.2a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,20.624,17.2Zm-3.261-1.212a2.336,2.336,0,0,0,0,2.424l-3.927,3.927-.118-.064,1.9-8.431ZM11.024,24.4a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,11.024,24.4Zm3.6,0a2.376,2.376,0,0,0-.339-1.208l3.928-3.927a2.378,2.378,0,0,0,1.212.339,2.417,2.417,0,0,0,.611-.088l2.646,4.7A17.537,17.537,0,0,1,14.623,24.4Zm6.461-5.468a2.427,2.427,0,0,0,.351-.425l5.205,1.735c0,.055-.016.107-.016.162a2.384,2.384,0,0,0,.426,1.362,10.491,10.491,0,0,1-3.216,2.054Zm6.74,1.472a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,27.824,20.4Zm-.314-1.848a2.413,2.413,0,0,0-.5.545l-5.205-1.735c0-.055.017-.107.017-.162a2.385,2.385,0,0,0-.617-1.593l2.232-3.349a2.2,2.2,0,0,0,1.211.1Zm-5.644-8.97a2.4,2.4,0,0,0-.042.418c0,.019,0,.036,0,.055l-6.78,1.922-.765-.765A2.372,2.372,0,0,0,14.624,10a2.415,2.415,0,0,0-.075-.568A10.336,10.336,0,0,1,21.866,9.582ZM11.024,10a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,11.024,10Zm.285,2.217a2.354,2.354,0,0,0,2.127-.156l.78.78-2.068,9.167a2.38,2.38,0,0,0-1.233.384A10.229,10.229,0,0,1,11.309,12.217ZM17.97,25.991c.183,0,.366.009.554.009a15.622,15.622,0,0,0,4.763-.707l1.676,2.98a2.391,2.391,0,0,0-.282.328Z",
    fill: "#fff"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_L3_vpn_services",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.839,13.579l1.006-.655a8.422,8.422,0,0,0-1.454-1.682l-.8.895A7.211,7.211,0,0,1,27.839,13.579Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,17.177l1.2-.018a8.32,8.32,0,0,0-.325-2.2l-1.151.336A7.109,7.109,0,0,1,28.9,17.177Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,26.7l1.1.484a8.146,8.146,0,0,0,.682-2.874l-1.2-.063A6.949,6.949,0,0,1,28.5,26.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.388,8.145a12.71,12.71,0,0,0-2.11-.441L19.135,8.9a11.453,11.453,0,0,1,1.911.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,8.847l-.086-1.2a10.751,10.751,0,0,0-2.143.372l.325,1.155A9.688,9.688,0,0,1,17.2,8.847Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.518,
    y: 20.2,
    width: 2.594,
    height: 1.2,
    transform: "translate(-10.076 17.275) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.215,
    y: 12.303,
    width: 1.2,
    height: 2.594,
    transform: "translate(-4.984 15.166) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.615,
    y: 17.513,
    width: 1.201,
    height: 2.573,
    transform: "translate(-1.28 35.824) rotate(-71.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.62,
    y: 24.513,
    width: 1.201,
    height: 2.457,
    transform: "translate(-9.51 15.182) rotate(-29.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.21,
    y: 20.23,
    width: 1.201,
    height: 2.457,
    transform: "translate(-7.72 13.45) rotate(-29.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.773,
    y: 13,
    width: 2.084,
    height: 1.2,
    transform: "translate(-1.602 24.207) rotate(-56.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.58,20.431l1.191.146a12.856,12.856,0,0,1,.562-2.525L12.2,17.669A13.942,13.942,0,0,0,11.58,20.431Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.535,11.316l-.354-1.147a14.365,14.365,0,0,0-2.607,1.086l.573,1.054A13.168,13.168,0,0,1,20.535,11.316Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.962,23.415l-.729-.955a10.493,10.493,0,0,1-1.855,1.131l.515,1.083A11.778,11.778,0,0,0,26.962,23.415Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.533,25.779a20.958,20.958,0,0,0,2.359.21l.037-1.2a19.707,19.707,0,0,1-2.224-.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.627,25.5l-.3-1.161a14.255,14.255,0,0,1-2.172.384l.119,1.194A15.33,15.33,0,0,0,22.627,25.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.635,13.458l-1.092-.5A11.066,11.066,0,0,0,8.71,15.63l1.182.207A9.846,9.846,0,0,1,10.635,13.458Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.781,18.326l-1.2.1a12.259,12.259,0,0,0,.548,2.728l1.143-.366A11.081,11.081,0,0,1,9.781,18.326Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.687,30.531a15.643,15.643,0,0,0,2.907.391l.05-1.2a14.447,14.447,0,0,1-2.683-.362Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.417,27.932A12,12,0,0,0,16.9,29.547l.526-1.078a10.872,10.872,0,0,1-2.238-1.454Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.149,12.211a2.407,2.407,0,0,0,1.056-.869A2.407,2.407,0,0,1,13.149,12.211Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.225,11.342a2.407,2.407,0,0,0,1.056.869A2.407,2.407,0,0,1,10.225,11.342Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.815,10a2.388,2.388,0,0,1,.41-1.342A2.388,2.388,0,0,0,9.815,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205,8.658a2.416,2.416,0,0,0-1.056-.87A2.416,2.416,0,0,1,14.205,8.658Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.615,10a2.388,2.388,0,0,1-.41,1.342A2.388,2.388,0,0,0,14.615,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205,8.658A2.388,2.388,0,0,1,14.615,10,2.388,2.388,0,0,0,14.205,8.658Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.815,10a2.388,2.388,0,0,0,.41,1.342A2.388,2.388,0,0,1,9.815,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.281,7.788a2.416,2.416,0,0,0-1.056.87A2.416,2.416,0,0,1,11.281,7.788Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.281,12.211a2.4,2.4,0,0,0,2.924-3.553,2.4,2.4,0,0,0-3.98,0,2.4,2.4,0,0,0,1.056,3.553ZM12.215,8.8a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,12.215,8.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.225,25.742a2.388,2.388,0,0,1-.41-1.342A2.388,2.388,0,0,0,10.225,25.742Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.281,22.189a2.407,2.407,0,0,0-1.056.869A2.407,2.407,0,0,1,11.281,22.189Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205,23.058a2.407,2.407,0,0,0-1.056-.869A2.407,2.407,0,0,1,14.205,23.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.149,26.611a2.407,2.407,0,0,0,1.056-.869A2.407,2.407,0,0,1,13.149,26.611Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.225,25.742a2.407,2.407,0,0,0,1.056.869A2.407,2.407,0,0,1,10.225,25.742Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.815,24.4a2.388,2.388,0,0,1,.41-1.342A2.388,2.388,0,0,0,9.815,24.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205,25.742a2.388,2.388,0,0,0,.41-1.342A2.388,2.388,0,0,1,14.205,25.742Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205,23.058a2.388,2.388,0,0,1,.41,1.342A2.388,2.388,0,0,0,14.205,23.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.205,23.058a2.4,2.4,0,1,0,.41,1.342A2.407,2.407,0,0,0,14.205,23.058ZM11.015,24.4a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,11.015,24.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.015,30a2.388,2.388,0,0,1-.41,1.342A2.388,2.388,0,0,0,29.015,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.015,30a2.388,2.388,0,0,0-.41-1.342A2.388,2.388,0,0,1,29.015,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.681,27.789a2.407,2.407,0,0,0-1.056.869A2.407,2.407,0,0,1,25.681,27.789Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.215,30a2.388,2.388,0,0,1,.41-1.342A2.388,2.388,0,0,0,24.215,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.605,28.658a2.4,2.4,0,0,0-1.056-.869A2.4,2.4,0,0,1,28.605,28.658Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.625,31.342a2.416,2.416,0,0,0,1.056.87A2.416,2.416,0,0,1,24.625,31.342Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.625,31.342A2.388,2.388,0,0,1,24.215,30,2.388,2.388,0,0,0,24.625,31.342Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.549,32.212a2.41,2.41,0,0,0,1.056-.87A2.41,2.41,0,0,1,27.549,32.212Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.549,27.789a2.4,2.4,0,0,0-1.868,0,2.4,2.4,0,1,0,1.868,0ZM26.615,31.2a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,26.615,31.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.025,21.742a2.388,2.388,0,0,1-.41-1.342A2.388,2.388,0,0,0,27.025,21.742Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.081,18.189a2.407,2.407,0,0,0-1.056.869A2.407,2.407,0,0,1,28.081,18.189Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.025,21.742a2.407,2.407,0,0,0,1.056.869A2.407,2.407,0,0,1,27.025,21.742Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.615,20.4a2.388,2.388,0,0,1,.41-1.342A2.388,2.388,0,0,0,26.615,20.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.005,19.058a2.4,2.4,0,0,0-1.056-.869A2.4,2.4,0,0,1,31.005,19.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.005,19.058a2.388,2.388,0,0,1,.41,1.342A2.388,2.388,0,0,0,31.005,19.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.949,22.611a2.4,2.4,0,0,0,1.056-.869A2.4,2.4,0,0,1,29.949,22.611Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.005,21.742a2.388,2.388,0,0,0,.41-1.342A2.388,2.388,0,0,1,31.005,21.742Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.005,19.058a2.4,2.4,0,1,0,.41,1.342A2.4,2.4,0,0,0,31.005,19.058ZM29.015,21.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,29.015,21.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.405,15.858a2.407,2.407,0,0,0-1.056-.869A2.407,2.407,0,0,1,21.405,15.858Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.405,15.858a2.388,2.388,0,0,1,.41,1.342A2.388,2.388,0,0,0,21.405,15.858Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.349,19.411a2.407,2.407,0,0,0,1.056-.869A2.407,2.407,0,0,1,20.349,19.411Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.425,18.542a2.407,2.407,0,0,0,1.056.869A2.407,2.407,0,0,1,17.425,18.542Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.481,14.989a2.407,2.407,0,0,0-1.056.869A2.407,2.407,0,0,1,18.481,14.989Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.815,17.2a2.388,2.388,0,0,1-.41,1.342A2.388,2.388,0,0,0,21.815,17.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.015,17.2a2.388,2.388,0,0,1,.41-1.342A2.388,2.388,0,0,0,17.015,17.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.425,18.542a2.388,2.388,0,0,1-.41-1.342A2.388,2.388,0,0,0,17.425,18.542Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.405,18.542a2.4,2.4,0,1,0-1.056.869A2.388,2.388,0,0,0,21.405,18.542Zm-.79-1.342a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,20.615,17.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.815,10a2.388,2.388,0,0,1,.41-1.342A2.388,2.388,0,0,0,21.815,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.205,8.658A2.388,2.388,0,0,1,26.615,10,2.388,2.388,0,0,0,26.205,8.658Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.281,7.788a2.416,2.416,0,0,0-1.056.87A2.416,2.416,0,0,1,23.281,7.788Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.815,10a2.388,2.388,0,0,0,.41,1.342A2.388,2.388,0,0,1,21.815,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.205,8.658a2.416,2.416,0,0,0-1.056-.87A2.416,2.416,0,0,1,26.205,8.658Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.225,11.342a2.407,2.407,0,0,0,1.056.869A2.407,2.407,0,0,1,22.225,11.342Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.149,12.211a2.407,2.407,0,0,0,1.056-.869A2.407,2.407,0,0,1,25.149,12.211Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.615,10a2.388,2.388,0,0,1-.41,1.342A2.388,2.388,0,0,0,26.615,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.281,12.211a2.4,2.4,0,0,0,2.924-3.553,2.4,2.4,0,0,0-3.98,0,2.4,2.4,0,0,0,1.056,3.553ZM25.415,10a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,25.415,10Z",
    fill: "#fff"
  }))))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Licensing",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.6,10.438V21.507a8.378,8.378,0,0,0,4.28,7.3L20,31.678l5.12-2.868a8.378,8.378,0,0,0,4.281-7.3V10.438L20,8.182Zm14.368,1.294,2.332.08a.706.706,0,0,1,.682.73c0,.022,0,.043,0,.064l-.377,3a.712.712,0,0,1-.679.619l-1.1.036-.017,1.052a.689.689,0,0,1-.682.7h-.038l-.91-.02.028.954a.71.71,0,0,1-.211.524l-1.742,1.743A4.942,4.942,0,0,1,17.468,27.4c-.09,0-.182,0-.273-.008a4.944,4.944,0,1,1,1.52-9.72l5.729-5.729A.726.726,0,0,1,24.968,11.732Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.948,9.4,9.492V21.507a9.575,9.575,0,0,0,4.894,8.35L20,33.052l5.706-3.195a9.578,9.578,0,0,0,4.894-8.35V9.492Zm9.4,14.56a8.377,8.377,0,0,1-4.28,7.3L20,31.678,14.88,28.81a8.378,8.378,0,0,1-4.28-7.3V10.438L20,8.182l9.4,2.256Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.486,19.527A4.946,4.946,0,0,0,17.2,27.39c.091,0,.182.008.273.008a4.942,4.942,0,0,0,4.785-6.189L24,19.466a.706.706,0,0,0,.21-.524l-.027-.954.91.02a.689.689,0,0,0,.719-.657c0-.012,0-.025,0-.037l.017-1.052,1.1-.036a.711.711,0,0,0,.674-.619l.375-3a.707.707,0,0,0-.612-.79l-.065-.005-2.332-.08a.727.727,0,0,0-.52.209L18.72,17.67A4.947,4.947,0,0,0,13.486,19.527Zm11.66-6.588,1.573.053-.256,2.048-1.142.038a.705.705,0,0,0-.687.7L24.618,16.8l-.925-.02a.747.747,0,0,0-.517.205.71.71,0,0,0-.206.521l.036,1.261L20.89,20.881l.121.354a3.717,3.717,0,0,1-.888,3.867,3.776,3.776,0,0,1-2.857,1.092,3.744,3.744,0,1,1,1.428-7.277l.354.121Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.486,21.917a1.785,1.785,0,1,0,2.524,0h0A1.787,1.787,0,0,0,15.486,21.917Zm1.676,1.675a.585.585,0,1,1,0-.827h0A.586.586,0,0,1,17.162,23.592Z",
    fill: "#fff"
  }))))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Metrics",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,8.8H9.6A1.6,1.6,0,0,0,8,10.4V29.6a1.6,1.6,0,0,0,1.6,1.6H30.4A1.6,1.6,0,0,0,32,29.6V10.4A1.6,1.6,0,0,0,30.4,8.8ZM9.2,12H30.8V24.2H27.342L25.6,23.329l-1.2.6-1.012-4.048-1.649,3.3-2.627-8.755-1.732,7.8L16,19.459,14.829,21.8H9.2ZM30.4,30H9.6a.4.4,0,0,1-.4-.4V23h6.371L16,22.141l1.819,3.639,1.468-6.6,2.173,7.245,1.551-3.1.588,2.352,2-1,1.458.729H30.8v4.2A.4.4,0,0,1,30.4,30Z",
    fill: "#fff"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Ne_connection_profiles",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.316,11.4H12.4a.6.6,0,0,0,0,1.2h4.915a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.316,13.8H12.4a.6.6,0,1,0,0,1.2h4.915a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,30.4a.4.4,0,0,1-.4.4H25.2v-5a.6.6,0,0,0-1.2,0v5H22.8v-5a.6.6,0,1,0-1.2,0v5H20.4v-5a.6.6,0,0,0-1.2,0v5H18V17.4a.6.6,0,0,0-1.2,0V30.8H15.6V17.4a.6.6,0,0,0-1.2,0V30.8H13.2V17.4a.6.6,0,1,0-1.2,0V30.8H10.2a.4.4,0,0,1-.4-.4V9.6a.4.4,0,0,1,.4-.4H27a.4.4,0,0,1,.4.4v2h1.2v-2A1.6,1.6,0,0,0,27,8H10.2A1.6,1.6,0,0,0,8.6,9.6V30.4A1.6,1.6,0,0,0,10.2,32H27a1.6,1.6,0,0,0,1.6-1.6V25.2H27.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,13H22.8a2.2,2.2,0,0,0-2.2,2.2v6.4a2.2,2.2,0,0,0,2.2,2.2h6.4a2.2,2.2,0,0,0,2.2-2.2V15.2A2.2,2.2,0,0,0,29.2,13Zm1,8.6a1,1,0,0,1-1,1H22.8a1,1,0,0,1-1-1V15.2a1,1,0,0,1,1-1h6.4a1,1,0,0,1,1,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.833,19.428h0l-.083-.006c0-.02-.117-.432-.117-.432a1.173,1.173,0,0,0,.473-.936.3.3,0,0,0,.3-.324l.037-.276a.319.319,0,0,0-.1-.227.333.333,0,0,0-.1-.068,1.324,1.324,0,0,0-1.264-1.643h-.036a1.324,1.324,0,0,0-1.264,1.643.347.347,0,0,0-.1.068.319.319,0,0,0-.1.227l.037.276a.3.3,0,0,0,.289.324,1.232,1.232,0,0,0,.487.936s-.119.412-.117.432l-.083.006h0a3.068,3.068,0,0,0-1.784.749,1.783,1.783,0,0,0-.5,1.107h6.358a1.868,1.868,0,0,0-.56-1.107A3.062,3.062,0,0,0,26.833,19.428Z",
    fill: "#fff"
  }))))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Network_audits",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,7.175H10.4a.8.8,0,0,0-.8.8h0v24.05a.8.8,0,0,0,.8.8H29.6a.8.8,0,0,0,.8-.8V13.575Zm4.4,24.4H10.8V8.375H24v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,16.025a2.39,2.39,0,0,0,2.32-1.82h4.01a.6.6,0,0,0,0-1.2h-4a2.4,2.4,0,1,0-2.32,3Zm0-3.6a1.2,1.2,0,1,1-1.2,1.2h0a1.2,1.2,0,0,1,1.149-1.249H15.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,22.375a2.39,2.39,0,0,0,2.32-1.82h4.01a.6.6,0,0,0,0-1.2h-4a2.4,2.4,0,1,0-2.32,3Zm0-3.6a1.2,1.2,0,1,1-.051,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,25.875H17.55a2.42,2.42,0,1,0-.05,1.15h4.1a.6.6,0,0,0,.6-.6h0A.6.6,0,0,0,21.6,25.875Zm-6.4,1.7a1.2,1.2,0,1,1,1.2-1.2,1.2,1.2,0,0,1-1.2,1.2Z",
    fill: "#fff"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Network_elements_operations",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.123,20.96l.064-.122a9.7,9.7,0,0,0,.581-1.33l.05-.154-.126-.094a2.383,2.383,0,0,1-1-1.9,2.176,2.176,0,0,1,1.083-1.89l.149-.085-.046-.167a8.611,8.611,0,0,0-.64-1.651l-.09-.162-.185.063a.829.829,0,0,1-.23.036c-.077.005-.144.005-.271.005a2.164,2.164,0,0,1-2.168-2.169,1.818,1.818,0,0,1,.013-.2c0-.031.009-.063.014-.108a2.63,2.63,0,0,0,.027-.32v-.131l-.113-.063a6.536,6.536,0,0,0-1.556-.645l-.167-.045-.085.149a2.254,2.254,0,0,1-1.885,1.186,2.168,2.168,0,0,1-1.935-1.182l-.086-.162-.175.054a7.885,7.885,0,0,0-1.552.64l-.148.082.04.162a1.284,1.284,0,0,1,.036.3c0,.09,0,.166,0,.324a2.131,2.131,0,0,1-2.169,2.169,2.264,2.264,0,0,1-.325-.022,1.828,1.828,0,0,0-.3-.027H8.785l-.073.167c-.184.4-.27.6-.369.838a6.9,6.9,0,0,0-.3.871L8,15.526l.135.09a2.2,2.2,0,0,1,.943,1.79,2.325,2.325,0,0,1-.853,1.75l-.1.086.027.135a3.829,3.829,0,0,0,.6,1.483l.072.127.154-.036a1.312,1.312,0,0,1,.3-.041c.09,0,.167,0,.325,0a2.164,2.164,0,0,1,2.169,2.169,2.241,2.241,0,0,1-.023.311,2.958,2.958,0,0,0-.027.365v.131c.086.045.131.068.136.072a8.457,8.457,0,0,0,.942.428c.23.095.334.136.46.194l.189.086.1-.185a2.134,2.134,0,0,1,3.819,0l.086.158.171-.045a6.442,6.442,0,0,0,1.556-.7l.162-.09-.059-.176a1.281,1.281,0,0,1-.04-.338v-.212a2.13,2.13,0,0,1,2.169-2.169,2.164,2.164,0,0,1,.257.023,3.114,3.114,0,0,0,.316.027Zm-6.662.428a4.149,4.149,0,1,1,4.149-4.149A4.148,4.148,0,0,1,15.461,21.388Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.163,25.117a1.479,1.479,0,0,1,.736-1.285l.1-.058-.031-.114a5.875,5.875,0,0,0-.435-1.122l-.061-.11-.126.043a.588.588,0,0,1-.157.024c-.052,0-.1,0-.183,0a1.471,1.471,0,0,1-1.475-1.474,1.262,1.262,0,0,1,.009-.135c0-.022.006-.043.009-.074a1.761,1.761,0,0,0,.018-.218v-.089l-.076-.043a4.452,4.452,0,0,0-1.058-.438L28.32,20l-.058.1a1.532,1.532,0,0,1-1.282.806,1.475,1.475,0,0,1-1.315-.8l-.058-.111-.12.037a5.385,5.385,0,0,0-1.055.435l-.1.056.028.11a.932.932,0,0,1,.024.2c0,.062,0,.114,0,.221a1.448,1.448,0,0,1-1.475,1.475,1.568,1.568,0,0,1-.22-.015,1.209,1.209,0,0,0-.206-.019h-.1l-.049.114c-.126.27-.184.4-.251.57a4.74,4.74,0,0,0-.206.592l-.027.1.092.062a1.5,1.5,0,0,1,.64,1.217,1.585,1.585,0,0,1-.579,1.19l-.071.058.019.092a2.6,2.6,0,0,0,.411,1.009l.049.085.1-.024a.91.91,0,0,1,.2-.028c.062,0,.114,0,.221,0a1.471,1.471,0,0,1,1.475,1.475,1.541,1.541,0,0,1-.015.212,1.881,1.881,0,0,0-.019.248v.089c.059.031.089.046.092.049a5.683,5.683,0,0,0,.641.291c.157.065.227.092.313.132l.129.058.067-.125a1.45,1.45,0,0,1,2.6,0l.059.107.116-.031a4.365,4.365,0,0,0,1.058-.472l.11-.061-.04-.12a.883.883,0,0,1-.027-.23v-.144a1.449,1.449,0,0,1,1.475-1.475,1.364,1.364,0,0,1,.175.016,2.143,2.143,0,0,0,.214.018h.1l.043-.083a6.508,6.508,0,0,0,.4-.9l.033-.1-.085-.064A1.619,1.619,0,0,1,31.163,25.117Zm-4.236,2.567a2.647,2.647,0,1,1,2.647-2.647A2.647,2.647,0,0,1,26.927,27.684Z",
    fill: "#fff"
  }))))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Network_elements",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.4,8H11.6A1.6,1.6,0,0,0,10,9.6V30.4A1.6,1.6,0,0,0,11.6,32H28.4A1.6,1.6,0,0,0,30,30.4V9.6A1.6,1.6,0,0,0,28.4,8Zm.4,22.4a.4.4,0,0,1-.4.4H26.6V17.405a.6.6,0,0,0-1.2,0V30.8H24.2V17.405a.6.6,0,0,0-1.2,0V30.8H21.8V17.405a.6.6,0,0,0-1.2,0V30.8H19.4V17.405a.6.6,0,0,0-1.2,0V30.8H17V17.405a.6.6,0,0,0-1.2,0V30.8H14.6V17.405a.6.6,0,0,0-1.2,0V30.8H11.6a.4.4,0,0,1-.4-.4V9.6a.4.4,0,0,1,.4-.4H28.4a.4.4,0,0,1,.4.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,11.4H13.8a.6.6,0,1,0,0,1.2H26.2a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,13.8H13.8a.6.6,0,1,0,0,1.2H26.2a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }))))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Network_map",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.75,14.407l-4.189.381a2.4,2.4,0,0,1-.711,1.347l5.75,10.35c.042-.011.081-.028.123-.037l.556-10.571A2.394,2.394,0,0,1,27.75,14.407Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.516,27,21.8,16.715a2.381,2.381,0,0,1-.6.085,2.327,2.327,0,0,1-.393-.04l-1.32,2.971a2.326,2.326,0,0,1,.783,2.615Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.715,13.479l.568,11.37a2.362,2.362,0,0,1,.974.458L15.8,22.552A2.4,2.4,0,0,1,18,19.2a2.327,2.327,0,0,1,.393.04l1.32-2.971A2.386,2.386,0,0,1,18.8,14.4c0-.021.006-.039.006-.06l-6.747-1.928A2.388,2.388,0,0,1,10.715,13.479Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4,13.6a2.4,2.4,0,0,0-4.761-.388l-4.189.381a2.382,2.382,0,0,0-4.309-.4L12.394,11.26c0-.02.006-.039.006-.06a2.4,2.4,0,1,0-2.883,2.351l.568,11.37A2.394,2.394,0,1,0,13,26.248l3.542-2.754a2.361,2.361,0,0,0,3.08-.137l7.308,4.7a2.371,2.371,0,0,0-.131.746,2.4,2.4,0,1,0,3.121-2.277l.556-10.571A2.4,2.4,0,0,0,32.4,13.6Zm-2,15.2a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,30.4,28.8ZM18,22.8a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,18,22.8Zm1.487-3.069,1.32-2.971a2.327,2.327,0,0,0,.393.04,2.381,2.381,0,0,0,.6-.085L27.516,27,20.27,22.346a2.326,2.326,0,0,0-.783-2.615ZM20,14.4a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,20,14.4Zm8.6,12.085-5.75-10.35a2.4,2.4,0,0,0,.711-1.347l4.189-.381a2.394,2.394,0,0,0,1.529,1.47l-.556,10.571C28.681,26.457,28.642,26.474,28.6,26.485ZM28.8,13.6A1.2,1.2,0,1,1,30,14.8,1.2,1.2,0,0,1,28.8,13.6Zm-9.994.74c0,.021-.006.039-.006.06a2.386,2.386,0,0,0,.913,1.869l-1.32,2.971A2.327,2.327,0,0,0,18,19.2a2.4,2.4,0,0,0-2.2,3.352l-3.542,2.755a2.362,2.362,0,0,0-.974-.458l-.568-11.37a2.388,2.388,0,0,0,1.344-1.067ZM12,27.2A1.2,1.2,0,1,1,10.8,26,1.2,1.2,0,0,1,12,27.2Zm-3.2-16A1.2,1.2,0,1,1,10,12.4,1.2,1.2,0,0,1,8.8,11.2Z",
    fill: "#fff"
  }))))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Network_trends",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.667,0h34.667C38.806,0,40,1.194,40,2.667 v34.667C40,38.806,38.806,40,37.333,40H2.667C1.194,40,0,38.806,0,37.333V2.667C0,1.194,1.194,0,2.667,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M29.731,32.688H10.269V7.312h15.865v4.594h3.596 V32.688z M26.981,6H9.846C9.379,6,9,6.391,9,6.875v26.25C9,33.609,9.379,34,9.846,34h20.308C30.621,34,31,33.609,31,33.125V11.031 L26.981,6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "29.22,15.1 23.346,16.789 24.45,18.193 20.634,21.02  17.081,17.862 12,21.47 12.669,22.413 17,19.336 20.568,22.508 25.164,19.103 26.19,20.408 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M25.835,21.678v8.267h-2.666 l-0.001-6.311L25.835,21.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M16.946,22.033v7.911H14.28 L14.28,23.9L16.946,22.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M18.724,23.544l1.912,1.698 l0.755-0.543v5.244h-2.666L18.724,23.544z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_One_planner_export",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.009,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "21.632 21.927 24.372 24.667 18.098 24.667 18.098 25.376 24.372 25.376 21.632 28.116 22.134 28.618 25.73 25.022 22.134 21.425 21.632 21.927",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.641 17.333 21.914 17.333 21.914 16.624 15.641 16.624 18.38 13.884 17.878 13.382 14.282 16.978 17.878 20.575 18.38 20.073 15.641 17.333",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.806,7.214h-14.4a.8.8,0,0,0-.8.8v24a.8.8,0,0,0,.8.8h19.2a.8.8,0,0,0,.8-.8v-18.4Zm4.4,24.4h-18.4V8.414h13.2v6h5.2Z",
    fill: "#fff"
  })))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Otdr_trace",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.009,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.409,8.8H9.609a1.6,1.6,0,0,0-1.6,1.6V29.6a1.6,1.6,0,0,0,1.6,1.6h20.8a1.6,1.6,0,0,0,1.6-1.6V10.4A1.6,1.6,0,0,0,30.409,8.8ZM15.086,14.925v-1.2H12.035v1.2h.926V21.8H9.209V12h21.6V24.2H29.93l-1.921-2.882-1.526,2.289L24.62,19.881l-.8,3.2-2.274-4.545L20.14,22.054l-1.852-7.4L17.1,21.8H14.161V14.925ZM30.409,30H9.609a.4.4,0,0,1-.4-.4V23h3.752v4.325h-.926v1.2h3.051v-1.2h-.925V23h3.956l.408-2.455,1.352,5.4,1.791-4.483,2.53,5.055.8-3.2,1.337,2.674,1.675-2.511L29.287,25.4h1.522v4.2A.4.4,0,0,1,30.409,30Z",
    fill: "#fff"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Packet_infrastructure",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.681,24.215l-2.646-4.7a2.27,2.27,0,0,1-1.823-.25l-3.928,3.927a2.373,2.373,0,0,1,.339,1.207A17.535,17.535,0,0,0,22.681,24.215Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.624,20.4c0-.055.012-.107.016-.162L21.435,18.5a2.384,2.384,0,0,1-.351.424l2.749,4.889a10.484,10.484,0,0,0,3.217-2.054A2.384,2.384,0,0,1,26.624,20.4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.224,12.4a2.374,2.374,0,0,1-.785-.142l-2.232,3.349a2.385,2.385,0,0,1,.617,1.593c0,.055-.013.107-.017.162L27.012,19.1a2.39,2.39,0,0,1,1.865-1.082,6.858,6.858,0,0,0-2.9-6.391A2.385,2.385,0,0,1,24.224,12.4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.436,22.339l3.927-3.927a2.336,2.336,0,0,1,0-2.424l-1.748-1.749a9.629,9.629,0,0,0-.728.848,11.958,11.958,0,0,0-2.2,6.959A2.383,2.383,0,0,1,13.436,22.339Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.212,15.139a2.3,2.3,0,0,1,2-.2l2.233-3.349a2.386,2.386,0,0,1-.419-.642A12.757,12.757,0,0,0,16.5,13.425Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.284,11.212l1.362,1.362a13.862,13.862,0,0,1,6.2-2.812c.006-.06.007-.122.018-.18a10.335,10.335,0,0,0-7.318-.151,2.278,2.278,0,0,1-.264,1.781Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.472,22.132a13.145,13.145,0,0,1,2.458-7.769,10.761,10.761,0,0,1,.834-.974l-1.328-1.328a2.354,2.354,0,0,1-2.122.158,10.363,10.363,0,0,0-.381,10.163A2.385,2.385,0,0,1,11.472,22.132Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.963,28.273l-1.676-2.98A15.622,15.622,0,0,1,18.524,26a21.488,21.488,0,0,1-4.215-.434,2.3,2.3,0,0,1-.238.348,12.323,12.323,0,0,0,10.181,3.809A2.375,2.375,0,0,1,24.963,28.273Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.95,22.536a11.727,11.727,0,0,1-3.529,2.323l1.591,2.829a2.418,2.418,0,0,1,.612-.088,2.373,2.373,0,0,1,1.19.328,7.049,7.049,0,0,0,1.2-5.128A2.4,2.4,0,0,1,27.95,22.536Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.424,20.4a2.393,2.393,0,0,0-1.359-2.153,8.057,8.057,0,0,0-3.521-7.664,2.388,2.388,0,0,0-4.162-2.105,11.349,11.349,0,0,0-8.421-.126,2.391,2.391,0,0,0-3.606,3.137,11.629,11.629,0,0,0-.276,11.854,2.388,2.388,0,0,0,3.031,3.283,13.358,13.358,0,0,0,10.28,4.293c.36,0,.692-.013,1.008-.031a2.4,2.4,0,1,0,4.267-2.135,8.271,8.271,0,0,0,1.521-6.266A2.389,2.389,0,0,0,31.424,20.4ZM15.615,14.239l1.748,1.749a2.336,2.336,0,0,0,0,2.424l-3.927,3.927a2.383,2.383,0,0,0-.754-.293,11.958,11.958,0,0,1,2.205-6.959A9.629,9.629,0,0,1,15.615,14.239Zm6.407-3.288a2.386,2.386,0,0,0,.419.642l-2.233,3.349a2.3,2.3,0,0,0-2,.2L16.5,13.425A12.757,12.757,0,0,1,22.022,10.951Zm2.2-2.151a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,24.224,8.8Zm-3.6,8.4a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,20.624,17.2Zm-9.6,7.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,11.024,24.4Zm3.6,0a2.373,2.373,0,0,0-.339-1.207l3.928-3.927a2.27,2.27,0,0,0,1.823.25l2.646,4.7A17.535,17.535,0,0,1,14.623,24.4Zm6.461-5.468a2.384,2.384,0,0,0,.351-.424l5.205,1.735c0,.055-.016.107-.016.162a2.384,2.384,0,0,0,.426,1.362,10.484,10.484,0,0,1-3.217,2.054Zm7.94,2.673a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,29.024,21.6Zm-.147-3.585A2.39,2.39,0,0,0,27.012,19.1l-5.205-1.735c0-.055.017-.107.017-.162a2.385,2.385,0,0,0-.617-1.593l2.232-3.349a2.338,2.338,0,0,0,2.542-.634A6.858,6.858,0,0,1,28.877,18.015ZM21.866,9.582c-.011.058-.012.12-.018.18a13.862,13.862,0,0,0-6.2,2.812l-1.362-1.362a2.278,2.278,0,0,0,.264-1.781A10.335,10.335,0,0,1,21.866,9.582ZM11.024,10a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,11.024,10Zm.29,2.219a2.354,2.354,0,0,0,2.122-.158l1.328,1.328a10.761,10.761,0,0,0-.834.974,13.145,13.145,0,0,0-2.458,7.769,2.385,2.385,0,0,0-.539.25A10.363,10.363,0,0,1,11.314,12.219Zm2.757,13.7a2.3,2.3,0,0,0,.238-.348A21.488,21.488,0,0,0,18.524,26a15.622,15.622,0,0,0,4.763-.707l1.676,2.98a2.375,2.375,0,0,0-.711,1.45A12.323,12.323,0,0,1,14.071,25.914ZM27.824,30a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,27.824,30Zm-.01-2.072a2.373,2.373,0,0,0-1.19-.328,2.418,2.418,0,0,0-.612.088l-1.591-2.829a11.727,11.727,0,0,0,3.529-2.323,2.4,2.4,0,0,0,1.068.264A7.049,7.049,0,0,1,27.814,27.928Z",
    fill: "#fff"
  }))))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Packet_services",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.608,20.4a2.394,2.394,0,0,1,2.254-2.385,6.858,6.858,0,0,0-2.9-6.391,2.338,2.338,0,0,1-2.542.634l-2.233,3.349A2.388,2.388,0,0,1,18.2,19.261l-3.927,3.927a2.376,2.376,0,0,1,.339,1.207c3.029.591,8.55.989,12.427-2.633A2.385,2.385,0,0,1,26.608,20.4Zm-1.591-.7-2-.665L23.4,17.9l2,.665Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.531,15.567a9.665,9.665,0,0,1,1.373-1.64l-.829-.868A10.945,10.945,0,0,0,13.531,14.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23,12.261a12.869,12.869,0,0,1,2-.849l-.379-1.139a14.209,14.209,0,0,0-2.184.929Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.618,20.1l1.187.172a12.744,12.744,0,0,1,.489-2.117l-1.141-.372A13.9,13.9,0,0,0,11.618,20.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.608,
    y: 17.747,
    width: 1.201,
    height: 2.105,
    transform: "matrix(0.316, -0.949, 0.949, 0.316, -1.281, 35.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.579,26.486l1.114.447a8.159,8.159,0,0,0,.557-2.357l-1.2-.1A6.922,6.922,0,0,1,28.579,26.486Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.479,8.944l.182-1.186a11.365,11.365,0,0,0-2.95-.073l.128,1.194A10.171,10.171,0,0,1,19.479,8.944Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.786,18.463l-1.194.114a12.062,12.062,0,0,0,.444,2.278l1.151-.339A11,11,0,0,1,9.786,18.463Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.517,13.712l-1.106-.467a11.075,11.075,0,0,0-.679,2.23l1.179.225A9.806,9.806,0,0,1,10.517,13.712Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.838,30.566a15.454,15.454,0,0,0,2.423.339l.074-1.2A14.256,14.256,0,0,1,20.1,29.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666,28.141a12.043,12.043,0,0,0,2.082,1.332l.54-1.071a10.812,10.812,0,0,1-1.875-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.208,12.4a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,12.208,12.4Zm1.2-2.4a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,13.408,10Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.608,27.6a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,26.608,27.6Zm0,3.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,26.608,31.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.05,18.247a8.056,8.056,0,0,0-3.521-7.664,2.4,2.4,0,1,0-4.1,1.01l-2.232,3.349a2.374,2.374,0,0,0-.785-.142,2.4,2.4,0,0,0-2.4,2.4,2.372,2.372,0,0,0,.34,1.212l-3.927,3.927a2.4,2.4,0,1,0,.873,3.227A21.486,21.486,0,0,0,18.508,26a13.211,13.211,0,0,0,9.427-3.464,2.391,2.391,0,1,0,2.115-4.289ZM29.008,21.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,29.008,21.6ZM25.408,10a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,25.408,10Zm-7.2,7.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,18.208,17.2Zm-4.8,7.2a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,13.408,24.4Zm1.2,0a2.376,2.376,0,0,0-.339-1.207L18.2,19.261a2.389,2.389,0,0,0,2.995-3.654l2.233-3.349a2.338,2.338,0,0,0,2.542-.634,6.858,6.858,0,0,1,2.9,6.391,2.388,2.388,0,0,0-1.827,3.747C23.158,25.384,17.637,24.986,14.608,24.4Z",
    fill: "#fff"
  }))))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Performance_browser",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.365,13.323a.6.6,0,0,0-.742.412l-2.677,9.37a2,2,0,1,0,1.154.328l2.677-9.368A.6.6,0,0,0,23.365,13.323ZM20,25.9a.8.8,0,1,1,.8-.8A.8.8,0,0,1,20,25.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.132,19.623v-.011c-.021-.039-.045-.075-.066-.113-.108-.2-.222-.4-.341-.591-.023-.037-.042-.075-.065-.111l-.008-.007a12.62,12.62,0,0,0-3.945-3.951l0-.006c-.029-.019-.06-.034-.09-.052-.11-.068-.217-.14-.33-.205a.41.41,0,0,0-.059-.02c-.112-.064-.221-.133-.335-.194a.2.2,0,0,0-.277.085l-1.122,2.116a.2.2,0,0,0-.015.156.2.2,0,0,0,.1.121c.216.114.428.237.634.366a.191.191,0,0,0,.109.032.23.23,0,0,0,.045,0,.205.205,0,0,0,.128-.091l.745-1.184a11.425,11.425,0,0,1,3.3,3.305l-1.184.745a.2.2,0,0,0-.09.128.2.2,0,0,0,.026.154c.13.206.251.417.366.634a.2.2,0,0,0,.181.108.214.214,0,0,0,.095-.023l1.237-.654A11.377,11.377,0,0,1,31.4,25.5a.6.6,0,0,0,1.2,0A12.576,12.576,0,0,0,31.132,19.623Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.869,15.334a11.308,11.308,0,0,1,4.5-1.2l.055,1.384a.2.2,0,0,0,.205.2h.008c.241-.011.485-.01.727,0a.2.2,0,0,0,.212-.2l.093-2.394a.2.2,0,0,0-.2-.213c-.142-.005-.287,0-.431,0-.016,0-.03-.009-.047-.009-.064,0-.125.009-.189.009-.094,0-.187,0-.281,0-.013,0-.021.013-.034.016a12.513,12.513,0,0,0-5.357,1.43c-.006,0-.013,0-.019,0-.028.015-.053.031-.08.046-.059.032-.116.068-.175.1-.19.107-.382.212-.559.324-.011.007-.011.02-.021.029a12.685,12.685,0,0,0-3.923,3.92s-.013.006-.016.012c-.066.1-.122.212-.185.318A12.509,12.509,0,0,0,7.4,25.5a.6.6,0,0,0,1.2,0,11.318,11.318,0,0,1,1.244-5.152L11.075,21a.2.2,0,0,0,.277-.085c.115-.215.237-.428.367-.635A.2.2,0,0,0,11.655,20l-1.182-.744a11.474,11.474,0,0,1,3.3-3.295l.741,1.176a.2.2,0,0,0,.128.092.222.222,0,0,0,.045,0A.2.2,0,0,0,14.8,17.2c.206-.129.418-.252.634-.366a.2.2,0,0,0,.085-.276Z",
    fill: "#fff"
  }))))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Permisssions",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.218,30.455a7.162,7.162,0,0,1,.294.945H7.473a6.454,6.454,0,0,1,1.773-3.57,12.28,12.28,0,0,1,6.909-2.951H16.2a.557.557,0,0,0,.092,0l.366-.022a.6.6,0,0,0,.562-.542c.036-.177.261-.983.465-1.688a.6.6,0,0,0-.3-.7c-1.059-.544-1.415-1.956-1.713-3.479a.6.6,0,0,0-.589-.485c-.442,0-.6-.4-.6-.747a.525.525,0,0,0-.006-.079l-.148-1.1a.745.745,0,0,1,.223-.49.815.815,0,0,1,.233-.16.6.6,0,0,0,.327-.686A4.922,4.922,0,0,1,19.8,8.6h.14a4.922,4.922,0,0,1,4.684,6.1.6.6,0,0,0,.328.686.845.845,0,0,1,.234.161.761.761,0,0,1,.227.444L25.25,17.2h1.2l.148-1.134A1.926,1.926,0,0,0,26.03,14.7a1.494,1.494,0,0,0-.157-.14A6.122,6.122,0,0,0,19.941,7.4h-.155a6.113,6.113,0,0,0-6.014,6.111,6.239,6.239,0,0,0,.088,1.043,1.882,1.882,0,0,0-.155.14,1.925,1.925,0,0,0-.575,1.372.525.525,0,0,0,.006.079l.149,1.11a1.849,1.849,0,0,0,1.293,1.836,5.818,5.818,0,0,0,1.832,3.635c-.123.429-.208.733-.266.953A13.287,13.287,0,0,0,8.431,26.95a7.832,7.832,0,0,0-2.254,4.977.6.6,0,0,0,.6.673H33.227a.6.6,0,0,0,.6-.673A8.243,8.243,0,0,0,33.2,29.7,3.187,3.187,0,0,1,32.218,30.455Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6,20.8a2.2,2.2,0,0,0-2.2-2.2H24a2.2,2.2,0,0,0-2.2,2.2v6.4A2.2,2.2,0,0,0,24,29.4h6.4a2.2,2.2,0,0,0,2.2-2.2Zm-2.2,7.4H24a1,1,0,0,1-1-1V20.8a1,1,0,0,1,1-1h6.4a1,1,0,0,1,1,1v6.4A1,1,0,0,1,30.4,28.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.806,22.222l4.8-.044a.6.6,0,1,0-.011-1.2l-4.8.044a.6.6,0,1,0,.011,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,24.6a.6.6,0,1,0,0-1.2H24.8a.6.6,0,1,0,0,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,27a.6.6,0,0,0,0-1.2H24.8a.6.6,0,1,0,0,1.2Z",
    fill: "#fff"
  }))))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Pm_collection_dashbaord",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,8.8H9.6A1.6,1.6,0,0,0,8,10.4V29.6a1.6,1.6,0,0,0,1.6,1.6H30.4A1.6,1.6,0,0,0,32,29.6V10.4A1.6,1.6,0,0,0,30.4,8.8Zm0,21.2H9.6a.4.4,0,0,1-.4-.4V12H30.8V29.6A.4.4,0,0,1,30.4,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 15.2,
    width: 2.4,
    height: 4.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 19.849,
    width: 2.4,
    height: 7.351,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 19.2,
    width: 2.4,
    height: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,26H24.6a.6.6,0,1,0,0,1.2h3.6a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,22.8H24.6a.6.6,0,1,0,0,1.2h3.6a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,19.6H24.6a.6.6,0,1,0,0,1.2h3.6a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6,17.6h3.6a.6.6,0,1,0,0-1.2H24.6a.6.6,0,0,0,0,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 21.449,
    width: 2.4,
    height: 5.751,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 15.2,
    width: 2.4,
    height: 3.049,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 15.2,
    width: 2.4,
    height: 2.551,
    fill: "#fff"
  }))))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Problem_analysis_beta",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#099"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,8.8H9.6A1.6,1.6,0,0,0,8,10.4V29.6a1.6,1.6,0,0,0,1.6,1.6H30.4A1.6,1.6,0,0,0,32,29.6h0V10.4A1.6,1.6,0,0,0,30.4,8.8Zm0,21.2H9.6a.4.4,0,0,1-.4-.4V12H30.8V29.6A.4.4,0,0,1,30.4,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 16,
    r: 1.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.8,
    cy: 20.4,
    r: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 14.4,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.87,
    cy: 17.512,
    r: 2.488,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,22.8H28.2a.6.6,0,0,1,.6.6h0a.6.6,0,0,1-.6.6H11.8a.6.6,0,0,1-.6-.6h0A.6.6,0,0,1,11.8,22.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,25H28.2a.6.6,0,0,1,.6.6h0a.6.6,0,0,1-.6.6H11.8a.6.6,0,0,1-.6-.6h0A.6.6,0,0,1,11.8,25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,27.4H28.2a.6.6,0,0,1,.6.6h0a.6.6,0,0,1-.6.6H11.8a.6.6,0,0,1-.6-.6h0A.6.6,0,0,1,11.8,27.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 14.8,
    r: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.2,
    cy: 19.2,
    r: 1.6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M13,27H40v9a4,4,0,0,1-4,4H9V31A4,4,0,0,1,13,27Z",
    fill: "#8e1b68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Connected"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.105,37.261V29.507h2.717a3.567,3.567,0,0,1,2.141.54,1.854,1.854,0,0,1,.727,1.585,1.752,1.752,0,0,1-.293,1,1.688,1.688,0,0,1-.818.636,1.634,1.634,0,0,1,.94.6,1.777,1.777,0,0,1,.343,1.108,2.044,2.044,0,0,1-.713,1.693,3.208,3.208,0,0,1-2.029.59ZM15.7,32.756h1.182q1.21-.023,1.209-.965a.89.89,0,0,0-.3-.759,1.623,1.623,0,0,0-.966-.231H15.7Zm0,1.129v2.09h1.369a1.323,1.323,0,0,0,.882-.273.917.917,0,0,0,.316-.742.973.973,0,0,0-.848-1.084.939.939,0,0,0-.254,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.617,37.368a2.83,2.83,0,0,1-2.063-.778,2.763,2.763,0,0,1-.8-2.072v-.149a3.481,3.481,0,0,1,.335-1.552,2.463,2.463,0,0,1,.951-1.055,2.68,2.68,0,0,1,1.4-.37,2.392,2.392,0,0,1,1.862.746,3.033,3.033,0,0,1,.679,2.114v.629h-3.67a1.428,1.428,0,0,0,.454.909,1.357,1.357,0,0,0,.95.34,1.656,1.656,0,0,0,1.39-.644l.757.847a2.317,2.317,0,0,1-.937.764A3.086,3.086,0,0,1,23.617,37.368Zm-.175-4.735a.962.962,0,0,0-.744.311,1.613,1.613,0,0,0-.363.888h2.141v-.124a1.15,1.15,0,0,0-.272-.794A1,1,0,0,0,23.442,32.633Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7,30.081V31.5h.985v1.127H28.7V35.5a.687.687,0,0,0,.122.455.612.612,0,0,0,.468.139,2.473,2.473,0,0,0,.455-.037v1.166a3.164,3.164,0,0,1-.932.138A1.469,1.469,0,0,1,27.168,36.1a1.448,1.448,0,0,1,0-.372v-3.1h-.841V31.5h.841V30.081Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.885,37.261a1.727,1.727,0,0,1-.154-.516,1.863,1.863,0,0,1-1.454.623,2.052,2.052,0,0,1-1.4-.49,1.577,1.577,0,0,1-.557-1.236A1.629,1.629,0,0,1,31,34.236a3.344,3.344,0,0,1,1.963-.495h.708v-.33a.939.939,0,0,0-.2-.636.8.8,0,0,0-.647-.24.913.913,0,0,0-.609.182.634.634,0,0,0-.221.51H30.445a1.546,1.546,0,0,1,.309-.926,2.029,2.029,0,0,1,.874-.668A3.18,3.18,0,0,1,32.9,31.39a2.514,2.514,0,0,1,1.691.536,1.868,1.868,0,0,1,.626,1.5v2.5a2.739,2.739,0,0,0,.229,1.24v.093ZM32.613,36.19a1.316,1.316,0,0,0,.63-.151.993.993,0,0,0,.426-.408v-.99h-.575q-1.157,0-1.231.8v.091a.617.617,0,0,0,.2.473A.782.782,0,0,0,32.613,36.19Z",
    fill: "#fff"
  }))))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Problem_analysis",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,8.8H9.6A1.6,1.6,0,0,0,8,10.4V29.6a1.6,1.6,0,0,0,1.6,1.6H30.4A1.6,1.6,0,0,0,32,29.6V10.4A1.6,1.6,0,0,0,30.4,8.8Zm0,21.2H9.6a.4.4,0,0,1-.4-.4V12H30.8V29.6A.4.4,0,0,1,30.4,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 16,
    r: 1.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.8,
    cy: 20.4,
    r: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 14.4,
    r: 0.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.87,
    cy: 17.512,
    r: 2.488,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 22.8,
    width: 17.6,
    height: 1.2,
    rx: 0.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 25,
    width: 17.6,
    height: 1.2,
    rx: 0.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 27.4,
    width: 17.6,
    height: 1.2,
    rx: 0.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 14.8,
    r: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.2,
    cy: 19.2,
    r: 1.6,
    fill: "#fff"
  })))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Projects",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8,7.2H10.4a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8H29.6a.8.8,0,0,0,.8-.8V13.6Zm4.4,24.4H10.8V8.4H24v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.583,15.334a1.98,1.98,0,0,0,.23-.913,2,2,0,1,0-2.739,1.855l-.546,8.186A2,2,0,1,0,18,26.4a2.039,2.039,0,0,0-.035-.352l5.024-2.631a2.008,2.008,0,1,0,.492-3.184Zm3.852,7.018-5.024,2.631a2,2,0,0,0-.686-.442l.545-8.178a1.928,1.928,0,0,0,.466-.178l4.9,4.9A1.982,1.982,0,0,0,22.4,22,2.049,2.049,0,0,0,22.435,22.352Z",
    fill: "#fff"
  }))))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Repeater_system_scanner",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.369,24.506H24.913a8.605,8.605,0,0,0,.849-10.167l1.87-2.08a2.96,2.96,0,0,0,1,.184,3.005,3.005,0,1,0-2.756-1.819l-1.666,1.853A8.595,8.595,0,0,0,12.368,24.93c.113.113.235.214.353.32L10.78,27.408a2.947,2.947,0,0,0-.937-.165,3,3,0,1,0,3,3,2.973,2.973,0,0,0-.274-1.236L14.735,26.6a8.555,8.555,0,0,0,9.371-1.284v1.454l6.788,6.788,2.263-2.263ZM11.643,30.243a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,11.643,30.243Zm1.574-6.162a7.353,7.353,0,0,1-2.03-3.825H15.22l.261-.523L16.965,22.7,18.1,17.606l1.671,5.569,1.216-2.432.42,1.681,1.666-.832,1.122.561h.872a7.393,7.393,0,0,1-11.847,1.928Zm5.232-12.632a7.4,7.4,0,0,1,7.093,9.5H24.476l-1.406-.7-.864.433L21.361,17.3l-1.313,2.627-2.124-7.078-1.4,6.288L15.481,17.05l-1,2.006H11.063a7.384,7.384,0,0,1,7.386-7.607Zm8.382-2.006a1.8,1.8,0,1,1,1.8,1.8A1.8,1.8,0,0,1,26.831,9.443Z",
    fill: "#fff"
  })))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Reporting",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8,7.2H10.4a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8H29.6a.8.8,0,0,0,.8-.8V13.6Zm4.4,24.4H10.8V8.4H24v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 20,
    width: 2.4,
    height: 9.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22.4,
    width: 2.4,
    height: 7.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 16,
    width: 2.4,
    height: 13.6,
    fill: "#fff"
  }))))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Resource_partitions",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.7,8.572v2.836A7.194,7.194,0,0,1,28.592,17.3h2.836A10.019,10.019,0,0,0,22.7,8.572Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,12.621V17.3h4.679A6.018,6.018,0,0,0,22.7,12.621Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,10.316A10.6,10.6,0,1,0,29.683,21.5H18.5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,9.1h-.6A11.8,11.8,0,1,0,30.9,20.9v-.6H19.7Zm9.983,12.4A10.6,10.6,0,1,1,18.5,10.316V21.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7,18.5A11.2,11.2,0,0,0,21.5,7.3V18.5H32.7Zm-10-1.2V12.621A6.018,6.018,0,0,1,27.379,17.3Zm0-5.892V8.572A10.019,10.019,0,0,1,31.428,17.3H28.592A7.194,7.194,0,0,0,22.7,11.408Z",
    fill: "#fff"
  }))))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Roles",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.2,29.7a3.187,3.187,0,0,1-.982.759,7.162,7.162,0,0,1,.294.945H7.473a6.454,6.454,0,0,1,1.773-3.57,12.28,12.28,0,0,1,6.909-2.951H16.2a.9.9,0,0,0,.092,0l.366-.022a.6.6,0,0,0,.562-.542c.036-.177.261-.983.465-1.688a.6.6,0,0,0-.3-.7c-1.059-.544-1.415-1.956-1.713-3.479a.6.6,0,0,0-.589-.485c-.442,0-.6-.4-.6-.747a.525.525,0,0,0-.006-.079l-.148-1.1a.745.745,0,0,1,.223-.49.815.815,0,0,1,.233-.16.6.6,0,0,0,.327-.686A4.922,4.922,0,0,1,19.8,8.6h.14a4.922,4.922,0,0,1,4.684,6.1.6.6,0,0,0,.328.686.845.845,0,0,1,.234.161.761.761,0,0,1,.227.444L25.25,17.2h1.2l.148-1.134A1.926,1.926,0,0,0,26.03,14.7a1.494,1.494,0,0,0-.157-.14A6.122,6.122,0,0,0,19.941,7.4h-.155a6.113,6.113,0,0,0-6.014,6.111,6.239,6.239,0,0,0,.088,1.043,1.882,1.882,0,0,0-.155.14,1.925,1.925,0,0,0-.575,1.372.525.525,0,0,0,.006.079l.149,1.11a1.849,1.849,0,0,0,1.293,1.836,5.818,5.818,0,0,0,1.832,3.635c-.123.429-.208.733-.266.953A13.287,13.287,0,0,0,8.431,26.95a7.832,7.832,0,0,0-2.254,4.977.6.6,0,0,0,.6.673H33.227a.6.6,0,0,0,.6-.673A8.243,8.243,0,0,0,33.2,29.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,20.8v6.4A2.2,2.2,0,0,0,24,29.4h6.4a2.2,2.2,0,0,0,2.2-2.2V20.8a2.2,2.2,0,0,0-2.2-2.2H24A2.2,2.2,0,0,0,21.8,20.8Zm9.6,0v6.4a1,1,0,0,1-1,1H24a1,1,0,0,1-1-1V20.8a1,1,0,0,1,1-1h6.4A1,1,0,0,1,31.4,20.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.908,25.974a.6.6,0,0,0,.849,0l3.15-3.15a.6.6,0,1,0-.849-.848L26.332,24.7l-.99-.991a.6.6,0,1,0-.849.848Z",
    fill: "#fff"
  }))))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Security_audit_dashboard",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.4,8.8H9.6A1.6,1.6,0,0,0,8,10.4V29.6a1.6,1.6,0,0,0,1.6,1.6H30.4A1.6,1.6,0,0,0,32,29.6V10.4A1.6,1.6,0,0,0,30.4,8.8Zm0,21.2H9.6a.4.4,0,0,1-.4-.4V12H30.8V29.6A.4.4,0,0,1,30.4,30Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,22.6H12.6a.6.6,0,1,0,0,1.2H27.4a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,25.8H12.6a.6.6,0,1,0,0,1.2H27.4a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 16.8,
    width: 2.4,
    height: 3.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 14.4,
    width: 2.4,
    height: 5.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 16.267,
    width: 2.4,
    height: 3.733,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 17.6,
    width: 2.4,
    height: 2.4,
    fill: "#fff"
  }))))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Security",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,14.961v2.368H22V14.961a2,2,0,1,0-3.992,0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6,10.438V21.507a8.377,8.377,0,0,0,4.28,7.3L20,31.677l5.12-2.867a8.377,8.377,0,0,0,4.28-7.3V10.438L20,8.182Zm12.6,4.523v2.368h1.15a1.4,1.4,0,0,1,1.4,1.4V24.64a1.4,1.4,0,0,1-1.4,1.4H15.654a1.4,1.4,0,0,1-1.4-1.4V18.729a1.4,1.4,0,0,1,1.4-1.4H16.8V14.961a3.2,3.2,0,0,1,6.392,0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.948,9.4,9.492V21.507a9.578,9.578,0,0,0,4.894,8.35L20,33.052l5.7-3.195a9.577,9.577,0,0,0,4.9-8.35V9.492Zm9.4,14.559a8.377,8.377,0,0,1-4.28,7.3L20,31.677,14.88,28.81a8.377,8.377,0,0,1-4.28-7.3V10.438L20,8.182l9.4,2.256Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,14.961v2.368h-1.15a1.4,1.4,0,0,0-1.4,1.4V24.64a1.4,1.4,0,0,0,1.4,1.4h8.692a1.4,1.4,0,0,0,1.4-1.4V18.729a1.4,1.4,0,0,0-1.4-1.4H23.2V14.961a3.2,3.2,0,0,0-6.392,0Zm7.742,3.768V24.64a.2.2,0,0,1-.2.2H15.654a.2.2,0,0,1-.2-.2V18.729a.2.2,0,0,1,.2-.2h8.692A.2.2,0,0,1,24.546,18.729ZM22,14.961v2.368H18V14.961a2,2,0,1,1,3.992,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,20.165a.6.6,0,0,0-.6.6v1.6a.6.6,0,0,0,1.2,0v-1.6A.6.6,0,0,0,20,20.165Z",
    fill: "#fff"
  }))))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Service_impact_reports",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.012,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.812,7.2h-14.4a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8h19.2a.8.8,0,0,0,.8-.8V13.6Zm4.4,24.4h-18.4V8.4h13.2v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.612,
    y: 22.4,
    width: 2.4,
    height: 7.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.012,
    y: 24.8,
    width: 2.4,
    height: 4.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.812,
    y: 20,
    width: 2.4,
    height: 9.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.212,14.2h8a.6.6,0,1,0,0-1.2h-8a.6.6,0,1,0,0,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.612,16.8a.6.6,0,0,0,.6.6h13.4a.6.6,0,1,0,0-1.2h-13.4A.6.6,0,0,0,12.612,16.8Z",
    fill: "#fff"
  }))))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Spectrum_sharing",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2,15V8.6H24.8v2.6H24a4.582,4.582,0,0,0-3.4,1.513V8.6H19.4v4.113A4.578,4.578,0,0,0,16,11.2h-.8V8.6H8.8V15h6.4V12.4H16a3.4,3.4,0,0,1,3.4,3.4v1H16.8v6.4h2.6v1A3.4,3.4,0,0,1,16,27.6h-.8V25H8.8v6.4h6.4V28.8H16a4.578,4.578,0,0,0,3.4-1.513V31.4h1.2V27.287A4.582,4.582,0,0,0,24,28.8h.8v2.6h6.4V25H24.8v2.6H24a3.4,3.4,0,0,1-3.4-3.4v-1h2.6V16.8H20.6v-1A3.4,3.4,0,0,1,24,12.4h.8V15ZM14,13.8H10v-4h4Zm0,16.4H10v-4h4Zm12-4h4v4H26ZM22,18v4H18V18Zm4-8.2h4v4H26Z",
    fill: "#fff"
  })))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_System_backups",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.7,31.091H9.9V24.533H20.171a6.985,6.985,0,0,1-.851-1.249H9.9V16.727h9.414a7.012,7.012,0,0,1,.857-1.26H9.9V8.909H26.7v4.2a7.064,7.064,0,0,1,1.2.32V8.509a.8.8,0,0,0-.8-.8H9.5a.8.8,0,0,0-.8.8V32.291H27.9v-5.72a7.064,7.064,0,0,1-1.2.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.179,10.92a1.28,1.28,0,1,0,1.28,1.279A1.279,1.279,0,0,0,13.179,10.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.179,21.285a1.28,1.28,0,1,0-1.28-1.28A1.28,1.28,0,0,0,13.179,21.285Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.179,29.092a1.28,1.28,0,1,0-1.28-1.28A1.28,1.28,0,0,0,13.179,29.092Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,14.2A5.8,5.8,0,1,0,31.3,20,5.807,5.807,0,0,0,25.5,14.2Zm0,10.4A4.6,4.6,0,1,1,30.1,20,4.605,4.605,0,0,1,25.5,24.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,16.8a.6.6,0,0,0-.6.6v3.2h2.333a.6.6,0,1,0,0-1.2H26.1v-2A.6.6,0,0,0,25.5,16.8Z",
    fill: "#fff"
  }))))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_System_profiles",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M15.2-32l5.6,6.4V-7.2a.8.8,0,0,1-.8.8H.8A.8.8,0,0,1,0-7.2H0v-24A.8.8,0,0,1,.8-32H15.2Zm-.8,1.2H1.2V-7.6H19.6V-24.8H14.4ZM17-11a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6H11a.6.6,0,0,1-.6-.6A.6.6,0,0,1,11-11h6Zm0-2.4a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6H11a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6h6Zm0-2.4a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6H3.6a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6H17Zm0-2.4a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6H11a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6h6Zm0-2.4a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6H11a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6h6ZM17-23a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6H3.6a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6H17Z",
    transform: "translate(9.6 39.2)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M1.826,5h0l-.064-.029c-.03-.014-.057-.025-.1-.042h0l-.053-.022a2.775,2.775,0,0,1-.315-.145l-.009,0-.037-.019V4.693a.957.957,0,0,1,.008-.116V4.57a.713.713,0,0,0,.008-.1.73.73,0,0,0-.727-.73c-.052,0-.078,0-.109,0a.428.428,0,0,0-.1.013l-.051.012L.252,3.72a1.29,1.29,0,0,1-.2-.5L.041,3.174l.034-.029a.786.786,0,0,0,.286-.589.746.746,0,0,0-.316-.6L0,1.923l.014-.051a2.33,2.33,0,0,1,.1-.294C.147,1.5.175,1.433.239,1.3L.263,1.24H.312a.648.648,0,0,1,.1.009.716.716,0,0,0,.109.008A.713.713,0,0,0,1.248.525c0-.054,0-.079,0-.109a.446.446,0,0,0-.012-.1L1.221.261l.05-.027a2.594,2.594,0,0,1,.52-.216L1.85,0l.028.055a.728.728,0,0,0,.649.4.758.758,0,0,0,.632-.4L3.187,0l.056.015a2.185,2.185,0,0,1,.521.217L3.8.256V.3a.9.9,0,0,1-.009.108c0,.011,0,.02,0,.028V.445a.649.649,0,0,0,0,.067.729.729,0,0,0,.727.73c.042,0,.065,0,.091,0a.254.254,0,0,0,.077-.012l.062-.021.031.055a2.918,2.918,0,0,1,.214.556L5,1.874l-.05.03a.737.737,0,0,0-.363.636.809.809,0,0,0,.336.641l.042.032-.016.051a3.193,3.193,0,0,1-.2.448l-.021.041H4.686a.73.73,0,0,1-.076-.006l-.029,0a.639.639,0,0,0-.086-.007.712.712,0,0,0-.727.73v.072a.4.4,0,0,0,.013.113l.02.059-.054.031a2.179,2.179,0,0,1-.522.233l-.057.015-.029-.053a.713.713,0,0,0-1.28,0L1.826,5ZM2.5,1.189A1.311,1.311,0,1,0,3.8,2.5,1.309,1.309,0,0,0,2.5,1.189Z",
    transform: "translate(13 10)",
    fill: "#fff"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_System_services",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.006,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.806,7.2h-14.4a.8.8,0,0,0-.8.8V32a.8.8,0,0,0,.8.8h19.2a.8.8,0,0,0,.8-.8V13.6Zm4.4,24.4h-18.4V8.4h13.2v6h5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.606,16.8a.6.6,0,0,0,.6.6h13.4a.6.6,0,1,0,0-1.2h-13.4A.6.6,0,0,0,12.606,16.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606,18.6h-6a.6.6,0,1,0,0,1.2h6a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606,21h-6a.6.6,0,1,0,0,1.2h6a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606,23.4h-13.4a.6.6,0,1,0,0,1.2h13.4a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606,25.8h-6a.6.6,0,1,0,0,1.2h6a.6.6,0,0,0,0-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606,28.2h-6a.6.6,0,1,0,0,1.2h6a.6.6,0,1,0,0-1.2Z",
    fill: "#fff"
  }))))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Transport_infrastructure",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.041,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.349,19.058a2.407,2.407,0,0,0-1.056-.869A2.379,2.379,0,0,0,28.359,18a2.4,2.4,0,0,0-.427.043l-2.854-6.185a2.4,2.4,0,0,0-.585-4.069,2.4,2.4,0,0,0-2.71.6,2.438,2.438,0,0,0-.214.272,2.371,2.371,0,0,0-.328.742H13.877a2.371,2.371,0,0,0-.328-.742,2.389,2.389,0,0,0-1.056-.869,2.4,2.4,0,0,0-2.71.6,2.438,2.438,0,0,0-.214.272,2.4,2.4,0,0,0,1.056,3.553,2.314,2.314,0,0,0,.334.1v9.77a2.314,2.314,0,0,0-.334.1,2.4,2.4,0,0,0,.934,4.611,2.379,2.379,0,0,0,.934-.189A2.406,2.406,0,0,0,13.5,25.8L23.58,29.719a2.6,2.6,0,0,0-.021.281A2.4,2.4,0,1,0,27.1,27.9l1.275-5.1a2.382,2.382,0,0,0,.915-.187,2.4,2.4,0,0,0,1.056-3.553ZM23.559,8.8a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,23.559,8.8Zm-.784,3.458a2.373,2.373,0,0,0,.784.142,2.4,2.4,0,0,0,.427-.043l2.855,6.185a2.412,2.412,0,0,0-.472.516c-.008.012-.014.026-.022.038l-5.2-1.733c0-.054.012-.108.012-.163a2.382,2.382,0,0,0-.612-1.6Zm-8.9-1.658h7.364a2.371,2.371,0,0,0,.328.742,2.4,2.4,0,0,0,.2.258l-2.229,3.342a2.323,2.323,0,0,0-1.718.047,1.977,1.977,0,0,0-.279.151l0-.006-3.919-3.919A2.363,2.363,0,0,0,13.877,10.6Zm6.082,6.6a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,19.959,17.2Zm-9.6-7.2a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,10.359,10Zm1.2,15.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,11.559,25.6Zm1.218-3.266a2.23,2.23,0,0,0-.284-.145,2.314,2.314,0,0,0-.334-.1v-9.77a2.314,2.314,0,0,0,.334-.1,2.23,2.23,0,0,0,.284-.145L16.7,15.985a2.359,2.359,0,0,0,0,2.43ZM24.015,28.6,13.938,24.681a2.351,2.351,0,0,0,.021-.281,2.378,2.378,0,0,0-.337-1.215l3.919-3.919a2.305,2.305,0,0,0,1.83.245L24.3,28.275A2.386,2.386,0,0,0,24.015,28.6ZM27.159,30a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,27.159,30ZM25.94,27.6a2.358,2.358,0,0,0-.592.087l-4.93-8.763a2.422,2.422,0,0,0,.331-.384c.008-.012.014-.026.022-.038l5.2,1.733c0,.054-.012.108-.012.163a2.379,2.379,0,0,0,1.256,2.1Zm2.419-6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,28.359,21.6Z",
    fill: "#fff"
  })))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Transport_routes",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.041,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.797,
    y: 9.406,
    width: 3.52,
    height: 1.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.067,
    y: 13.006,
    width: 2.181,
    height: 1.2,
    transform: "translate(-1.899 23.663) rotate(-56.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.357,
    y: 13.555,
    width: 1.2,
    height: 3.302,
    transform: "translate(-3.983 12.278) rotate(-24.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.597,
    y: 20.194,
    width: 1.201,
    height: 2.702,
    transform: "translate(-7.841 13.16) rotate(-29.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.917,
    y: 24.316,
    width: 1.201,
    height: 2.702,
    transform: "translate(-9.564 14.826) rotate(-29.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.76,
    y: 20.206,
    width: 2.793,
    height: 1.2,
    transform: "translate(-10.273 16.811) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.556,
    y: 12.209,
    width: 1.2,
    height: 2.793,
    transform: "translate(-5.181 14.702) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.957,
    y: 13.583,
    width: 1.2,
    height: 2.635,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.957,
    y: 18.194,
    width: 1.2,
    height: 2.635,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.508,
    y: 26.678,
    width: 1.201,
    height: 2.883,
    transform: "translate(-12.752 37.595) rotate(-68.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.807,
    y: 24.85,
    width: 1.201,
    height: 2.882,
    transform: "translate(-14.043 32.055) rotate(-68.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.818,
    y: 24.606,
    width: 2.678,
    height: 1.2,
    transform: "translate(-3.883 45.439) rotate(-75.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.957,
    y: 17.422,
    width: 1.201,
    height: 2.768,
    transform: "translate(-1.733 35.207) rotate(-71.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.157,17.206a2.4,2.4,0,1,0-2.4,2.4A2.4,2.4,0,0,0,21.157,17.206Zm-1.2,0a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,19.957,17.206Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.557,22.006a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,11.557,22.006Zm0,1.2a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,11.557,23.206Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.557,12.406a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,11.557,12.406Zm0-3.6a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,11.557,8.806Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.357,18.006a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,28.357,18.006Zm0,3.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,28.357,21.606Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.957,27.606a2.4,2.4,0,1,0,2.4,2.4A2.4,2.4,0,0,0,25.957,27.606Zm0,3.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,25.957,31.206Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.557,12.406a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,23.557,12.406Zm0-3.6a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,23.557,8.806Z",
    fill: "#fff"
  }))))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Transport_services",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.19,28.658a2.352,2.352,0,0,0-2.6-.97L21.66,18.927l.014-.015a2.423,2.423,0,0,0,.316-.37,2.4,2.4,0,0,0-2.924-3.553,2.23,2.23,0,0,0-.284.145l-3.919-3.919a2.382,2.382,0,0,0,.312-.879A2.331,2.331,0,0,0,15.2,10a2.4,2.4,0,1,0-1.466,2.211,2.23,2.23,0,0,0,.284-.145l3.919,3.919a2.382,2.382,0,0,0-.312.879,2.331,2.331,0,0,0-.025.336,2.371,2.371,0,0,0,3.011,2.312l4.929,8.761-.013.015a2.388,2.388,0,0,0-.317,3.054,2.4,2.4,0,0,0,3.98-2.684ZM12.8,11.2A1.2,1.2,0,1,1,14,10,1.2,1.2,0,0,1,12.8,11.2ZM20,18.4a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,20,18.4Zm7.2,12.8A1.2,1.2,0,1,1,28.4,30,1.2,1.2,0,0,1,27.2,31.2Z",
    fill: "#fff"
  })))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_Tunnel_re_route_operations",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23.025,
    y: 17.337,
    width: 1.199,
    height: 1.388,
    transform: "translate(2.436 38.871) rotate(-81.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.068,
    y: 21.83,
    width: 1.516,
    height: 1.199,
    transform: "translate(-12.047 23.315) rotate(-58.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.123,24.052l-.794,1.292.012.007a2.382,2.382,0,1,0,1.011.618l.793-1.289Zm-1.5,4.778a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,11.625,28.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.225,27.63a2.431,2.431,0,0,0-.611.088l-4.929-8.76a2.407,2.407,0,0,0,.556-.8l1.239.177.169-1.187L20.4,16.964a2.374,2.374,0,0,0-3.585-1.794l-3.927-3.927a2.426,2.426,0,1,0-.849.848l3.928,3.928a2.362,2.362,0,0,0,.334,2.872l-.793,1.289,1.022.628.8-1.292-.01,0a2.177,2.177,0,0,0,1.324.032l4.928,8.76a2.395,2.395,0,1,0,1.66-.673Zm-8.4-10.4a1.2,1.2,0,1,1,1.2,1.2A1.2,1.2,0,0,1,16.825,17.231Zm-6-8.4a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,10.825,8.831Zm14.4,22.4a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,25.225,31.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.225,16.431a2.4,2.4,0,0,0-2.215,1.477l-1.239-.177-.17,1.188,1.252.178a2.394,2.394,0,1,0,2.372-2.666Zm0,3.6a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,29.225,20.031Z",
    fill: "#fff"
  }))))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "MCP_app_menu_User_accounts",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.227,32.6H6.773a.6.6,0,0,1-.6-.673A7.832,7.832,0,0,1,8.431,26.95a13.287,13.287,0,0,1,7.713-3.271c.058-.22.143-.524.266-.953a5.818,5.818,0,0,1-1.832-3.635,1.849,1.849,0,0,1-1.293-1.836l-.149-1.11a.525.525,0,0,1-.006-.079,1.925,1.925,0,0,1,.575-1.372,1.882,1.882,0,0,1,.155-.14,6.239,6.239,0,0,1-.088-1.043A6.113,6.113,0,0,1,19.786,7.4h.155a6.122,6.122,0,0,1,5.932,7.155,1.494,1.494,0,0,1,.157.14,1.926,1.926,0,0,1,.573,1.371l-.16,1.226a1.808,1.808,0,0,1-1.334,1.8,5.493,5.493,0,0,1-1.785,3.635c.122.428.207.733.265.952a13.3,13.3,0,0,1,7.716,3.273,8.446,8.446,0,0,1,2.518,4.975.6.6,0,0,1-.6.673ZM7.473,31.4H32.512a7.176,7.176,0,0,0-2.022-3.567,12.291,12.291,0,0,0-6.919-2.954.571.571,0,0,1-.059,0c-.026,0-.051,0-.075,0l-.364-.022a.6.6,0,0,1-.562-.543c-.037-.177-.262-.983-.466-1.687a.6.6,0,0,1,.3-.7c1-.511,1.38-1.752,1.65-3.457a.6.6,0,0,1,.593-.507.667.667,0,0,0,.659-.747l.159-1.226a.761.761,0,0,0-.227-.444.845.845,0,0,0-.234-.161.6.6,0,0,1-.328-.686,4.922,4.922,0,0,0-4.684-6.1H19.8a4.922,4.922,0,0,0-4.681,6.1.6.6,0,0,1-.327.686.815.815,0,0,0-.233.16.745.745,0,0,0-.223.49l.148,1.1a.525.525,0,0,1,.006.079c0,.345.157.747.6.747a.6.6,0,0,1,.589.485c.3,1.523.654,2.935,1.713,3.479a.6.6,0,0,1,.3.7c-.2.705-.429,1.511-.465,1.688a.6.6,0,0,1-.562.542l-.366.022a.9.9,0,0,1-.092,0h-.048A12.28,12.28,0,0,0,9.246,27.83,6.454,6.454,0,0,0,7.473,31.4Z",
    fill: "#fff"
  })))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "metrics",
    viewBox: "-10 -10 60 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M43.3,50H-3.3C-7,50-10,47-10,43.3V-3.3C-9.8-7-6.8-10-3.3-10h46.6C47-10,50-7,50-3.3v46.7 C50,47,47,50,43.3,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "33.5,32.5 37.2,21.8 36.2,8.6 50,22.6 50,44.1 49.8,45.2 49.6,45.7 49.1,46.8 48.5,47.7 47.4,48.7 45.8,49.4 43.8,50 23.5,50 5.9,33.9 21,38.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M46.8,52.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M20,3c9.4,0,17,7.6,17,17s-7.6,17-17,17S3,29.4,3,20S10.6,3,20,3 M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20 S31,0,20,0L20,0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20,3c9.4,0,17,7.6,17,17s-7.6,17-17,17S3,29.4,3,20S10.6,3,20,3 M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20 S31,0,20,0L20,0z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 22.2,
    y1: 17.8,
    x2: 29.2,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 20,
    y1: 9.7,
    x2: 20,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 30.7,
    y1: 20,
    x2: 33.8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    fill: "none",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 6.3,
    y1: 20,
    x2: 9.5,
    y2: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20,18.2c1,0,1.8,0.8,1.8,1.8S21,21.8,20,21.8S18.2,21,18.2,20S19,18.2,20,18.2 M20,16.2 c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8S22.1,16.2,20,16.2L20,16.2z"
  })))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "models",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#009EEF;}\n\t.st2{opacity:0.15;fill:#272425;enable-background:new    ;}\n\t.st3{fill:#FFFFFF;}\n    "), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,50H5.6C2.5,50,0,47.5,0,44.4V5.6C0.1,2.5,2.6,0,5.6,0h38.8C47.5,0,50,2.5,50,5.6v38.9 C50,47.5,47.5,50,44.4,50z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43.1,10.8 50,27.2 50,45.1 49.8,46 49.6,46.4 49.2,47.2 48.7,48.1 47.8,48.9 46.6,49.5 44.8,50 17.7,50 6.7,33.1 12.7,30 7.8,19.8 20.3,10.9 28.1,20.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12,39.5 7.9,32.5 12,25.5 20,25.5 24.1,32.5 20,39.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.8,26l3.8,6.5L19.8,39h-7.5l-3.8-6.5l3.8-6.5H19.8 M20.3,25h-8.7l-4.3,7.5l4.3,7.5h8.7l4.3-7.5L20.3,25 L20.3,25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 25.8,
    className: "st1",
    width: 13.2,
    height: 13.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.2,26.3v12.2H29V26.3H41.2 M42.2,25.3H28v14.2h14.2V25.3L42.2,25.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 11.3,
    className: "st1",
    width: 33.4,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.2,11.8v7H8.8v-7H41.2 M42.2,10.8H7.8v9h34.4V10.8L42.2,10.8z"
  })))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "monitoring",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-17.000000, -1154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(17.000000, 1154.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    fill: "#4F7A97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,45 L5,45 C2.239,45 0,42.761 0,40 L0,5 C0,2.239 2.239,0 5,0 L40,0 C42.761,0 45,2.239 45,5 L45,40 C45,42.761 42.761,45 40,45 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.9856734,45 C29.1209943,45 22.0675081,45 18.8252149,45 L10,31.1132075 L36.0744986,31.1132075 L36.0744986,13 L45,24.1698113 L45,39.9685535 C45,42.7469182 42.7545845,45 39.9856734,45 Z",
    id: "Shape",
    fillOpacity: 0.25,
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,12 C9.3,12 9,12.9 9,14.3 L9,20 L10,20 L10,14.3 C10,13.6 10,13 10.7,13 L17.9,13 L18.1,12 L10.7,12 Z M34.7,12 L20.6,12 L20.4,13 L34.7,13 C35.4,13 36,13.7 36,14.3 L36,29.3 C36,30 35.4,31 34.7,31 L10.7,31 C10,31 10,30 10,29.3 L10,23 L9,23 L9,29.3 C9,30.7 9.3,32 10.7,32 L34.7,32 C36.1,32 37,30.8 37,29.3 L37,14.3 C37,12.9 36.1,12 34.7,12 Z",
    id: "Shape",
    fill: "#E8E8E8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,35.7027027 C33,36.4594595 32.3870968,37 31.7741935,37 L15.2258065,37 C14.5107527,37 14,36.3513514 14,35.7027027 C14,34.9459459 14.6129032,34.4054054 15.2258065,34.4054054 L19.1075269,34.4054054 L19.1075269,33 L27.9946237,33 L27.9946237,34.4054054 L31.8763441,34.4054054 C32.4892473,34.2972973 33,34.9459459 33,35.7027027 Z",
    id: "Shape",
    fill: "#E8E8E8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "18.7782258 26 16.6612903 23.1573604 15.6532258 22.0406091 14.141129 23.5634518 9 23.5634518 9 21.8375635 13.4354839 21.8375635 15.6532258 19.7055838 17.7701613 21.8375635 20.5927419 6 24.2217742 19.8071066 26.9435484 17.2690355 29.3629032 21.8375635 34 21.8375635 34 23.5634518 28.3548387 23.5634518 26.5403226 20.1116751 23.3145161 23.0558376 20.8951613 13.715736"
  }))))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "network-hover",
    viewBox: "-5 5 35 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M10.6,39.9c0.6,0.1,1.3,0.1,1.9,0.1c0.4,0,0.7,0,1.1,0c-3.5-2.8-5.7-7.2-5.7-12c0-8.5,7-15.5,15.5-15.5 c1.3,0,2.6,0.2,3.8,0.5c-0.5-0.9-1.2-1.6-1.9-2.4c-0.6-0.1-1.2-0.1-1.9-0.1c-9.7,0-17.5,7.8-17.5,17.5C5.9,32.6,7.7,36.8,10.6,39.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#43C9F7",
    d: "M12.5,38c-0.6,0-1.2,0-1.7-0.1C2.9,37.1-3,30.4-3,22.5c0-7.6,5.5-14.1,13-15.3C10.6,7.1,11.2,7,11.9,7 c0.2,0,0.3,0,0.5,0h0.1c4.3,0,8.3,1.7,11.3,4.9c0.6,0.7,1.2,1.4,1.7,2.1c1.6,2.5,2.5,5.5,2.5,8.5c0,3.6-1.3,7.2-3.6,10 c-0.3,0.3-0.5,0.6-0.9,0.9c-2.7,2.7-6.2,4.3-10.1,4.6C13.2,38,12.9,38,12.5,38 M12.5,40c0.4,0,0.7,0,1.1,0 c4.4-0.3,8.4-2.2,11.3-5.2c0.4-0.3,0.7-0.7,1-1.1c2.6-3,4.1-7,4.1-11.2c0-3.5-1.1-6.8-2.9-9.6c-0.5-0.9-1.2-1.6-1.9-2.4 C22,7.1,17.5,5,12.4,5c-0.2,0-0.4,0-0.7,0c-0.8,0-1.5,0.1-2.2,0.2C1.3,6.6-5,13.8-5,22.5c0,9,6.8,16.5,15.6,17.4 C11.2,40,11.9,40,12.5,40L12.5,40z"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#009EEF",
    cx: 6.8,
    cy: 29.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#009EEF",
    cx: 18.5,
    cy: 12,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.8,32.5l1-1.7c-0.8-0.5-1.6-1-2.3-1.7l-1.2,1.6C18.1,31.3,18.9,31.9,19.8,32.5z M15,28.6l1.4-1.4 c-0.7-0.7-1.3-1.4-1.8-2.2L13,26.2C13.6,27,14.2,27.8,15,28.6z M11.3,23.5l1.8-1c-0.5-0.8-0.9-1.7-1.2-2.6L10,20.6 C10.3,21.7,10.8,22.6,11.3,23.5z M9.1,17.7l2-0.4c-0.2-0.9-0.4-1.9-0.5-2.8l-2,0.2C8.7,15.6,8.8,16.7,9.1,17.7z M10.5,12 c0,0,0.1-1.8,0.2-2.7l-2-0.2c-0.1,1-0.2,1.9-0.2,2.9C8.5,12,10.5,12,10.5,12z M11.2,6.8c0.2-0.6,0.4-1.2,0.6-1.8 C11,5,10.3,5.1,9.6,5.2C9.5,5.6,9.4,5.9,9.3,6.3L11.2,6.8z M24.9,34.8c-0.8-0.2-1.6-0.5-2.3-0.9l0.8-1.8c0.9,0.4,1.8,0.7,2.7,1 l-0.2,0.6L24.9,34.8z"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "network",
    viewBox: "-5 5 35 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M10.6,39.9c0.6,0.1,1.3,0.1,1.9,0.1c0.4,0,0.7,0,1.1,0c-3.5-2.8-5.7-7.2-5.7-12c0-8.5,7-15.5,15.5-15.5 c1.3,0,2.6,0.2,3.8,0.5c-0.5-0.9-1.2-1.6-1.9-2.4c-0.6-0.1-1.2-0.1-1.9-0.1c-9.7,0-17.5,7.8-17.5,17.5C5.9,32.6,7.7,36.8,10.6,39.9z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M12.5,38c-0.6,0-1.2,0-1.7-0.1C2.9,37.1-3,30.4-3,22.5c0-7.6,5.5-14.1,13-15.3C10.6,7.1,11.2,7,11.9,7 c0.2,0,0.3,0,0.5,0h0.1c4.3,0,8.3,1.7,11.3,4.9c0.6,0.7,1.2,1.4,1.7,2.1c1.6,2.5,2.5,5.5,2.5,8.5c0,3.6-1.3,7.2-3.6,10 c-0.3,0.3-0.5,0.6-0.9,0.9c-2.7,2.7-6.2,4.3-10.1,4.6C13.2,38,12.9,38,12.5,38 M12.5,40c0.4,0,0.7,0,1.1,0 c4.4-0.3,8.4-2.2,11.3-5.2c0.4-0.3,0.7-0.7,1-1.1c2.6-3,4.1-7,4.1-11.2c0-3.5-1.1-6.8-2.9-9.6c-0.5-0.9-1.2-1.6-1.9-2.4 C22,7.1,17.5,5,12.4,5c-0.2,0-0.4,0-0.7,0c-0.8,0-1.5,0.1-2.2,0.2C1.3,6.6-5,13.8-5,22.5c0,9,6.8,16.5,15.6,17.4 C11.2,40,11.9,40,12.5,40L12.5,40z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 6.8,
    cy: 29.2,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E8E8E8",
    cx: 18.5,
    cy: 12,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M19.8,32.5l1-1.7c-0.8-0.5-1.6-1-2.3-1.7l-1.2,1.6C18.1,31.3,18.9,31.9,19.8,32.5z M15,28.6l1.4-1.4 c-0.7-0.7-1.3-1.4-1.8-2.2L13,26.2C13.6,27,14.2,27.8,15,28.6z M11.3,23.5l1.8-1c-0.5-0.8-0.9-1.7-1.2-2.6L10,20.6 C10.3,21.7,10.8,22.6,11.3,23.5z M9.1,17.7l2-0.4c-0.2-0.9-0.4-1.9-0.5-2.8l-2,0.2C8.7,15.6,8.8,16.7,9.1,17.7z M10.5,12 c0,0,0.1-1.8,0.2-2.7l-2-0.2c-0.1,1-0.2,1.9-0.2,2.9C8.5,12,10.5,12,10.5,12z M11.2,6.8c0.2-0.6,0.4-1.2,0.6-1.8 C11,5,10.3,5.1,9.6,5.2C9.5,5.6,9.4,5.9,9.3,6.3L11.2,6.8z M24.9,34.8c-0.8-0.2-1.6-0.5-2.3-0.9l0.8-1.8c0.9,0.4,1.8,0.7,2.7,1 l-0.2,0.6L24.9,34.8z"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "nfvo-hover",
    viewBox: "0 0 38 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-607.000000, -62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(608.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0229811,19.6585 L31.5336171,19.6585 L2.22892808,19.6585 C0.978728033,19.6585 0,18.7361911 0,17.5542194 C0,16.3739337 0.978728033,15.4499387 2.22892808,15.4499387 C2.33787408,15.4499387 2.33787408,14.3725066 2.33787408,13.7570719 C2.33787408,10.4708195 5.16511218,7.80168792 8.6442403,7.80168792 C9.29613032,7.80168792 9.94980634,7.90454138 10.5481164,8.05966464 C11.4178984,3.43968951 15.7132285,0 20.8229747,0 C26.5863969,0 31.2621451,4.4142682 31.2621451,9.8553849 C31.2621451,10.9328171 31.5871971,12.62737 32.0229811,12.62737 C34.0893832,12.62737 35.7200012,14.1667996 35.7200012,16.1176432 C35.7200012,18.0684867 34.0893832,19.6585 32.0229811,19.6585 Z",
    id: "Fill-1",
    stroke: "#43C9F7",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(11.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5,
    points: "21.7159908 4.98666667 11.5885714 10.4327711 22.5085714 18.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1428571,9.68 L10.4,2.93333333",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5885714,11.22 L2.97142857,10.2666667",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5885714,11.22 L9.21142857,17.38",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#A1E7FF",
    fillRule: "nonzero",
    cx: 10.4742857,
    cy: 2.56666667,
    rx: 2.45142857,
    ry: 2.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#A1E7FF",
    fillRule: "nonzero",
    cx: 2.74857143,
    cy: 9.97333333,
    rx: 2.45142857,
    ry: 2.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#A1E7FF",
    fillRule: "nonzero",
    cx: 22.5085714,
    cy: 4.91333333,
    rx: 2.89714286,
    ry: 2.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 11.2914286,
    cy: 10.56,
    rx: 3.19428571,
    ry: 3.15333333
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#A1E7FF",
    fillRule: "nonzero",
    cx: 20.8,
    cy: 18.48,
    rx: 2.89714286,
    ry: 2.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#A1E7FF",
    fillRule: "nonzero",
    cx: 8.69142857,
    cy: 18.92,
    rx: 2.89714286,
    ry: 2.86
  }))))))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "nfvo",
    viewBox: "0 0 38 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-560.000000, -62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(561.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0229811,19.6585 L31.5336171,19.6585 L2.22892808,19.6585 C0.978728033,19.6585 0,18.7361911 0,17.5542194 C0,16.3739337 0.978728033,15.4499387 2.22892808,15.4499387 C2.33787408,15.4499387 2.33787408,14.3725066 2.33787408,13.7570719 C2.33787408,10.4708195 5.16511218,7.80168792 8.6442403,7.80168792 C9.29613032,7.80168792 9.94980634,7.90454138 10.5481164,8.05966464 C11.4178984,3.43968951 15.7132285,0 20.8229747,0 C26.5863969,0 31.2621451,4.4142682 31.2621451,9.8553849 C31.2621451,10.9328171 31.5871971,12.62737 32.0229811,12.62737 C34.0893832,12.62737 35.7200012,14.1667996 35.7200012,16.1176432 C35.7200012,18.0684867 34.0893832,19.6585 32.0229811,19.6585 Z",
    id: "Fill-1",
    stroke: "#C2C6CA",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(11.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5,
    points: "21.7159908 4.98666667 11.5885714 10.4327711 22.5085714 18.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1428571,9.68 L10.4,2.93333333",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5885714,11.22 L2.97142857,10.2666667",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5885714,11.22 L9.21142857,17.38",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 10.4742857,
    cy: 2.56666667,
    rx: 2.45142857,
    ry: 2.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 2.74857143,
    cy: 9.97333333,
    rx: 2.45142857,
    ry: 2.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 22.5085714,
    cy: 4.91333333,
    rx: 2.89714286,
    ry: 2.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 11.2914286,
    cy: 10.56,
    rx: 3.19428571,
    ry: 3.15333333
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 20.8,
    cy: 18.48,
    rx: 2.89714286,
    ry: 2.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#33424F",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 8.69142857,
    cy: 18.92,
    rx: 2.89714286,
    ry: 2.86
  }))))))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "orchestrate",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "25,94.3 0,50 25,5.6 75,5.6 100,50 75,94.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "78.9,32.7 18.8,51.5 42,94.3 75,94.3 95.2,58.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    points: "66.1,36.8 45.7,48.7 67.8,66.2  "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 84,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABklJREFUeNrsWu1OGzkU9ccMmZlA gaawKyTU//AMlfYl4HVKn4eXaNVnoOq/VkWbZWEp0JBM5sP2nmMmbLuluz8nKvdIbjz29a1zcr/s QSmBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgWD7oZd5TCOFhAf3NtoMQ+qO9gMCjV6/0 yclJ3Nf+/v6D+8N86ObD0cuXQd0RvBTE2iX5UfXR0ZHeurgw22zb25YoisLe3NxYPg8GA3t+fm6z LDOYMs+fP48sYo0+3N9Xr1+/XgoD6ZvQOyK3tkiise/fJ03TJG3bJm5jIy2USiGTOufSqqrYT4gS RPvbW12WpSk+ftQgXkGHPjw8XBD7KF0+kkn33tzcNDs7O/xxk0Wboq00jW3T1ILluE/0A/quTlM3 xKP6qo3HY3d1deVjGDg6Cn2FgD4tNFomyRwOh4nf3Ez9dDrw3mcNvB0bK5Rzq2ClCFqz5YixmfZ+ AJ9PwKL1da1hzbpeW1O2rhVCQfj06ZN69+5deGwWGq0Tn4bWOMvztCjLAfpZBQIT53Jvbe7aNjPG pN6Y+MMb7x0Ib2ySzI1zZWstF80wNYeOCjqazmJ9X1ZqeqET2fxkb09fXl5GN7fX1ysdmavBufUm hJFv221rzC9gZMd0jX2OcY4ylOUaru10JNRJ3Sr0Y6S2F+tEIclszgSErL1CN4e1kcwnRusNtKfw 3xHERiDmafB+E59P8DzUxmQKVguCDetRzAVnjEcocHB5D51+dzLxv71500uCSvr4FZmIkDxi+cM9 gNABUnnutF5FHNjwSj3DBElcB2kF6syVLj7VGJth7AYyJJWstta5uvG+xiPCr6Xbm65WDY+CUAKu qdVoZDVLIVpp0+SaVgoSwfQmxp95knrn0itd5U7Sbg3JNEbBohuQO8cPUuosK1kZVKurtrq8bPv6 Xr3EUJ6ARqORRrwxLI086kwknkEwJoc1DkHcE7QNkEVin8Iq6foj9jnGOcpEWazhWuqgLuqk7h+d sn46Qhfnc5yAdDafx0zPU1GwNu0sMdMh5JAbdta5CmuMbfHMOcpQlmu4ljqoizqp+7/uAn6+LA/s 7u4qtb7OYl0jc2tmGCQWq+9KpARPKRiJJIeuRcIxFucoA1mu4VrqoC7qjLp7Qm8x9PT0VOF8jprJ hhrxECYW4LpBIWvTuEgv/gmaoXNhangOnEOdGTjGhjUGn3XbMrsFN5+r06oCr+uPI4Yurt7whcM8 y0gUanjruoKcSaeGTMViPbYQSgjNQ9dfjHcyddfaToenTup+4Jrv561DeZHBkikUhUUnCW0bkxK+ /gDuO9Ask+7c3XTBkGRXGOep6AvGbtD/DMauwNw1mPyCYv/WpSmPSnWJLP/hwwffxxG0N5dHJg63 w6EbTqdwVlW3xpQ4mKPyUROUS3mMk3RxePOiDo1lk9YTEHyFUomZZ4I21UlSgv0aX6YN0InMFc7O zh5V2RTG43HA0cbTXacgDcmlBHm3tDjExUsQd4F4+ics9g/VtdjHWJyDDGW5hmupg7qok7r5fzye y5EQ9MHxsfn17dsElppOUP5kSTKE66/xfA7r3ABh68b7NdaZOF6mcbPGNCQP4WECYm9A5jVCxg0s dDKHda8htuLA0Jy9eNEeHxx4WvjjKJuQLPYR36qq8qgZXVKWTZjN5sjUUxIEoj5jY+dg4wxtDHJ/ Z2OfY3EOMpTlGq6lDuqiTupWuh9b6fWC+eDgwMA17RixvECNWdT1QBdFhgSTw1JzbI7vO1JYqO0s 1OFE1DDjg8zSIHaSzNnKSoVsVe/A5XGGd8fHx76vC2bTI6ExlpIAEkFCnEMVCYtj1k7gzsraSzDz F6yTMfMi9jHGOcpEWaz5msy+YucyWOj9RXN3+xRfyKGGvH8VwssOnD/NrPvhYcUeY/7r1x90c6xx CzL7fP2xDIR+Qypfh+D0BE9OjN3ZgU1e8FRp8jyP+yxLFgIIAFtb3o3HiAytZ8xchndJy0To/T4i sXt7GkklXprwio83R/+69gusYXkqgmxgAuqIVGoJ3s0v21+OfPfHDkhcfOkW+3sgEAnnPv4u2x85 LCOhD+7rn7uR77YblEAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAI/hd/CzAAA++GpmuG WmgAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 1 -14)"
  })), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 44.6,
    y1: 44.9,
    x2: 43.8,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 45.7,
    y1: 48.7,
    x2: 28.6,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "#FFFFFF",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    x1: 45.7,
    y1: 48.7,
    x2: 40,
    y2: 63.6
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    fill: "#FFFFFF",
    cx: 43,
    cy: 27.8,
    r: 5.8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 84,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABqdJREFUeNrsWstuE0kUrap+uR0H m3gCM0aIBbvkG5DmB1gmv0P4Hn8E4SPMGgVhAh4nTmynn1V3zi3baCIW7KZb8j1Sqbq7qtvVx+e+ ylZKIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCNoH3fp1ESnaXdS/LJeE0N+shUDg+/fv 9WQy0ersTJ3h2qdPn/zYyckJjcdjP/n09JQu3r0jtSG5NcQGbSHz4uJCHx8fG5BnptOpef36tQms DdZXV7xGw202mwWAefXqlWfxeDbT56en6vLysjXi0G0hkwkDkTpJEjMcDn+SmHU6Os1zv84sy4iO jpwzxtnp1NV17YqicLe3t84r9uKCmlarbguZ8/k8KEDkIE0D41yoiUK9WoXwm6aKIr/OqKqojCJ7 oFSttu3u7s72+30LF2HbQKpuC5lQZtjr9SKcx9xyNAzGIcye55Sbe5wJgiqo66oMw8IqVYZZVt2m aTUCuW0gNWwLmeFwGJfLZcekaacqy24cRZ26qjoUBJFzLoiMIQsoa8ta6xwsZ1EYZhjPu3jedBOo FJPapEKbCko+AMEHGvv8eTiM49hlWQriDrCgQx0EfafUwBANjNYD0rqvnOvB/LtoCQJTSBvlqhJZ QaeuKSlLenh4AL8BvX37lraB6n+HaeJDOTWCmnwAYp/JJs7KjKLoAI5xAPKG2tpnypi/rHMvFDdj XkB2I8j6T5D9DMQegdR+HIYHutvt1GkawZey2s3k5ERz/rovCtUMTo2eQ502CNhPplTXhw7KBGFH ZMxQO3es0WP+EGQOEKQOWaGgKUEf+KfwdwNZ0zZAwQHbqqrcy+XS/f3xo2pCpY34UE7aWaFsIRzN YfoJhWGKCz2kRJ5UmP0fUPJTkNXDeeQrJq0LkLvEccR0gvgaiihqa/OYqFBhWAajUaXWa4PPaCQw NROUUAHNr6/18ObGE2rDMILv6WCki5TpkH0myDxSTKwxPRCYgEjC3ALXY2JtOlfhngyMrXG25mcU eB/cz4GusezFNOBA1SlKSZDpFYpIHjhrI4TmGL6xg4agrXogsAeynmB+H+dPNB/v+o35H2zn8hcR 8zNiPEvjS0JhoM/OzvaD0J0NIiHXOSogEGSQeKL2cQH8ZgRF+lwUSmRfmdCGsA73fA7fmWhWLOep m7kh16P8LlwApGnq1cn1PzUQmExTpvHy5Uul+n2V4hiBCdzA+rk5p2mzrYSsibZbH8RRmwnyPehn f7qZi3sQl3Tckk2Jxgj98uULy1QhKrOMHDcwY8GahX+ssbASLHOBVEKVBXG/OyaqMK/iyA5p1vgy OJl3XJqi9qfdzpTeB0J3e5rIGSnfvLwLrEcFYhBXVI7+AQpcg9gVbliCwCXuuueer+F4heesQXgG dRZ8bx0EFuMuzXOaHx3RePNh+5GHokrSvA1H3W6AgxAmHBlrOXrHxLW8MSH7VhDCdl7jOquTCeSU 6Q79LZL6W1y7QWm0gBO9B5trlaY5ctqqm2V2dnlJ8KO0NyaPSEzJauV3jijPS6iSUyBW3p0nSql/ QOoPR/QdxH7D8bXaHH/nMRB5g3n3IHxdVlXe4SpUa07wHYoG4k2SvfGh25dFpmPZd7IPLGCyGSsQ AwuY9RwK/IF2DcKmOP8KIr/CpKc4v8acH/C3c5C9gLKXURw/sH9FUVAjB7Wj0Yje8W5+A4l9I5sj lx8++N327ufPKMO7GpWSTsLQ149Ga/BEFkqtTBDkYOQBLmAFAu/RL3B9oZl0KDkgukdQWytrM7iQ YoYH2cXCXl1d0fn5+f4olIMFknuC2XN0ru1gwD4yR3K5gmTvQdQNSJqhpPwO1X7DIqdgZ4oxr042 eSjzluL4Hupeu8PDfLVaVclWnU2Ze5Pbd37jgoMTRKWCslTu6VNy6zVx6gTUKknKEKWm2/jWh8C5 tQ88UKup63UYhmskqjkrM7+7q4qiqLdfkNvHDeafvnQymXg/OsrAW8KFkWJSYMe+LufqyUSogGDT zJDTUYR8IIaT0DX7zAUielIUtg1keuNruLDwO/e73SfevYfyDKdURa/H9aTp8A90qKi4COhs89Zd 4wDEP9KxmbeBzEbTpl1pzySMx2NP0PWbNzUS/qrX61VqPi8G8KsgLH+WJL5nP4uknZP/EqlRxark XzzbQmYbFPp4LUTqYvcnh41L+GV9E5SUajz27oJTo//8m4Ta8RLtg36820ePBx6Xk6QEAoFAIBAI BAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQPBb/CvAANJ30vlu1QdAAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -19 5)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    fill: "#FFFFFF",
    cx: 22.8,
    cy: 47.4,
    r: 5.8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 87,
    height: 87,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB4NJREFUeNrsWstuGzcUJTlvvSzV CZpHgxborvmGAinQbZbO78T5jX5CvM2yC39Bd/a6MAo3bRpb1mPeJHvOSGqdoJtuOm50D0DMaMgZ UWcOz70kpZRAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCD516P9N/7xX/vZF/UHXvZD7 L/rkQearV6/02dmZVkdH6un5+Qd9PfvmG69OTtTTp0/9y5cvvf6b7DtDdHDXiD0+Ptb379835+fn 5vLhQ/N1lpnA2mBQFMHNzU1QVVWQpimvmS/HY402+qc3b3iPfvHihTo9PRXlftwPKhXkGCiRfTI/ o3yFkud5AFWaKst0WpZdf8s09UlR4BbvBoOBRVuHtg5VDkr3r1+/dlsl+30nt1Mrh/9sNjOPHj0K VqtVAITGmDBJkiBXKiThURh2/W3alqS5gVItlGydc621th2NRvby8tJeX1872gWe6/skOLgrxMI8 g3vOhes0jTPvExCbomSl98MkigaubYfO2gFKBpmncRTFRdPEodadsgFdj8cqqGu1ePJEvYOC+7aJ 3smlv5LYL+CnMWCiKNVhONBBMLRKjcHcGHKdsBitRyhDFIhWpSA5tlqHOoqM8YhpRaFAshrmuYfy /cXFhYJ376VyO9W2bdsplsTaLEsw/gextSPn/UEYBAcgdQbaZki9psq5Ke6bKBCPY2aUSmgfaGNc EGgQrJok8RN48ng89ni2ev78ue9LvWFfzJJY+ig8FWKN6K9x2DSZj6IRiJqgbuqoWO8nIHWIgZ+A 1FBZ6Bn+ivMS9Wvj3AJ1Ma4FLawBavHL5dKBXIdne6RsrsvrtN4bcrtfiuCjGcBulIrwMUEZQo0T 79wMpB5iPH8GUg5wfYxrKbw1QvEgtUV9AdKWIDnDZ16ncl0AuUK2Le5pwzC0sx9/NMewhuMecuDe lMsg9uDBgy7VysIwcnGcgtiB3fjrZyYI7kGx98DZzG8UnOG2yMNdQWKD8xxqH4DgSNFvoWcovkHa UCP41SoMa1hGg5e3CZg9ZA1hj5agMSlglA/bOI7QkRSZwJABDCxMSTDa3INiDzHsSXjmqfDNNLgm uThPQLbG0SKSVWhT4KXkYdvm/G1IzYL379+3nOFxNvdfw/RpCVCWadI0iNuWthAHmyE+YtDCcboN ZDOQN+ssAsdd8TwaM9UMciCf92mkangZicNI2OXGh4eHmlNn2u4+kNtZAocrlKXHmz4w4sckhrkt rGAA0kZ6Q/QI5G2Otwrr0H6EF8DMge0zpGj07RgjIIqahpmQuZlMepsoGdUj4Ld6vemDMYj2zpgI xMQgLGGBahMwk8J7U7X9vCus1zyHNfDF4AnR1uZCnJhuylxV+mCx6MjlItDekAsv1IPBoJOdxbS2 JSHsD6xi2y8D4jr1cWagd/W3r2/rducIhoYezJz39nfRgvZKufBCD+X6NWcyyJ4gOee5+GJttwDT Fa1td3Suq/MfX9/W7c7BuIM9eIyCDwwWFuT3zhagXD/cEgO1WUwIGkT7GtGnYoFCK7BSQp2l2n7e FdZ7nmtdddkD7mVuy9LwRSDn5SQCntsRyzXfvUjFuGKFoeon+OF+NHJIYLnMVWOEc4mr0EyzjFmB xGE3uXDObNW562+N9rlmG+fW8N8cdlDAr0l2jReEcBZYeK+D5/a2ttAHufyxzBY88lyXlKWt07RB R2prbYFItEKDhWFe632MQl+1UGoJEqMdud0LcO4GpM5xXODFrKD+HPdVum2bQRhSxQ7e7t9+++3t nYpPe+GGCyncOWBAwxRVhwhQjiu4xgRc5WLA2sxmvYI66bUkqoYqS5QVaFqizHF+jeMV6q5A/pXT eu6tXWCGsY5hJavVqp5Op/bd6anvY3WsN8+lNSBV6nYSijhuMOa5EJPjbTN3ugJJf4Dc31Heguxf wcwlAz8C1qXbfH6LWPYbCH4HZb/H5zkmEUu8qNyEYUXvxUhwtB9+1z6tiv1lDRi2NssyWGRQYWiv fRQZqJUG6zWHv7U5xvSiWxVDfzFx4BSv7YKcRpq8sYQb6/0N7llhdlbY5bJW43ELuOvvv3c/HB15 tdmV2I/1XFrDs2fP1Hw+5zS4S1e5FgvifAjFQZ0WNsEMoEJlgeMaadoKxwVy4TmOc/jGHKTPwRq9 dxlYu8ZbKsdJQuU2eLb7uizd6Xff9bf01+eC+dHR0Qc7EVwwxxvnChkXcrggniL6J1BsdMvGHEht mB3QTlBfmKYpYBMlSk2s1+uWe2knJydO9bSPZnomt/NedXZmfzk4sCSlIllVtdZ1vQydm7cIVJD2 Owz7328XXmMd27AtSM3tdFryGXzWbpOyz9/W+/8WaA/cSOSGIve9Ph+PfVkytinOwtosjuuS67fI gaM4Lg09VakCBJdD2AV8tQKxFY41PrdXV1e2vLi4E7u/8r+FT9kWdtkDt2+2/kiCLMhqLx8+bEBe lT9+XE7BKVK3rvCc11jHNmzLe3gvn8FnqTvwtyb5r9iekfvP/fsf/stRIBAIBAKBQCAQCAQCgUAg EAgEAoFAIBAIBAKBQCAQCASfPv4UYACAEHWoj9RAJgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 28 -10)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    fill: "#FFFFFF",
    cx: 71.9,
    cy: 33.5,
    r: 7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 89,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABZCAYAAABVC4ivAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACFtJREFUeNrsWslu3EYQ7YXrrFos GRICG4lv0TcEcIBcfVR+x/Jv5Bf0EzoHSAAfLORmwEDGjpWRNNIsHLKXvGpy5DESBMiJ40w9oMSe 7h4O9br4uqpIIRgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwfiyIb+U6/Peh+OrV69C 38uXL0OHlJ/9C55J/i/XBVLPQOibN2+kOD0VJ5eX/3itb7791ovzc3FycuLPiPia9I0iW2/gosuz szN5cHWlzOvX+tmzZ0r/9pvudDp6MpnoLMsium60Fdo0pp4+fSpHo5H8pijEjycn4uLiYqMcaJM8 OZBLnru7u6vSNFXR11+r5d2dhieofVhRFBLEhmtG26Ptx0I4C0sHA2vevnXL5dLd3Ny44NlnZ34T vFpuEsE4KjLy2OFwqEFkDM2NyEyS6A7GqqoK1xzHsZ+D3KgsLfTakIH0Ct+1+C54F45sE4iWm0Tw eDzW+/v7epFlMZhOVLebWGNSDCYwkomoWQjRkGh8baWOoqWbzUo3HJZ5UVQ4l8W57CYQrTeJ4CdP nkT39/dpLkRWCNEFmz1hbV96P9DODcHSABtiH9aDdZW1OTw4QTum/8VHkcyNkbgDxNHRkf/w4YOA lovnz5+vdHoLSfY+bHCHV1e0sQWClVJZpXUPxBK5QyXljtB6FyuxC9J3vFJDRBADBaK9lB2vdYr+ WDinQbiSMfi21s/ncz8YDMjbPXTeX15ebqUnyzOILUUQzrloZ2cnQV8gOIb3Kq13vHP7Uut9SUfv 90HqHpENI6+mhYBMi1QoFSvyZK2lM0YgBHGJ1g6y4+bjMbq1f/HihW/Lm6P2nJjC23MJmVDYxKKJ Ay/G5CqKehbeC2L3QF4gFZ5L3ttDO1tdM60P/hTom+LjBB5Ouk1Ei6osndHaqmYTNMY4xNMu/KiU W+PJkvAaXvz48ePIWptkUuZLSISGHJDXgpBHmHWI4yFoOYAXP1p5MayPc3QxTqTTHRDB65VUyilH EZ0waFsE0qaaz53/6iurf/7Zv/j111a8uTVPpngYsayEdpIex4aiCNJY5/rw4KG3dk/UxD4C0bsN sZn/dM0GfQt8zjEvhpaHPnh0ibugcNYWYLvAOUuKtY+Pj23IHluIMlRbUkEE0++XyOQQ+8Y2ilJo Zy5JaxFFgJwdVZO759cM/btkRLwnSUEftRsbYgPsg+guSUsI/RBjH9bRS0jP20AbJEsq8lAaTL+/ U19D1MTCdPvTZtYDOeS5A7JAOkUb6McC9WnTg/f2Pc1p5lGbxiATXUhGjgVL4c0xJTH0O4iZJdU/ VoWm/70nrzCdTiXSYG3jGNuUjeGZaSDa+7whOxgIzCEhtACfGc0FaTmNS5pDVvelkJ+QwMRVFUie DAatJV6qLT2GRsp5ryerNJXY/rXTVKLABoZwTNReTRta4qlNycbKSJPXjiA3pnEs0MM8hH0RNFpj EsJsqbCQcnh3J9dLpVvjyYfEYlnKKIqCdOBWf6hfNJ/V+udQPEYCA08Nx/AZUYWoyfz0XWsVFkti 4T4jtJGo7ZKLj7AySTxubQ/9BG3gz7lwpJqDb4o8kIpw9LWgOkl9NLf5/DdDIoIIwyPt/kyAcff4 rSGZypCjoyPfmU59vFz6FMQgw1vFtxVxT0Uf0Ri4rOC5FZyVxkww+kzjCNlW49QG+RXCvzCnqhfG pWnqocmB4NUTle3w5F9+Eb1eL3iiiZCPgFyQQ+QWkIAF+udk0IFZaCs1B5ELEP1gggx96+OQCoqN l4rOR0THcajEQZNbq120kYzQP0sbn59MJp7SXrBp0qoqDSUPIAzefI85dyCtQ1U2EKbgkiQFFT6T gPvGowsQHeai/x4Lcu+wKHQOZJHLOElKt1hYkSQOcbL/8N13Xm5LWk2p7cHBgUSmFzaryPsQxoma wAieHKIHigyaDc1jzFK9gry0qVnMwPQ92hO0b9A/RnsMpb7GIt3As+9wnCEVXEy73XIHd8vVxUUr 1bjW5IJ0mR4VgWi7SJIKad/SN14Mr7wFSWMc/0TfRzKQ+AeIfjDqE9RH40p9pLnOuRt8f4KxqTJm AbclTTcWGyEiC0+/uU1VuAfJoCcYeZ5Xy05nmRkzr6yN4L4a0YF0tQcTUaS/q4LQeu2iALkzzJkI 8l4hrnHiWyIZafpCzmalSJGXvH3rbn74wf10eupF/ZRkO+rJJBn0xOL29lZSHhIjGjNpKhIHaqOI tNNJkgjoMG63JYgsfL0ZToNeg0yM3yiSCZCL47UG0dKYO0jE1JXlHJ69nM/nZgFdflYU7uL779sp OYp2IU9PTxVuY914aIJQItOUSlvbjbSmQk8vpNbO5SEDRCYXvliXNEvIQ4guyHuNtTOs2AwD8y5t inUIaJBh2vPzcydaes6nWiY5aPNF81CUSEFsW6iynOVaT+CVNxj4E0T+ATl4D4ZG2BR/Jwtt9NFY mIO59B36brVGMO4Y15YWb4onh2tYfx1gBI8+hmFTpLpEghAkKYsiQeodI5rWZeMYCcXXSGCQLVZJ lpV+PqekpETiUeEc5rhetI14LWAj3iBa6TM98MyRYvf7fV8Mhw7xbcgC9XJZIUIokbBQ7FsobGpl XbBfxMYUPk0Ll2VLg1AtqSpzPxqZd+/eucPDQ8/vXfyDR6+emKwXhujpSaim5bnMiqJ+gyjLfLpY UPkihIHrtQtaLH6D6D+QPTo6ksfv38vx3p7cv76WyBLDNSNT9Ojz6At1EMzxm0buJpP8cF1UZHv1 L292rr/RSYWftZTZb9w/s+H4dI0g3a93fgHvJjMYDAaDwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAw GAwGg/F/wF8CDABCl9UOwiKNIgAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 0 3)"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 45,
    cy: 47.2,
    r: 7.7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 87,
    height: 87,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB7RJREFUeNrsWrlyG0cUnGtPHAR4 qCxYLqukzAycKVagVKH0O5R+Qh9hpv4ApU6cgaldqhIlW0USIAHsNYf7LUCZctmBo4WN11VTuzuz Sw4aPT09sxCCwWAwGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBj/d8j/TP9CEOFupfyi64HJ /Rd9CiDz9evXcjqdSvHihTg+O/uir9Pvvgvi9FQcHx+Hk5OTIP8ke2uI1ttG7KtXr+TR0ZE6OztT 5/fvq8dZprRzOi8KPZ/PdVVVOk1TqlPfDgYS98iff/yRnpEvX74Ub9++ZeX+tR+kVJCjoETqk/oV 5SHKarXSUKWqskymZdn2t0zTMBLCi03BvX6Jcry5xhcUtkHBclvUSsN/PB6ryWSiF4uFBoxSyiRJ oldCGCI8Mqbtb2NtMFHk4qZxuLRU8IyDqi2Kv7q68qenp75rgvW2EAvz1Ifem2WaxlkICYhNUbIy hF4SRbm3tuedy1EyyDw1TRPXSkUNPkMN4vtxTMTL/f39YK0Vjx49ErCWnfbc1l+J2Afw0xhQUZRK Y3KpdQ+yHMATBjgO0dGhkrKP0jNaZw4Ea6ViAz/W3utSKZlHkYCNhFuCnz9/Hrr0YN21akFCq1gi 1mVZgvGfx871fQh7IHEPchzDc8eIXiMolq4HgUgWIoOKE3wRJkDiJNvQNAGTXSCCAZ/nuXj69Gln k5zpilkilnwUngqxRuSvMYZ6FqKo77Ueom0E0xyC0CFuzHGegkQjnBPS+wZmWkK5i+B9JvEsyFae lAuOQaonTMlzp9POJjfV5UR6fn4uDw4OdJPnkQPLIKeHhiEIG0vnDoNzX0Gl9xF6vwahD9D2ACp+ gDo6TpxS91F3D/cf4DjCh+nH1mZIDnG/39c9fD5KH5REdskWWq8djUb0/6ME/ingsbggfx2DzEOl 9RHajkDiEag5xPk+zvfQNoDKcxxTEGqgWknsQdUO19YrRemhiXCOuOaQgz1ycCfeazq0BIlFgaK4 ZeM4QkdSeGiPJjCQOcIN+7jnsFWlUkPUZWHTX9TVIHqJe6JWlSAUxwrWUUC9K9TH9NkoI08+fLBt GunAGlSXloAsq5o01RjKEJqIcZ2BoD7OhziOwnoiIyW3kxqsYZ+u6RxkjulLwPUeyB7CRvooOZ5N Df4eZWNafCA5tMvnnZnQSEmblVg7qVkiAuSCJMq3GcikYQ/LFP2wJrvf1q37S1qtN3sJDUgGjyKH raQgP8HfiGAUJifhYFV3eXkpj1F+wFNSyv+9cj8Dw1Yu131QsAQNv4yIHBCWgMAUbCQgJCE1ivVQ jzdDPgbFye017mmfk2vyDZKvLvA3yySR8+Gws1VoZ+ReXFxIRCZJ8nTrZS1lVSXulPY6BN1eQ9Jf 1Ms1PtdhYvPruNsiQ9lD+aZD8XSWcxHB1mEfQT+xNjgpPdTqJRUpEWalo6xKR+IficBtxjXdZykZ QOHu87n3lBbo2mvnQqG1KOdzUVWV2Nvb2y1yCVAuzeDtjhZmMyewOMBEVsMzK1ok0AYYCCvD2gpo ujdqTW5NbSC7QHsBdZdQboVc3KDOwhYwGIyLsFqjFVs7i0q5G+TSBjfSQhgOhyH0+z6jfArCMKwr RWR5v5S0+pLyhnLw5s1DA/Vq1AUcK9QsUK5B7E177twKBBawjwpr6gYfzF3QFuTFRfj48WPYFeXS B5WTySQg5/qkLF2dpk1CpHi/8rekkW2GQJMVPWBp0dD2NwTaSqxRtwDJM7Rf4XwO8m/whSw9qT1J apBtk17PIWoQubuzQqPVEr05oAkNw5d2sxRUq0EcDXsVaBJDRpXrL4K8loZ7hfqCFI37rqHQK7Rf ou4SbRdqTfJMWXsTrF0hMFRFltnLX37xjx8/9l2s0DpLC2QNtLENgh0iU4PhXjbWLkHQNYi+gjV8 Amm/gTwa0+dUoNL3IPa9oKP3H6gdH+D3QCSDWFKzNabAPEiebC2IvXr2zL86Oelk86arCe2zNSCS OSSHBtdVZMyycI4yF4xVOthEjfMlyMqh2CSsY5nHeQN5F57alCIVz1XTXEOti7quC8SMGpZDbyb8 8dlZOJVyd2zh1hpor3U2m8nBYNDWVXEcUvJUimBaWxxaO6BEEGgvIYQFiLwG6TMQPEP8msEO5g5W 4JtmURmzymAHURRhVZ26d+/e+Tdv3nS25djpmwgimF7H2O+/F/79e9GLojaalUrRpGWxbmhAcIVS aprspCS/XaDT10GpGyiUygLGvUB7UYHYdB3TLP62f/Lkyc6+iWgDFr0Of/fTT0KDiMFi0S4smijy cV3b0nurjamV1iVWDIWCMkXTrNodMcQ1WMOKCqIXbDupLs/PG4wC2nL0Dx8+7PwtcOe/WyBl3RJM 773o9cw4z/1Ma581jU2NaTyMFCRWWBxUwZgSsa3El1BlWVaiqcZzdRzH9ubmxpIV3Lt3L2zD6/Wt +d3CnX1eRduR9PoHMU3pyUSpT58UxbaiKNr7VlkWDu78buG2TKfTQCmEf7fwD/3ZEHx3W1LdbvT8 dW+CVnmUOLaN1G0l9++ULDZvEv42K2/r78S2mdx/078gGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwG g8FgMBgMBoPB6Ah/CDAAukI2NJ9A3rcAAAAASUVORK5CYII=",
    transform: "matrix(1 0 0 1 24 24)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "#FFFFFF",
    cx: 67.8,
    cy: 66.2,
    r: 7
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 87,
    height: 87,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABXCAYAAABxyNlsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAB8FJREFUeNrsWk1v20YU3A+SIinJ siRbgA0ULWKkh/iYP5BDrjnafyfO7/E1d+eaQwr4ICO3JG1iN3EkR7YskSJ3t/NWUuqkvfREpXoD LEgulxQ1HM57b0khGAwGg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPxf4f8Ya7POeHudspv Lt0xuf/hmhzIfPbsmez3+1IcHIj9s7NvrrX/4IETx8dif3/fPX361Mm/yV4ZovWqEXt0dCS3t7fV 2dmZOt/ZUXtJorQxOp1O9Wg00nme6ziOqU/93GxKjJG/PX9Ox8jDw0Px4sULVu7310FKBTkKSqRr Um/RfkGbTCYaqlR5ksg4y/z1ZnHsNoWwYtEw1t6i7S+2cYPcKihYropa6fFvt9tqd3dXj8djDQRK qaBWq+mJEAERHgaBv96iLF0QhiYqCoPNkhqOMVB1iWavrq7s8fGxrZpgvSrEwjz1lrWBbbfDoChq IDZGSzLn6rUwTG1Z1q0xKVoCmccYE82UCgv8hxmIb0QRES87nY4ry1Lcu3dPwFrW2nO9v5JiidgI gKkSsYmLojpk2YQnNLHcwIVuKCkbaPVA68SAYK1UFMCPtbU6U0qmYShgI25J8JMnT1yVHqyrVi1I 0GQFCFJRHoZx6Fxqw7ChiFClNiHHNjy3jdRrE4ptYbvpiGQhEqi4JoMgcLgbJFtXFA7ncUQwYNM0 FY8ePaosyAVVMUsBDL4oB4OBouu4ESLCxZAVNJQxGwZkYkwLRDYxgCwhdovrldYWWM9A/thZm0go GGOUJeXi1CDVEvrkuf1+ZcGtKuVKwunpqY7v39dxnkeqKBKhdUMo1TJKdcD+ltJ6C+RuQ7FbOKYr Sb1Sbri5PcSWSHVO4ybQ6RzUa4KyNFOlDDzYgGj7a6/nTk5OHHLm9SGXvHZvb0+B2DCPohpCewr1 NYW1RGBXWbsNuRGx2yCNyO1g2cKyCXWnID/GdgDVSsrjYA0G2yUIp+yhCLGOdM0gD7bIgyvxXlWV LRyg6qLfn6I4ADlBDFtwlAkI0cCj3oKC24JIhXJBck8ulujrYX+P+ol00NoFsW2yEAS+BvqI9Iis hnLk3YuLeTZSAVRVfos0SaLiosdZEblIpyKsx9hXx6PeJLKgSQpgPqhhu7MIbD7AYbtt0UD4JtqG nBOb4vQxrCEkcuncyBx8+bw25NKcwfn5uWy1Wp7cEBkDAhYRQoqL4aAUpFKQ1hCk5Dlx9e+2Gzi2 jjtVR1/qA5u1NSxDxLKwKAqdoKobDoeS5iXohq6NLRBQVUlUYL7cpVyVPBTEhiAtAhs1sWjor0Gx NTlfn+9DMHO0jSX1wRqQxTmvWBFFKgxDmeHco42NyqrQKsj1f/bhw4d+A+Uq5brSzlNVtUhZ1bKB bO2XyApo7919kvqtVQiCCqql0CbpeG2MhHIlgqX8qULxVEGufz5fvXrlN6Bc5+sAa6mf0lMn7kzK QKXGL6U0INL3gXBDI6FmQ/2LsWZ5PGo2V4ahg3LdHxWSG1RpC41Gw0G5DgRb5LYGd7oEmVQgzKDS nITtm3MZmgKZlqKhnO/PQHaO9RzM5zhuBu0WoLeEck2EohiPhYN63TopV9DkNkpeh2zBl6lFEBgU DIUg0lB5gagpiJuAuDFZs1ss0X8Dgn3D/rGkdVRp6L/1x+BYnG+GVs7C0Ct50Ok4mliXUq4HufRH H+API1vw5OKfl0gTiJQM+26hxBssRyDrCwZfYf1KLBrG+AZzHfptGiPEyBMtxIQIpps0m09H2u5w 6N9YrFX5S63X60lEdVUGgS6N8fO3eOyp6tIIUNrN35RZqrywRs83zZbfol0TqVgOMX6I8QNBhEv5 Bes3wpjJTOschUmBCs3sJYldqwqN3n0h13VIlUwNOtNFQeRNiBwizmn9GeufoOKPIPYC5F2AzHOk XL4p6sM+jLmEzw78MbAOVZZTsgbUwOVb3BhUaP4dWxWTN5VNOZ6cnIgsy8Tb01OZpqmcaO1dMTDG 511gwsFHS6wVUPFX4km1IPPLwhKGbq5eUizZyE2k1ARpWL4RBMVkZ6f8/eVLd3h4WElQq0y55Lso gSlboDSqbMInYZIZUqlxqfWIHnVSJS7wTwz+AAI/gKH31OS8nYPkj7CASw1rwEmuVVHcUkC8juNi MBgYUi09Ies4We4nsel1DL01oLQ1nJeoFsqF42oKSDOszdA71Vr77AGNgt01sq1r5JEjkH9TaD0G uZNYax/MLnGzdtPUB7QqX1ZWWv4uvZdeKL5vtcwMMJubpN6JnM1uUGaN4L0DKPNzAYWCwE/U5Fyt n0HqFUgfIXCNU5A7rtdzpF5FdH5eObGVK3epXvre4LLfB4/adZLEwYuXFVcZwzszKg5QVCDoZSgO plBthixjavI8g+pzuimTbrco3r0zXVRszWZzJV6vr/x3C8t5BCSzanMxeErvybLMdaFOyjbKN28s effjx48t+fiqfLcQrAi5ywrKErl9qBhLS1/T0GQ3HnWJYuCrEBJkGZMBsq9u192+fu2uQOo+SD04 OFieZyU+afphvhWj6e6zxfdiVN0dL6ou8uwjymNXiNRVJvffr+/uV47/nCdwgsFgMBgMBoPBYDAY DAaDwWAwGAwGg8FgMBgMBoPBYDAYjArwlwADAJDQdTzjUfgAAAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 -5 25)"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "#FFFFFF",
    cx: 38.9,
    cy: 67.3,
    r: 7
  }))))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "orchestration-hover",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-488.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(488.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5,
    points: "29.2330645 6.8 15.6 14.226506 30.3 25.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.2 L14,4",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,15.3 L4,14",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,15.3 L12.4,23.7",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#43C9F7",
    fillRule: "nonzero",
    cx: 14.1,
    cy: 3.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#43C9F7",
    fillRule: "nonzero",
    cx: 3.7,
    cy: 13.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#43C9F7",
    fillRule: "nonzero",
    cx: 30.3,
    cy: 6.7,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 15.2,
    cy: 14.4,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#43C9F7",
    fillRule: "nonzero",
    cx: 28,
    cy: 25.2,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#43C9F7",
    fillRule: "nonzero",
    cx: 11.7,
    cy: 25.8,
    r: 3.9
  }))))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "orchestration",
    viewBox: "0 0 35 30"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-441.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(441.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5,
    points: "29.2330645 6.8 15.6 14.226506 30.3 25.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.2 L14,4",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,15.3 L4,14",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,15.3 L12.4,23.7",
    id: "Shape",
    stroke: "#F1F1F1",
    strokeWidth: 4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 14.1,
    cy: 3.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 3.7,
    cy: 13.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 30.3,
    cy: 6.7,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 15.2,
    cy: 14.4,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 28,
    cy: 25.2,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 11.7,
    cy: 25.8,
    r: 3.9
  })))))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "planning-hover",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-293.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(293.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "APPBAR_planning",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,1 L26,26 L1,26 L1,1 L26,1 Z M27,0 L0,0 L0,27 L27,27 L27,0 Z",
    id: "Shape",
    fill: "#BABCBE",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.35,
    x: 4,
    y: 5,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18 L22,23 L17,23 L17,18 L22,18 Z M23,17 L16,17 L16,24 L23,24 L23,17 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,17.3 L15,16.7 L15.7,16 L16.4,16.7 L15.6,17.3 Z M14.3,16 L13.6,15.3 L14.3,14.6 L15,15.3 L14.3,16 Z M12.9,14.5 L12.2,13.8 L12.9,13.1 L13.6,13.8 L12.9,14.5 Z M11.5,13.1 L10.8,12.4 L11.5,11.7 L12.2,12.4 L11.5,13.1 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    stroke: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19.1 L28.6,32 L18,32 L18,19 L18,19.1 Z M15,11 L15,35 L35,35 L15,11 Z",
    id: "Shape",
    fill: "#43C9F7",
    fillRule: "nonzero"
  })))))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "planning",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-334.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(334.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "APPBAR_planning",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,1 L26,26 L1,26 L1,1 L26,1 Z M27,0 L0,0 L0,27 L27,27 L27,0 Z",
    id: "Shape",
    fill: "#BABCBE",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.35,
    x: 4,
    y: 5,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18 L22,23 L17,23 L17,18 L22,18 Z M23,17 L16,17 L16,24 L23,24 L23,17 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,17.3 L15,16.7 L15.7,16 L16.4,16.7 L15.6,17.3 Z M14.3,16 L13.6,15.3 L14.3,14.6 L15,15.3 L14.3,16 Z M12.9,14.5 L12.2,13.8 L12.9,13.1 L13.6,13.8 L12.9,14.5 Z M11.5,13.1 L10.8,12.4 L11.5,11.7 L12.2,12.4 L11.5,13.1 Z",
    id: "Shape",
    fill: "#FFFFFF",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    stroke: "#BABCBE",
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19.1 L28.6,32 L18,32 L18,19 L18,19.1 Z M15,11 L15,35 L35,35 L15,11 Z",
    id: "Shape",
    fill: "#E8E8E8",
    fillRule: "nonzero"
  })))))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "schema",
    viewBox: "0 0 45 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MCP-application-icons",
    transform: "translate(-22.000000, -3391.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(22.000000, 3391.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.96,45 L5.04,45 C2.25,45 0,42.75 0,39.96 L0,5.04 C0.18,2.25 2.43,0 5.04,0 L39.96,0 C42.75,0 45,2.25 45,5.04 L45,40.05 C45,42.75 42.75,45 39.96,45 Z",
    id: "Shape",
    fill: "#009999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#272425",
    opacity: 0.15,
    points: "36 37 36 9 45 15.48 45 40.05 44.91 41.4 44.82 41.76 44.37 42.57 44.01 43.29 43.11 44.01 41.94 44.55 40.41 45 17.46 45 9 37.8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    fill: "#B3E0E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.75757576 C0,0.790909091 0.790909091,0 1.75757576,0 L27.2424242,0 C28.2090909,0 29,0.790909091 29,1.75757576 L29,28.2090909 C29,29.1757576 28.2090909,29.9666667 27.2424242,29.9666667 L1.75757576,29.9666667 C0.790909091,29.9666667 0,29.1757576 0,28.2090909 L0,1.75757576 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 19,
    y: 11,
    width: 7,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    opacity: 0.1,
    x: 19,
    y: 19,
    width: 7,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 28,
    y: 19,
    width: 7,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    opacity: 0.3,
    x: 10,
    y: 19,
    width: 7,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    opacity: 0.3,
    x: 10,
    y: 27,
    width: 11,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 24,
    y: 27,
    width: 11,
    height: 9
  }))))))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "service-browser",
    viewBox: "0 0 70 60"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00AA3E",
    points: "17.7,59.9 0.4,29.9 17.7,0 52.3,0 69.6,29.9 52.3,59.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.1,
    fill: "#272425",
    points: "43.6,14 15.8,33.9 29.9,60.1 52.1,60.3 62.1,42.3 "
  }), /*#__PURE__*/React.createElement("polyline", {
    opacity: 0.5,
    fill: "none",
    stroke: "#F1F1F1",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: "39.2,18.4 20.1,30.7 46.4,45.3  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 40.1,
    y1: 18.7,
    x2: 40.5,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeDasharray: "4.4356,4.4356",
    x1: 41.4,
    y1: 25,
    x2: 44.8,
    y2: 40.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    x1: 45.2,
    y1: 42.3,
    x2: 45.7,
    y2: 44.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 26,
    fill: "#FFFFFF",
    width: 7.8,
    height: 7.8
  }), /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.25,
    width: 22,
    height: 22,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWJJREFUeNq0lX9LwzAQhhObzlYr bMM/VBDE7/+txKk4dDK31dpZ34z34DwzBTGBh/5Kn1zSu9S735vfc3/4y0teHX8SD/sG8XukkQOD bh+Gwcp9QiqiUhGUPIp68K7QA3wTi7QAI1CDY3AEDjmAo+gNrMEKbEAHtlpu17KgpAFjMAUTcMLB HCVL8AyewAK8crCtLEtQEcv0a0rPwQU443XNfhvK7hmEM9HGcxfMMpSc/pTSa3AJTo14ziVyjLTl THoZIJgsKPnChJFG6VVC3PB8zej1cux8dinidcU1HVMoVOzX8hhFD+xbmcxxIZEVQWWFUCmxM89G Sup1lFlaMCUqyd9xLYVW9WvNsy8fLSUWacs8XfDrN2r6Oivm7LPkOyLftSKxPwRVygWj6FhlMtgM 3JA7FspKlfdQJDYfXZE9U0gq7ZHSW0pnvPdio85W0tk3oazbZtaNPuuv6V9+pp8CDABTiJuZ9ZTX iwAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 29 7)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 39.8,
    cy: 17,
    r: 4.7
  }), /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    opacity: 0.25,
    width: 22,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAYAAAAP6L+eAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAc9JREFUeNqsldlOwzAQReMsdC9L RQsPLOL//woEpYillFLaNAljdIymxt0kIh3FiZPrseeObaLdLuM9V/v+EOoza4SrTYOYDe9i2rFq O6ESXPvPACYg6sQSIRUy7jHfWKGlR+nNYkVYi1qxmtAQmkIdcdufC3PhU5jRtu8KLe4LJ4hawa5w BF0GMghNhLHwJrwzyEKL6wTFRNVA7FQ4gx6R2+tLeBVGwpC7fZ7qyFMvYi18LlwLl0JfaPOdnf6z 0GGGBdG6iH/WO1EOSFjLQ6K8Em7gQhgIJwjW+G/BQFNm4hL5mxCdNLe+PcQGRNziuxlBuMgf+SdT zon0UrioD1jPNtF1aDdVghe8bzHLTHnd+MKRVxDOxwnESlj3xaHqTL0yLUnAkqjmKjEZP+vCKELF ERIuEPvAp9ZGL4gWROj6JyppuT9AEqi6lHXOvITkFIId8Em4F+6EB54nzGzFbv4u5tpuX5gTnRa9 RXjoFUjpV55RXrYuOMZmfazXZTY5ZTzCasHKMwFHJBRAE7EuRdOkb6mWZLxtrwiJux2uTgEc0Feq ittpd4vWJDJVnjXKPfkmy5ktx5I+RYwSrvY9QTade9GaA7WK/uEyu374LcAA+yWqXdEfl7QAAAAA SUVORK5CYII=",
    transform: "matrix(1 0 0 1 34 33)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 45.1,
    cy: 43.4,
    r: 4.7
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-hover",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-293.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(293.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    stroke: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-23",
    fill: "#5A6671",
    x: 3,
    y: 9,
    width: 21,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,27.275 C32.4,25.975 33.5,25.175 34.8,25.075 C34.9,24.175 35,23.275 34.9,22.475 C34.6,22.375 34.3,22.375 34,22.175 C32.1,21.375 31.3,19.175 32.1,17.275 C32.2,16.975 32.4,16.675 32.6,16.475 C32.1,15.775 31.5,15.175 30.9,14.675 C29.9,15.475 28.4,15.675 27.2,15.175 C25.9,14.575 25.1,13.375 25,12.075 C24.2,11.975 23.3,11.975 22.5,12.075 C22.5,12.375 22.4,12.775 22.2,13.075 C21.4,14.975 19.2,15.775 17.4,14.975 C17.1,14.875 16.8,14.675 16.5,14.475 C15.7,15.075 15.1,15.775 14.5,16.475 C15.1,17.475 15.2,18.775 14.7,19.875 C14.2,20.975 13.2,21.775 12.1,21.975 C12,22.775 12,23.575 12,24.375 C12.3,24.375 12.7,24.475 13,24.675 C14.9,25.475 15.7,27.675 14.9,29.575 C14.8,29.875 14.6,30.175 14.3,30.475 C14.8,31.075 15.3,31.675 15.9,32.175 C16.9,31.375 18.4,31.075 19.7,31.675 C21,32.275 21.8,33.475 21.9,34.775 C22.8,34.875 23.6,34.875 24.5,34.775 C24.5,34.475 24.6,34.175 24.8,33.875 C25.6,31.975 27.8,31.175 29.6,31.975 C29.9,32.075 30.1,32.275 30.4,32.475 C31,31.975 31.5,31.475 32,30.975 C31.4,29.875 31.2,28.475 31.8,27.275 Z M20.6,29.975 C17,28.375 15.4,24.175 17,20.575 C18.6,16.975 22.8,15.275 26.4,16.875 C30,18.475 31.6,22.675 30,26.275 C28.4,29.875 24.2,31.475 20.6,29.975 Z",
    id: "Shape",
    fill: "#43C9F7",
    fillRule: "nonzero"
  }))))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-critical",
    viewBox: "0 0 26 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-Critical",
    transform: "translate(0.940000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.724138)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.84375,0 L0.78125,0 C0.349777539,0 0,0.32565495 0,0.72737069 L0,22.5484914 C0,22.9502071 0.349777539,23.2758621 0.78125,23.2758621 L19.53125,23.2758621 C19.9627225,23.2758621 20.3125,22.9502071 20.3125,22.5484914 L20.3125,5.81896552 L14.84375,0 Z M19.140625,22.184806 L1.171875,22.184806 L1.171875,1.09105603 L14.0625,1.09105603 L14.0625,6.54633621 L19.140625,6.54633621 L19.140625,22.184806 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9296875,8.72844828 C2.9296875,9.02973508 3.19202065,9.27397629 3.515625,9.27397629 L16.6015625,9.27397629 C16.8108978,9.27397629 17.0043316,9.16999925 17.1089993,9.00121229 C17.213667,8.83242533 17.213667,8.62447122 17.1089993,8.45568426 C17.0043316,8.2868973 16.8108978,8.18292026 16.6015625,8.18292026 L3.515625,8.18292026 C3.36022471,8.18292026 3.21118922,8.24039537 3.10130462,8.34270172 C2.99142002,8.44500806 2.9296875,8.58376525 2.9296875,8.72844828 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,10.3650323 L10.7421875,10.3650323 C10.5328522,10.3650323 10.3394184,10.4690094 10.2347507,10.6377963 C10.130083,10.8065833 10.130083,11.0145374 10.2347507,11.1833244 C10.3394184,11.3521113 10.5328522,11.4560884 10.7421875,11.4560884 L16.6015625,11.4560884 C16.9251668,11.4560884 17.1875,11.2118471 17.1875,10.9105603 C17.1875,10.6092736 16.9251668,10.3650323 16.6015625,10.3650323 L16.6015625,10.3650323 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,12.5471444 L10.7421875,12.5471444 C10.4185832,12.5471444 10.15625,12.7913856 10.15625,13.0926724 C10.15625,13.3939592 10.4185832,13.6382004 10.7421875,13.6382004 L16.6015625,13.6382004 C16.9251668,13.6382004 17.1875,13.3939592 17.1875,13.0926724 C17.1875,12.7913856 16.9251668,12.5471444 16.6015625,12.5471444 L16.6015625,12.5471444 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,14.7292565 L3.515625,14.7292565 C3.19202065,14.7292565 2.9296875,14.9734977 2.9296875,15.2747845 C2.9296875,15.5760713 3.19202065,15.8203125 3.515625,15.8203125 L16.6015625,15.8203125 C16.9251668,15.8203125 17.1875,15.5760713 17.1875,15.2747845 C17.1875,14.9734977 16.9251668,14.7292565 16.6015625,14.7292565 L16.6015625,14.7292565 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,16.9113685 L10.7421875,16.9113685 C10.4185832,16.9113685 10.15625,17.1556097 10.15625,17.4568966 C10.15625,17.7581834 10.4185832,18.0024246 10.7421875,18.0024246 L16.6015625,18.0024246 C16.9251668,18.0024246 17.1875,17.7581834 17.1875,17.4568966 C17.1875,17.1556097 16.9251668,16.9113685 16.6015625,16.9113685 L16.6015625,16.9113685 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,19.0934806 L10.7421875,19.0934806 C10.4185832,19.0934806 10.15625,19.3377218 10.15625,19.6390086 C10.15625,19.9402954 10.4185832,20.1845366 10.7421875,20.1845366 L16.6015625,20.1845366 C16.9251668,20.1845366 17.1875,19.9402954 17.1875,19.6390086 C17.1875,19.3377218 16.9251668,19.0934806 16.6015625,19.0934806 L16.6015625,19.0934806 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(12.962963, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10.3448276 L9.11111111,10.3448276 C10.2156806,10.3448276 11.1111111,9.44939709 11.1111111,8.34482759 L11.1111111,2 C11.1111111,0.8954305 10.2156806,-4.2495073e-16 9.11111111,0 L2,0 C0.8954305,-1.91384796e-17 -3.57315355e-16,0.8954305 0,2 L0,8.34482759 C-8.67738547e-17,9.44939709 0.8954305,10.3448276 2,10.3448276 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92592593,9.48275862 L9.18518519,9.48275862 C9.73746994,9.48275862 10.1851852,9.03504337 10.1851852,8.48275862 L10.1851852,1.86206897 C10.1851852,1.30978422 9.73746994,0.862068966 9.18518519,0.862068966 L1.92592593,0.862068966 C1.37364118,0.862068966 0.925925926,1.30978422 0.925925926,1.86206897 L0.925925926,8.48275862 C0.925925926,9.03504337 1.37364118,9.48275862 1.92592593,9.48275862 Z",
    id: "Path-2",
    fill: "#E52C2C"
  })))))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-nodata",
    viewBox: "0 0 23 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-Unknown-Copy",
    transform: "translate(0.940000, 0.000000)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.03125,0 L0.84375,0 C0.377759742,0 0,0.377759742 0,0.84375 L0,26.15625 C0,26.6222403 0.377759742,27 0.84375,27 L21.09375,27 C21.5597403,27 21.9375,26.6222403 21.9375,26.15625 L21.9375,6.75 L16.03125,0 Z M20.671875,25.734375 L1.265625,25.734375 L1.265625,1.265625 L15.1875,1.265625 L15.1875,7.59375 L20.671875,7.59375 L20.671875,25.734375 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1640625,10.125 C3.1640625,10.4744927 3.44738231,10.7578125 3.796875,10.7578125 L17.9296875,10.7578125 C18.1557696,10.7578125 18.3646782,10.6371991 18.4777192,10.4414063 C18.5907603,10.2456134 18.5907603,10.0043866 18.4777192,9.80859374 C18.3646782,9.61280086 18.1557696,9.4921875 17.9296875,9.4921875 L3.796875,9.4921875 C3.62904269,9.4921875 3.46808435,9.55885863 3.34940899,9.67753399 C3.23073363,9.79620935 3.1640625,9.95716769 3.1640625,10.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,12.0234375 L11.6015625,12.0234375 C11.3754804,12.0234375 11.1665718,12.1440509 11.0535308,12.3398437 C10.9404897,12.5356366 10.9404897,12.7768634 11.0535308,12.9726563 C11.1665718,13.1684491 11.3754804,13.2890625 11.6015625,13.2890625 L17.9296875,13.2890625 C18.2791802,13.2890625 18.5625,13.0057427 18.5625,12.65625 C18.5625,12.3067573 18.2791802,12.0234375 17.9296875,12.0234375 L17.9296875,12.0234375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,14.5546875 L11.6015625,14.5546875 C11.2520698,14.5546875 10.96875,14.8380073 10.96875,15.1875 C10.96875,15.5369927 11.2520698,15.8203125 11.6015625,15.8203125 L17.9296875,15.8203125 C18.2791802,15.8203125 18.5625,15.5369927 18.5625,15.1875 C18.5625,14.8380073 18.2791802,14.5546875 17.9296875,14.5546875 L17.9296875,14.5546875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,17.0859375 L3.796875,17.0859375 C3.44738231,17.0859375 3.1640625,17.3692573 3.1640625,17.71875 C3.1640625,18.0682427 3.44738231,18.3515625 3.796875,18.3515625 L17.9296875,18.3515625 C18.2791802,18.3515625 18.5625,18.0682427 18.5625,17.71875 C18.5625,17.3692573 18.2791802,17.0859375 17.9296875,17.0859375 L17.9296875,17.0859375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,19.6171875 L11.6015625,19.6171875 C11.2520698,19.6171875 10.96875,19.9005073 10.96875,20.25 C10.96875,20.5994927 11.2520698,20.8828125 11.6015625,20.8828125 L17.9296875,20.8828125 C18.2791802,20.8828125 18.5625,20.5994927 18.5625,20.25 C18.5625,19.9005073 18.2791802,19.6171875 17.9296875,19.6171875 L17.9296875,19.6171875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,22.1484375 L11.6015625,22.1484375 C11.2520698,22.1484375 10.96875,22.4317573 10.96875,22.78125 C10.96875,23.1307427 11.2520698,23.4140625 11.6015625,23.4140625 L17.9296875,23.4140625 C18.2791802,23.4140625 18.5625,23.1307427 18.5625,22.78125 C18.5625,22.4317573 18.2791802,22.1484375 17.9296875,22.1484375 L17.9296875,22.1484375 Z",
    id: "Path"
  })))))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-ok",
    viewBox: "0 0 26 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-OK",
    transform: "translate(0.940000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.724138)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.84375,0 L0.78125,0 C0.349777539,0 0,0.32565495 0,0.72737069 L0,22.5484914 C0,22.9502071 0.349777539,23.2758621 0.78125,23.2758621 L19.53125,23.2758621 C19.9627225,23.2758621 20.3125,22.9502071 20.3125,22.5484914 L20.3125,5.81896552 L14.84375,0 Z M19.140625,22.184806 L1.171875,22.184806 L1.171875,1.09105603 L14.0625,1.09105603 L14.0625,6.54633621 L19.140625,6.54633621 L19.140625,22.184806 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9296875,8.72844828 C2.9296875,9.02973508 3.19202065,9.27397629 3.515625,9.27397629 L16.6015625,9.27397629 C16.8108978,9.27397629 17.0043316,9.16999925 17.1089993,9.00121229 C17.213667,8.83242533 17.213667,8.62447122 17.1089993,8.45568426 C17.0043316,8.2868973 16.8108978,8.18292026 16.6015625,8.18292026 L3.515625,8.18292026 C3.36022471,8.18292026 3.21118922,8.24039537 3.10130462,8.34270172 C2.99142002,8.44500806 2.9296875,8.58376525 2.9296875,8.72844828 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,10.3650323 L10.7421875,10.3650323 C10.5328522,10.3650323 10.3394184,10.4690094 10.2347507,10.6377963 C10.130083,10.8065833 10.130083,11.0145374 10.2347507,11.1833244 C10.3394184,11.3521113 10.5328522,11.4560884 10.7421875,11.4560884 L16.6015625,11.4560884 C16.9251668,11.4560884 17.1875,11.2118471 17.1875,10.9105603 C17.1875,10.6092736 16.9251668,10.3650323 16.6015625,10.3650323 L16.6015625,10.3650323 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,12.5471444 L10.7421875,12.5471444 C10.4185832,12.5471444 10.15625,12.7913856 10.15625,13.0926724 C10.15625,13.3939592 10.4185832,13.6382004 10.7421875,13.6382004 L16.6015625,13.6382004 C16.9251668,13.6382004 17.1875,13.3939592 17.1875,13.0926724 C17.1875,12.7913856 16.9251668,12.5471444 16.6015625,12.5471444 L16.6015625,12.5471444 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,14.7292565 L3.515625,14.7292565 C3.19202065,14.7292565 2.9296875,14.9734977 2.9296875,15.2747845 C2.9296875,15.5760713 3.19202065,15.8203125 3.515625,15.8203125 L16.6015625,15.8203125 C16.9251668,15.8203125 17.1875,15.5760713 17.1875,15.2747845 C17.1875,14.9734977 16.9251668,14.7292565 16.6015625,14.7292565 L16.6015625,14.7292565 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,16.9113685 L10.7421875,16.9113685 C10.4185832,16.9113685 10.15625,17.1556097 10.15625,17.4568966 C10.15625,17.7581834 10.4185832,18.0024246 10.7421875,18.0024246 L16.6015625,18.0024246 C16.9251668,18.0024246 17.1875,17.7581834 17.1875,17.4568966 C17.1875,17.1556097 16.9251668,16.9113685 16.6015625,16.9113685 L16.6015625,16.9113685 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,19.0934806 L10.7421875,19.0934806 C10.4185832,19.0934806 10.15625,19.3377218 10.15625,19.6390086 C10.15625,19.9402954 10.4185832,20.1845366 10.7421875,20.1845366 L16.6015625,20.1845366 C16.9251668,20.1845366 17.1875,19.9402954 17.1875,19.6390086 C17.1875,19.3377218 16.9251668,19.0934806 16.6015625,19.0934806 L16.6015625,19.0934806 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(12.962963, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10.3448276 L9.11111111,10.3448276 C10.2156806,10.3448276 11.1111111,9.44939709 11.1111111,8.34482759 L11.1111111,2 C11.1111111,0.8954305 10.2156806,-4.2495073e-16 9.11111111,0 L2,0 C0.8954305,-1.91384796e-17 -3.57315355e-16,0.8954305 0,2 L0,8.34482759 C-8.67738547e-17,9.44939709 0.8954305,10.3448276 2,10.3448276 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92592593,9.48275862 L9.18518519,9.48275862 C9.73746994,9.48275862 10.1851852,9.03504337 10.1851852,8.48275862 L10.1851852,1.86206897 C10.1851852,1.30978422 9.73746994,0.862068966 9.18518519,0.862068966 L1.92592593,0.862068966 C1.37364118,0.862068966 0.925925926,1.30978422 0.925925926,1.86206897 L0.925925926,8.48275862 C0.925925926,9.03504337 1.37364118,9.48275862 1.92592593,9.48275862 Z",
    id: "Path-2",
    fill: "#00AA3E"
  })))))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-pending",
    viewBox: "0 0 26 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-Pending",
    transform: "translate(0.940000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.724138)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.84375,0 L0.78125,0 C0.349777539,0 0,0.32565495 0,0.72737069 L0,22.5484914 C0,22.9502071 0.349777539,23.2758621 0.78125,23.2758621 L19.53125,23.2758621 C19.9627225,23.2758621 20.3125,22.9502071 20.3125,22.5484914 L20.3125,5.81896552 L14.84375,0 Z M19.140625,22.184806 L1.171875,22.184806 L1.171875,1.09105603 L14.0625,1.09105603 L14.0625,6.54633621 L19.140625,6.54633621 L19.140625,22.184806 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9296875,8.72844828 C2.9296875,9.02973508 3.19202065,9.27397629 3.515625,9.27397629 L16.6015625,9.27397629 C16.8108978,9.27397629 17.0043316,9.16999925 17.1089993,9.00121229 C17.213667,8.83242533 17.213667,8.62447122 17.1089993,8.45568426 C17.0043316,8.2868973 16.8108978,8.18292026 16.6015625,8.18292026 L3.515625,8.18292026 C3.36022471,8.18292026 3.21118922,8.24039537 3.10130462,8.34270172 C2.99142002,8.44500806 2.9296875,8.58376525 2.9296875,8.72844828 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,10.3650323 L10.7421875,10.3650323 C10.5328522,10.3650323 10.3394184,10.4690094 10.2347507,10.6377963 C10.130083,10.8065833 10.130083,11.0145374 10.2347507,11.1833244 C10.3394184,11.3521113 10.5328522,11.4560884 10.7421875,11.4560884 L16.6015625,11.4560884 C16.9251668,11.4560884 17.1875,11.2118471 17.1875,10.9105603 C17.1875,10.6092736 16.9251668,10.3650323 16.6015625,10.3650323 L16.6015625,10.3650323 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,12.5471444 L10.7421875,12.5471444 C10.4185832,12.5471444 10.15625,12.7913856 10.15625,13.0926724 C10.15625,13.3939592 10.4185832,13.6382004 10.7421875,13.6382004 L16.6015625,13.6382004 C16.9251668,13.6382004 17.1875,13.3939592 17.1875,13.0926724 C17.1875,12.7913856 16.9251668,12.5471444 16.6015625,12.5471444 L16.6015625,12.5471444 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,14.7292565 L3.515625,14.7292565 C3.19202065,14.7292565 2.9296875,14.9734977 2.9296875,15.2747845 C2.9296875,15.5760713 3.19202065,15.8203125 3.515625,15.8203125 L16.6015625,15.8203125 C16.9251668,15.8203125 17.1875,15.5760713 17.1875,15.2747845 C17.1875,14.9734977 16.9251668,14.7292565 16.6015625,14.7292565 L16.6015625,14.7292565 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,16.9113685 L10.7421875,16.9113685 C10.4185832,16.9113685 10.15625,17.1556097 10.15625,17.4568966 C10.15625,17.7581834 10.4185832,18.0024246 10.7421875,18.0024246 L16.6015625,18.0024246 C16.9251668,18.0024246 17.1875,17.7581834 17.1875,17.4568966 C17.1875,17.1556097 16.9251668,16.9113685 16.6015625,16.9113685 L16.6015625,16.9113685 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,19.0934806 L10.7421875,19.0934806 C10.4185832,19.0934806 10.15625,19.3377218 10.15625,19.6390086 C10.15625,19.9402954 10.4185832,20.1845366 10.7421875,20.1845366 L16.6015625,20.1845366 C16.9251668,20.1845366 17.1875,19.9402954 17.1875,19.6390086 C17.1875,19.3377218 16.9251668,19.0934806 16.6015625,19.0934806 L16.6015625,19.0934806 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(12.962963, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10.3448276 L9.11111111,10.3448276 C10.2156806,10.3448276 11.1111111,9.44939709 11.1111111,8.34482759 L11.1111111,2 C11.1111111,0.8954305 10.2156806,-4.2495073e-16 9.11111111,0 L2,0 C0.8954305,-1.91384796e-17 -3.57315355e-16,0.8954305 0,2 L0,8.34482759 C-8.67738547e-17,9.44939709 0.8954305,10.3448276 2,10.3448276 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92592593,9.48275862 L9.18518519,9.48275862 C9.73746994,9.48275862 10.1851852,9.03504337 10.1851852,8.48275862 L10.1851852,1.86206897 C10.1851852,1.30978422 9.73746994,0.862068966 9.18518519,0.862068966 L1.92592593,0.862068966 C1.37364118,0.862068966 0.925925926,1.30978422 0.925925926,1.86206897 L0.925925926,8.48275862 C0.925925926,9.03504337 1.37364118,9.48275862 1.92592593,9.48275862 Z",
    id: "Path-2",
    fill: "#7D85B2"
  })))))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-unknown",
    viewBox: "0 0 26 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-Unknown",
    transform: "translate(0.940000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.724138)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.84375,0 L0.78125,0 C0.349777539,0 0,0.32565495 0,0.72737069 L0,22.5484914 C0,22.9502071 0.349777539,23.2758621 0.78125,23.2758621 L19.53125,23.2758621 C19.9627225,23.2758621 20.3125,22.9502071 20.3125,22.5484914 L20.3125,5.81896552 L14.84375,0 Z M19.140625,22.184806 L1.171875,22.184806 L1.171875,1.09105603 L14.0625,1.09105603 L14.0625,6.54633621 L19.140625,6.54633621 L19.140625,22.184806 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9296875,8.72844828 C2.9296875,9.02973508 3.19202065,9.27397629 3.515625,9.27397629 L16.6015625,9.27397629 C16.8108978,9.27397629 17.0043316,9.16999925 17.1089993,9.00121229 C17.213667,8.83242533 17.213667,8.62447122 17.1089993,8.45568426 C17.0043316,8.2868973 16.8108978,8.18292026 16.6015625,8.18292026 L3.515625,8.18292026 C3.36022471,8.18292026 3.21118922,8.24039537 3.10130462,8.34270172 C2.99142002,8.44500806 2.9296875,8.58376525 2.9296875,8.72844828 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,10.3650323 L10.7421875,10.3650323 C10.5328522,10.3650323 10.3394184,10.4690094 10.2347507,10.6377963 C10.130083,10.8065833 10.130083,11.0145374 10.2347507,11.1833244 C10.3394184,11.3521113 10.5328522,11.4560884 10.7421875,11.4560884 L16.6015625,11.4560884 C16.9251668,11.4560884 17.1875,11.2118471 17.1875,10.9105603 C17.1875,10.6092736 16.9251668,10.3650323 16.6015625,10.3650323 L16.6015625,10.3650323 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,12.5471444 L10.7421875,12.5471444 C10.4185832,12.5471444 10.15625,12.7913856 10.15625,13.0926724 C10.15625,13.3939592 10.4185832,13.6382004 10.7421875,13.6382004 L16.6015625,13.6382004 C16.9251668,13.6382004 17.1875,13.3939592 17.1875,13.0926724 C17.1875,12.7913856 16.9251668,12.5471444 16.6015625,12.5471444 L16.6015625,12.5471444 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,14.7292565 L3.515625,14.7292565 C3.19202065,14.7292565 2.9296875,14.9734977 2.9296875,15.2747845 C2.9296875,15.5760713 3.19202065,15.8203125 3.515625,15.8203125 L16.6015625,15.8203125 C16.9251668,15.8203125 17.1875,15.5760713 17.1875,15.2747845 C17.1875,14.9734977 16.9251668,14.7292565 16.6015625,14.7292565 L16.6015625,14.7292565 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,16.9113685 L10.7421875,16.9113685 C10.4185832,16.9113685 10.15625,17.1556097 10.15625,17.4568966 C10.15625,17.7581834 10.4185832,18.0024246 10.7421875,18.0024246 L16.6015625,18.0024246 C16.9251668,18.0024246 17.1875,17.7581834 17.1875,17.4568966 C17.1875,17.1556097 16.9251668,16.9113685 16.6015625,16.9113685 L16.6015625,16.9113685 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,19.0934806 L10.7421875,19.0934806 C10.4185832,19.0934806 10.15625,19.3377218 10.15625,19.6390086 C10.15625,19.9402954 10.4185832,20.1845366 10.7421875,20.1845366 L16.6015625,20.1845366 C16.9251668,20.1845366 17.1875,19.9402954 17.1875,19.6390086 C17.1875,19.3377218 16.9251668,19.0934806 16.6015625,19.0934806 L16.6015625,19.0934806 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(12.962963, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10.3448276 L9.11111111,10.3448276 C10.2156806,10.3448276 11.1111111,9.44939709 11.1111111,8.34482759 L11.1111111,2 C11.1111111,0.8954305 10.2156806,-4.2495073e-16 9.11111111,0 L2,0 C0.8954305,-1.91384796e-17 -3.57315355e-16,0.8954305 0,2 L0,8.34482759 C-8.67738547e-17,9.44939709 0.8954305,10.3448276 2,10.3448276 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92592593,9.48275862 L9.18518519,9.48275862 C9.73746994,9.48275862 10.1851852,9.03504337 10.1851852,8.48275862 L10.1851852,1.86206897 C10.1851852,1.30978422 9.73746994,0.862068966 9.18518519,0.862068966 L1.92592593,0.862068966 C1.37364118,0.862068966 0.925925926,1.30978422 0.925925926,1.86206897 L0.925925926,8.48275862 C0.925925926,9.03504337 1.37364118,9.48275862 1.92592593,9.48275862 Z",
    id: "Path-2",
    fill: "#BABCBE"
  })))))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-unreachable",
    viewBox: "0 0 27 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-NotRechable",
    transform: "translate(0.940000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 2.000000)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.03125,0 L0.84375,0 C0.377759742,0 0,0.377759742 0,0.84375 L0,26.15625 C0,26.6222403 0.377759742,27 0.84375,27 L21.09375,27 C21.5597403,27 21.9375,26.6222403 21.9375,26.15625 L21.9375,6.75 L16.03125,0 Z M20.671875,25.734375 L1.265625,25.734375 L1.265625,1.265625 L15.1875,1.265625 L15.1875,7.59375 L20.671875,7.59375 L20.671875,25.734375 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1640625,10.125 C3.1640625,10.4744927 3.44738231,10.7578125 3.796875,10.7578125 L17.9296875,10.7578125 C18.1557696,10.7578125 18.3646782,10.6371991 18.4777192,10.4414063 C18.5907603,10.2456134 18.5907603,10.0043866 18.4777192,9.80859374 C18.3646782,9.61280086 18.1557696,9.4921875 17.9296875,9.4921875 L3.796875,9.4921875 C3.62904269,9.4921875 3.46808435,9.55885863 3.34940899,9.67753399 C3.23073363,9.79620935 3.1640625,9.95716769 3.1640625,10.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,12.0234375 L11.6015625,12.0234375 C11.3754804,12.0234375 11.1665718,12.1440509 11.0535308,12.3398437 C10.9404897,12.5356366 10.9404897,12.7768634 11.0535308,12.9726563 C11.1665718,13.1684491 11.3754804,13.2890625 11.6015625,13.2890625 L17.9296875,13.2890625 C18.2791802,13.2890625 18.5625,13.0057427 18.5625,12.65625 C18.5625,12.3067573 18.2791802,12.0234375 17.9296875,12.0234375 L17.9296875,12.0234375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,14.5546875 L11.6015625,14.5546875 C11.2520698,14.5546875 10.96875,14.8380073 10.96875,15.1875 C10.96875,15.5369927 11.2520698,15.8203125 11.6015625,15.8203125 L17.9296875,15.8203125 C18.2791802,15.8203125 18.5625,15.5369927 18.5625,15.1875 C18.5625,14.8380073 18.2791802,14.5546875 17.9296875,14.5546875 L17.9296875,14.5546875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,17.0859375 L3.796875,17.0859375 C3.44738231,17.0859375 3.1640625,17.3692573 3.1640625,17.71875 C3.1640625,18.0682427 3.44738231,18.3515625 3.796875,18.3515625 L17.9296875,18.3515625 C18.2791802,18.3515625 18.5625,18.0682427 18.5625,17.71875 C18.5625,17.3692573 18.2791802,17.0859375 17.9296875,17.0859375 L17.9296875,17.0859375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,19.6171875 L11.6015625,19.6171875 C11.2520698,19.6171875 10.96875,19.9005073 10.96875,20.25 C10.96875,20.5994927 11.2520698,20.8828125 11.6015625,20.8828125 L17.9296875,20.8828125 C18.2791802,20.8828125 18.5625,20.5994927 18.5625,20.25 C18.5625,19.9005073 18.2791802,19.6171875 17.9296875,19.6171875 L17.9296875,19.6171875 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9296875,22.1484375 L11.6015625,22.1484375 C11.2520698,22.1484375 10.96875,22.4317573 10.96875,22.78125 C10.96875,23.1307427 11.2520698,23.4140625 11.6015625,23.4140625 L17.9296875,23.4140625 C18.2791802,23.4140625 18.5625,23.1307427 18.5625,22.78125 C18.5625,22.4317573 18.2791802,22.1484375 17.9296875,22.1484375 L17.9296875,22.1484375 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(14.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,12 L10,12 C11.1045695,12 12,11.1045695 12,10 L12,2 C12,0.8954305 11.1045695,-2.02906125e-16 10,0 L2,0 C0.8954305,2.02906125e-16 -1.3527075e-16,0.8954305 0,2 L0,10 C1.3527075e-16,11.1045695 0.8954305,12 2,12 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,11 L10,11 C10.5522847,11 11,10.5522847 11,10 L11,2 C11,1.44771525 10.5522847,1 10,1 L2,1 C1.44771525,1 1,1.44771525 1,2 L1,10 C1,10.5522847 1.44771525,11 2,11 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E52C2C",
    points: "10.0609184 2.72735622 9.33356216 2 6.06045919 5.27218459 2.78735622 2 2.06 2.72735622 5.33310297 5.99954081 2.06 9.27264378 2.78735622 10 6.06045919 6.72689703 9.33356216 10 10.0609184 9.27264378 6.78781541 5.99954081"
  })))))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "system-service-warning",
    viewBox: "0 0 26 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-services-Warning",
    transform: "translate(0.940000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.724138)",
    fill: "#E2E2E2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.84375,0 L0.78125,0 C0.349777539,0 0,0.32565495 0,0.72737069 L0,22.5484914 C0,22.9502071 0.349777539,23.2758621 0.78125,23.2758621 L19.53125,23.2758621 C19.9627225,23.2758621 20.3125,22.9502071 20.3125,22.5484914 L20.3125,5.81896552 L14.84375,0 Z M19.140625,22.184806 L1.171875,22.184806 L1.171875,1.09105603 L14.0625,1.09105603 L14.0625,6.54633621 L19.140625,6.54633621 L19.140625,22.184806 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9296875,8.72844828 C2.9296875,9.02973508 3.19202065,9.27397629 3.515625,9.27397629 L16.6015625,9.27397629 C16.8108978,9.27397629 17.0043316,9.16999925 17.1089993,9.00121229 C17.213667,8.83242533 17.213667,8.62447122 17.1089993,8.45568426 C17.0043316,8.2868973 16.8108978,8.18292026 16.6015625,8.18292026 L3.515625,8.18292026 C3.36022471,8.18292026 3.21118922,8.24039537 3.10130462,8.34270172 C2.99142002,8.44500806 2.9296875,8.58376525 2.9296875,8.72844828 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,10.3650323 L10.7421875,10.3650323 C10.5328522,10.3650323 10.3394184,10.4690094 10.2347507,10.6377963 C10.130083,10.8065833 10.130083,11.0145374 10.2347507,11.1833244 C10.3394184,11.3521113 10.5328522,11.4560884 10.7421875,11.4560884 L16.6015625,11.4560884 C16.9251668,11.4560884 17.1875,11.2118471 17.1875,10.9105603 C17.1875,10.6092736 16.9251668,10.3650323 16.6015625,10.3650323 L16.6015625,10.3650323 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,12.5471444 L10.7421875,12.5471444 C10.4185832,12.5471444 10.15625,12.7913856 10.15625,13.0926724 C10.15625,13.3939592 10.4185832,13.6382004 10.7421875,13.6382004 L16.6015625,13.6382004 C16.9251668,13.6382004 17.1875,13.3939592 17.1875,13.0926724 C17.1875,12.7913856 16.9251668,12.5471444 16.6015625,12.5471444 L16.6015625,12.5471444 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,14.7292565 L3.515625,14.7292565 C3.19202065,14.7292565 2.9296875,14.9734977 2.9296875,15.2747845 C2.9296875,15.5760713 3.19202065,15.8203125 3.515625,15.8203125 L16.6015625,15.8203125 C16.9251668,15.8203125 17.1875,15.5760713 17.1875,15.2747845 C17.1875,14.9734977 16.9251668,14.7292565 16.6015625,14.7292565 L16.6015625,14.7292565 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,16.9113685 L10.7421875,16.9113685 C10.4185832,16.9113685 10.15625,17.1556097 10.15625,17.4568966 C10.15625,17.7581834 10.4185832,18.0024246 10.7421875,18.0024246 L16.6015625,18.0024246 C16.9251668,18.0024246 17.1875,17.7581834 17.1875,17.4568966 C17.1875,17.1556097 16.9251668,16.9113685 16.6015625,16.9113685 L16.6015625,16.9113685 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6015625,19.0934806 L10.7421875,19.0934806 C10.4185832,19.0934806 10.15625,19.3377218 10.15625,19.6390086 C10.15625,19.9402954 10.4185832,20.1845366 10.7421875,20.1845366 L16.6015625,20.1845366 C16.9251668,20.1845366 17.1875,19.9402954 17.1875,19.6390086 C17.1875,19.3377218 16.9251668,19.0934806 16.6015625,19.0934806 L16.6015625,19.0934806 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(12.962963, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10.3448276 L9.11111111,10.3448276 C10.2156806,10.3448276 11.1111111,9.44939709 11.1111111,8.34482759 L11.1111111,2 C11.1111111,0.8954305 10.2156806,-4.2495073e-16 9.11111111,0 L2,0 C0.8954305,-1.91384796e-17 -3.57315355e-16,0.8954305 0,2 L0,8.34482759 C-8.67738547e-17,9.44939709 0.8954305,10.3448276 2,10.3448276 Z",
    id: "Path-2",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92592593,9.48275862 L9.18518519,9.48275862 C9.73746994,9.48275862 10.1851852,9.03504337 10.1851852,8.48275862 L10.1851852,1.86206897 C10.1851852,1.30978422 9.73746994,0.862068966 9.18518519,0.862068966 L1.92592593,0.862068966 C1.37364118,0.862068966 0.925925926,1.30978422 0.925925926,1.86206897 L0.925925926,8.48275862 C0.925925926,9.03504337 1.37364118,9.48275862 1.92592593,9.48275862 Z",
    id: "Path-2",
    fill: "#FED200"
  })))))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "system",
    viewBox: "0 0 35 35"
  }, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "appbar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-334.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(334.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    stroke: "#BABCBE",
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-23",
    fill: "#5A6671",
    x: 3,
    y: 9,
    width: 21,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,27.275 C32.4,25.975 33.5,25.175 34.8,25.075 C34.9,24.175 35,23.275 34.9,22.475 C34.6,22.375 34.3,22.375 34,22.175 C32.1,21.375 31.3,19.175 32.1,17.275 C32.2,16.975 32.4,16.675 32.6,16.475 C32.1,15.775 31.5,15.175 30.9,14.675 C29.9,15.475 28.4,15.675 27.2,15.175 C25.9,14.575 25.1,13.375 25,12.075 C24.2,11.975 23.3,11.975 22.5,12.075 C22.5,12.375 22.4,12.775 22.2,13.075 C21.4,14.975 19.2,15.775 17.4,14.975 C17.1,14.875 16.8,14.675 16.5,14.475 C15.7,15.075 15.1,15.775 14.5,16.475 C15.1,17.475 15.2,18.775 14.7,19.875 C14.2,20.975 13.2,21.775 12.1,21.975 C12,22.775 12,23.575 12,24.375 C12.3,24.375 12.7,24.475 13,24.675 C14.9,25.475 15.7,27.675 14.9,29.575 C14.8,29.875 14.6,30.175 14.3,30.475 C14.8,31.075 15.3,31.675 15.9,32.175 C16.9,31.375 18.4,31.075 19.7,31.675 C21,32.275 21.8,33.475 21.9,34.775 C22.8,34.875 23.6,34.875 24.5,34.775 C24.5,34.475 24.6,34.175 24.8,33.875 C25.6,31.975 27.8,31.175 29.6,31.975 C29.9,32.075 30.1,32.275 30.4,32.475 C31,31.975 31.5,31.475 32,30.975 C31.4,29.875 31.2,28.475 31.8,27.275 Z M20.6,29.975 C17,28.375 15.4,24.175 17,20.575 C18.6,16.975 22.8,15.275 26.4,16.875 C30,18.475 31.6,22.675 30,26.275 C28.4,29.875 24.2,31.475 20.6,29.975 Z",
    id: "Shape",
    fill: "#E8E8E8",
    fillRule: "nonzero"
  }))))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "topology",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009EEF",
    d: "M55,60H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h50c2.8,0,5,2.2,5,5v50C60,57.8,57.8,60,55,60z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "10,18 10,38 23,46 23,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "38,18 38,39 50,46 50,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.25,
    fill: "#FFFFFF",
    points: "37,18 37,39 24,46 24,24  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 35.1,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 26,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30.4,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30.1,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 37,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 35,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 37,
    fill: "#FFFFFF",
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 27.6,
    transform: "matrix(0.5978 0.8016 -0.8016 0.5978 29.6551 -2.8385)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 31.6,
    transform: "matrix(0.948 0.3183 -0.3183 0.948 12.1999 -4.2819)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 33.8,
    transform: "matrix(0.26 0.9656 -0.9656 0.26 52.4599 6.7993)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 30.8,
    transform: "matrix(0.6808 0.7325 -0.7325 0.6808 34.006 -9.4806)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 33.8,
    transform: "matrix(0.7258 0.6879 -0.6879 0.7258 32.6047 -13.2272)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 6.8,
    height: 1
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    x1: 35.4,
    y1: 36.6,
    x2: 40.5,
    y2: 31.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 34.8,
    transform: "matrix(0.6343 0.7731 -0.7731 0.6343 43.0651 -20.5179)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 8.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 27.7,
    transform: "matrix(0.2201 0.9755 -0.9755 0.2201 58.4711 -16.6737)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 7.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.6,
    y: 23.6,
    transform: "matrix(0.5529 0.8333 -0.8333 0.5529 37.972 -19.4299)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 25.8,
    transform: "matrix(0.7206 0.6933 -0.6933 0.7206 29.5731 -14.5623)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 27.8,
    transform: "matrix(0.8991 0.4377 -0.4377 0.8991 14.6553 -7.0654)",
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 17.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 25,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 1,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    points: "50,24 60,36 60,60 24.1,60 10,38 24,46 38,38 50,46 "
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-accounts",
    viewBox: "-25 -5 50 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M19.4,45h-38.8c-3.1,0-5.6-2.5-5.6-5.6V0.6c0-3.1,2.5-5.6,5.6-5.6h38.8C22.5-5,25-2.5,25,0.6v38.9 C24.9,42.5,22.4,45,19.4,45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.15,
    fill: "#272425",
    enableBackground: "new    ",
    points: "3.6,4.8 24.9,22.2 24.9,40.1 24.7,41 24.5,41.4 24.1,42.3 23.6,43.1 22.8,43.9 21.5,44.5 19.7,45 -6.1,45 -17.7,33.6 0.2,33.3 1,28.4 3.9,23.7 2.7,21.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#637582",
    d: "M-0.8,3.9L-0.8,3.9c-3.8,0-6.8,3.1-6.8,6.8c0,0.6,0.1,1.1,0.2,1.6c-0.2,0.1-0.3,0.2-0.5,0.4 c-0.3,0.3-0.5,0.7-0.5,1.2l0.2,1.4c0,0.9,0.6,1.7,1.5,1.7h0.1c0.3,1.9,0.8,4,2.4,4.8c0,0-0.6,2.1-0.6,2.2c-0.9,0.1-0.3,0-0.4,0 c-5.2,0.2-9.2,3.8-9.2,3.8c-1.6,1.5-2.3,3.7-2.5,5.7c-1.7,0,33.8,0,32.2,0c-0.2-1.9-0.9-4.2-2.5-5.7c0,0-4-3.7-9.2-3.8 c-0.1,0,0.5,0-0.4,0c0-0.1-0.6-2.2-0.6-2.2C4.2,21,4.7,18.9,5,17h0.1c0.9,0,1.5-0.7,1.5-1.7l0.2-1.4c0-0.5-0.2-0.9-0.5-1.2 c-0.1-0.1-0.3-0.3-0.5-0.3c0-0.6,0.1-1.1,0.1-1.7C5.9,7,2.9,3.9-0.8,3.9L-0.8,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABCBE",
    d: "M15.3,34H-17v-0.5l-0.4-0.1c0.3-2.6,1.2-4.6,2.7-6c0.2-0.2,4.1-3.8,9.5-4l0,0c0.1-0.2,0.2-0.7,0.4-1.4 c-1.4-1-1.9-2.8-2.2-4.6c-1-0.2-1.6-1-1.6-2.1l-0.2-1.4c0-0.6,0.2-1.2,0.6-1.6c0.1,0,0.2-0.1,0.3-0.2C-8,11.6-8,11.2-8,10.7 c0-4,3.2-7.2,7.2-7.3l0,0h0.1c4,0,7.2,3.3,7.2,7.3c0,0.5,0,0.9-0.1,1.4c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.4,0.6,0.9,0.6,1.5L7,15.3 c0,1.1-0.7,1.9-1.6,2c-0.3,1.9-0.9,3.6-2.3,4.6c0.2,0.8,0.4,1.2,0.4,1.5l0,0c5.4,0.2,9.4,3.8,9.5,4c1.5,1.3,2.4,3.4,2.7,6 l-0.4,0.1V34z M-16.4,33h31.1c-0.3-2.1-1.1-3.8-2.3-4.9c0,0-3.7-3.4-8.6-3.7H3.6H3.5l-1-0.1l0.1-0.4c-0.1-0.2-0.3-1.2-0.6-2.1 l-0.1-0.3l0.4-0.2c1.5-0.8,1.9-2.7,2.2-4.5l0.1-0.4h0.3c0.8,0,1.1-0.6,1.1-1.2l0.2-1.5c0-0.2-0.1-0.5-0.4-0.8 c-0.1-0.1-0.2-0.2-0.4-0.2L5,12.5l0.1-0.4c0.1-0.5,0.2-1,0.2-1.5c0-3.5-2.8-6.3-6.2-6.3h-0.1l0,0h0c-3.4,0-6.2,2.9-6.2,6.3 c0,0.5,0.1,1,0.2,1.5l0.1,0.4l-0.4,0.3c-0.1,0-0.2,0.1-0.3,0.2c-0.3,0.2-0.4,0.5-0.4,0.9l0.2,1.4c0,0.7,0.3,1.2,1,1.2h0.4 l0.1,0.4c0.3,1.8,0.7,3.7,2.2,4.5l0.4,0.2L-3.7,22c-0.3,0.7-0.6,1.7-0.6,2l0.1,0.4l-1,0.1h-0.1h-0.3c-4.8,0.3-8.5,3.7-8.5,3.7 C-15.3,29.3-16,30.9-16.4,33z"
  })))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 35 31.4"
  }, /*#__PURE__*/React.createElement("title", null, "aArtboard 1"), /*#__PURE__*/React.createElement("path", {
    d: "M34,31.4H1a.684.684,0,0,1-.7-.7h0v-.1a10.415,10.415,0,0,1,2.8-6.2,16.327,16.327,0,0,1,9.6-4.1l.3-1.2c-1.5-1.1-2-3-2.3-4.5a2.253,2.253,0,0,1-1.6-2.3l-.2-1.4v-.1a2.837,2.837,0,0,1,.7-1.7l.2-.2a5.7,5.7,0,0,1-.1-1.3A7.556,7.556,0,0,1,17.1,0h.3a7.709,7.709,0,0,1,7.5,7.6,5.7,5.7,0,0,1-.1,1.3l.2.2a2.193,2.193,0,0,1,.7,1.7l-.2,1.5a2.341,2.341,0,0,1-1.7,2.2A6.687,6.687,0,0,1,21.6,19a2.663,2.663,0,0,1,.3,1.2,16.327,16.327,0,0,1,9.6,4.1,10.526,10.526,0,0,1,3.1,6.2C34.8,30.9,34.5,31.3,34,31.4ZM1.8,29.8H33.1a9.552,9.552,0,0,0-2.5-4.5A15.2,15.2,0,0,0,22,21.6h-.7a.684.684,0,0,1-.7-.7h0L20,18.8a.807.807,0,0,1,.4-.9c1.2-.6,1.7-2.2,2.1-4.3a.858.858,0,0,1,.7-.6.789.789,0,0,0,.8-.8h0v-.1l.2-1.5a.864.864,0,0,0-.3-.6c-.1-.1-.2-.2-.3-.2a.807.807,0,0,1-.4-.9,6.123,6.123,0,0,0-4.4-7.4h0a6.753,6.753,0,0,0-1.4-.2h-.2a6.147,6.147,0,0,0-6,6.3h0a5.853,5.853,0,0,0,.2,1.3.807.807,0,0,1-.4.9c-.1,0-.2.1-.3.2a.864.864,0,0,0-.3.6l.2,1.4v.1c0,.4.2.9.7.9.4,0,.7.2.7.6.4,1.9.8,3.7,2.1,4.3a.807.807,0,0,1,.4.9c-.3.9-.5,1.9-.6,2.1a.52.52,0,0,1-.2.4.55.55,0,0,1-.5.3h-.7a15.872,15.872,0,0,0-8.3,3.8A7.7,7.7,0,0,0,1.8,29.8Z",
    fill: "#e2e2e2"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "watchlist",
    viewBox: "0 0 30 28"
  }, /*#__PURE__*/React.createElement("title", null, "cArtboard 1"), /*#__PURE__*/React.createElement("path", {
    d: "M29,0H1A1,1,0,0,0,0,1V20a1,1,0,0,0,1,1H5v7l9-7H29a1,1,0,0,0,1-1V1A1,1,0,0,0,29,0Zm-.5,19.5H13.43l-.43.379L6.5,24.66V19.5h-5V1.5h27Z",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 1.5,
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13a.6.6,0,0,0,.562-.6L16.5,5.756A1.652,1.652,0,0,0,15,4a1.8,1.8,0,0,0-1.5,1.933l.937,6.463a.566.566,0,0,0,.527.6Z",
    fill: "#e2e2e2"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "notification",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBar);
export default __webpack_public_path__ + "static/media/app-bar.svg";
export { ForwardRef as ReactComponent };